(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('core-js/es6/math'), require('preact-compat/legacy'), require('classnames'), require('lodash'), require('d3-scale'), require('d3-shape'), require('raf'), require('preact'), require('reduce-css-calc')) :
	typeof define === 'function' && define.amd ? define(['core-js/es6/math', 'preact-compat/legacy', 'classnames', 'lodash', 'd3-scale', 'd3-shape', 'raf', 'preact', 'reduce-css-calc'], factory) :
	(global.precharts = factory(global.coreJs_es6_math,global.preactCompat,global.classnames,global.lodash,global.d3Scales,global.d3Shape,global.raf,global.preact,global.reduceCSSCalc));
}(this, (function (coreJs_es6_math,React,classNames,_,d3Scales,d3Shape,raf,preact,reduceCSSCalc) {

var React__default = 'default' in React ? React['default'] : React;
classNames = 'default' in classNames ? classNames['default'] : classNames;
var ___default = 'default' in _ ? _['default'] : _;
var raf__default = 'default' in raf ? raf['default'] : raf;
reduceCSSCalc = 'default' in reduceCSSCalc ? reduceCSSCalc['default'] : reduceCSSCalc;

/* eslint no-proto: 0 */
var testObject = {};

if (!(Object.setPrototypeOf || testObject.__proto__)) {
  (function () {
    var nativeGetPrototypeOf = Object.getPrototypeOf;

    Object.getPrototypeOf = function (object) {
      if (object.__proto__) {
        return object.__proto__;
      }

      return nativeGetPrototypeOf.call(Object, object);
    };
  })();
}



var compat = Object.freeze({
	default: React__default
});

var isPercent = function isPercent(value) {
  return ___default.isString(value) && value.indexOf('%') === value.length - 1;
};

var isNumber = function isNumber(value) {
  return ___default.isNumber(value) && !___default.isNaN(value);
};

var isNumOrStr = function isNumOrStr(value) {
  return isNumber(value) || ___default.isString(value);
};

var idCounter = 0;
var uniqueId = function uniqueId(prefix) {
  var id = ++idCounter;

  return '' + (prefix || '') + id;
};
/**
 * Get percent value of a total value
 * @param {Number|String} percent A percent
 * @param {Number} totalValue     Total value
 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
 * @param {Boolean} validate      If set to be true, the result will be validated
 * @return {Number} value
 */
var getPercentValue = function getPercentValue(percent, totalValue) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!isNumber(percent) && !___default.isString(percent)) {
    return defaultValue;
  }

  var value = void 0;

  if (isPercent(percent)) {
    var index = percent.indexOf('%');
    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
  } else {
    value = +percent;
  }

  if (isNaN(value)) {
    value = defaultValue;
  }

  if (validate && value > totalValue) {
    value = totalValue;
  }

  return value;
};

var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([\d]+)$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([\d]+)$/;

var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
  if (!___default.isArray(specifiedDomain)) {
    return dataDomain;
  }

  var domain = [];

  if (isNumber(specifiedDomain[0])) {
    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];

    domain[0] = dataDomain[0] - value;
  } else {
    domain[0] = dataDomain[0];
  }

  if (isNumber(specifiedDomain[1])) {
    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];

    domain[1] = dataDomain[1] + _value;
  } else {
    domain[1] = dataDomain[1];
  }

  return domain;
};

var validateCoordinateInRange = function validateCoordinateInRange(coordinate, scale) {
  if (!scale) {
    return false;
  }

  var range = scale.range();
  var first = range[0];
  var last = range[range.length - 1];
  var isValidate = first <= last ? coordinate >= first && coordinate <= last : coordinate >= last && coordinate <= first;

  return isValidate;
};

/**
 * Calculate the size between two category
 * @param  {Object} axis  The options of axis
 * @param  {Array}  ticks The ticks of axis
 * @return {Number} Size
 */
var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
  if (axis && axis.type === 'category' && axis.scale && axis.scale.bandwidth) {
    return axis.scale.bandwidth();
  }

  if (axis && axis.type === 'number' && ticks) {
    var orderedTicks = ___default.sortBy(ticks, function (o) {
      return o.coordinate;
    });
    var bandSize = Infinity;

    for (var i = 1, len = orderedTicks.length; i < len; i++) {
      var cur = orderedTicks[i];
      var prev = orderedTicks[i - 1];

      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
    }

    return bandSize === Infinity ? 0 : bandSize;
  }

  return 0;
};

var getAnyElementOfObject = function getAnyElementOfObject(obj) {
  if (!obj) {
    return null;
  }

  var keys = Object.keys(obj);

  if (keys && keys.length) {
    return obj[keys[0]];
  }

  return null;
};

var hasDuplicate = function hasDuplicate(ary) {
  if (!___default.isArray(ary)) {
    return false;
  }

  var len = ary.length;
  var cache = {};

  for (var i = 0; i < len; i++) {
    if (!cache[ary[i]]) {
      cache[ary[i]] = true;
    } else {
      return true;
    }
  }

  return false;
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} parentHandler  Handler function specified in parent component
 * @param  {Function} childHandler   Handler function specified in child component
 * @return {Function}                The combined handler
 */
var combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
  var customizedHandler = void 0;

  if (___default.isFunction(childHandler)) {
    customizedHandler = childHandler;
  } else if (___default.isFunction(parentHandler)) {
    customizedHandler = parentHandler;
  }

  if (___default.isFunction(defaultHandler) || customizedHandler) {
    return function (arg1, arg2, arg3, arg4) {
      if (___default.isFunction(defaultHandler)) {
        defaultHandler(arg1, arg2, arg3, arg4);
      }

      if (___default.isFunction(customizedHandler)) {
        customizedHandler(arg1, arg2, arg3, arg4);
      }
    };
  }

  return null;
};
/**
 * Parse the scale function of axis
 * @param  {String}   options.scale The specified scale type
 * @param  {String}   options.type  The type of axis
 * @param  {String}   chartType     The displayName of chart
 * @return {Function}               The scale funcion
 */
var parseScale = function parseScale(_ref, chartType) {
  var scale = _ref.scale,
      type = _ref.type;

  if (scale === 'auto') {
    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
      return d3Scales.scalePoint();
    } else if (type === 'category') {
      return d3Scales.scaleBand();
    }

    return d3Scales.scaleLinear();
  } else if (___default.isString(scale)) {
    var name = 'scale' + scale.slice(0, 1).toUpperCase() + scale.slice(1);

    return (d3Scales[name] || d3Scales.scalePoint)();
  }

  return ___default.isFunction(scale) ? scale : d3Scales.scalePoint();
};

var getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
  if (___default.isNil(obj) || ___default.isNil(dataKey)) {
    return defaultValue;
  }

  if (isNumOrStr(dataKey)) {
    return ___default.get(obj, dataKey, defaultValue);
  }

  if (___default.isFunction(dataKey)) {
    return dataKey(obj);
  }

  return defaultValue;
};

var findPositionOfBar = function findPositionOfBar(barPosition, child) {
  if (!barPosition) {
    return null;
  }

  for (var i = 0, len = barPosition.length; i < len; i++) {
    if (barPosition[i].item === child) {
      return barPosition[i].position;
    }
  }

  return null;
};

var truncateByDomain = function truncateByDomain(value, domain) {
  if (!domain || domain.length !== 2 || !isNumber(domain[0]) || !isNumber(domain[1])) {
    return value;
  }

  var min = Math.min(domain[0], domain[1]);
  var max = Math.max(domain[0], domain[1]);

  var result = [value[0], value[1]];
  if (!isNumber(value[0]) || value[0] < min) {
    result[0] = min;
  }

  if (!isNumber(value[1]) || value[1] > max) {
    result[1] = max;
  }

  if (result[0] > max) {
    result[0] = max;
  }

  if (result[1] < min) {
    result[1] = min;
  }

  return result;
};

function shallowEqual(a, b) {
  /* eslint-disable no-restricted-syntax */
  for (var key in a) {
    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
      return false;
    }
  }
  for (var _key in b) {
    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
      return false;
    }
  }
  return true;
}

function shouldComponentUpdate(props, state) {
  return !shallowEqual(props, this.props) || !shallowEqual(state, this.state);
}

function pureRenderDecorator$1(component) {
  // eslint-disable-next-line no-param-reassign
  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
}

var PRESENTATION_ATTRIBUTES = {
  alignmentBaseline: React.PropTypes.string,
  angle: React.PropTypes.number,
  baselineShift: React.PropTypes.string,
  clip: React.PropTypes.string,
  clipPath: React.PropTypes.string,
  clipRule: React.PropTypes.string,
  color: React.PropTypes.string,
  colorInterpolation: React.PropTypes.string,
  colorInterpolationFilters: React.PropTypes.string,
  colorProfile: React.PropTypes.string,
  colorRendering: React.PropTypes.string,
  cursor: React.PropTypes.string,
  direction: React.PropTypes.oneOf(['ltr', 'rtl', 'inherit']),
  display: React.PropTypes.string,
  dominantBaseline: React.PropTypes.string,
  enableBackground: React.PropTypes.string,
  fill: React.PropTypes.string,
  fillOpacity: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
  fillRule: React.PropTypes.oneOf(['nonzero', 'evenodd', 'inherit']),
  filter: React.PropTypes.string,
  floodColor: React.PropTypes.string,
  floodOpacity: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
  font: React.PropTypes.string,
  fontFamily: React.PropTypes.string,
  fontSize: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  fontSizeAdjust: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  fontStretch: React.PropTypes.oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
  fontStyle: React.PropTypes.oneOf(['normal', 'italic', 'oblique', 'inherit']),
  fontVariant: React.PropTypes.oneOf(['normal', 'small-caps', 'inherit']),
  fontWeight: React.PropTypes.oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
  glyphOrientationHorizontal: React.PropTypes.string,
  glyphOrientationVertical: React.PropTypes.string,
  imageRendering: React.PropTypes.oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
  kerning: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  letterSpacing: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  lightingColor: React.PropTypes.string,
  markerEnd: React.PropTypes.string,
  markerMid: React.PropTypes.string,
  markerStart: React.PropTypes.string,
  mask: React.PropTypes.string,
  opacity: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  overflow: React.PropTypes.oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
  pointerEvents: React.PropTypes.oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
  shapeRendering: React.PropTypes.oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
  stopColor: React.PropTypes.string,
  stopOpacity: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  stroke: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  strokeDasharray: React.PropTypes.string,
  strokeDashoffset: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  strokeLinecap: React.PropTypes.oneOf(['butt', 'round', 'square', 'inherit']),
  strokeLinejoin: React.PropTypes.oneOf(['miter', 'round', 'bevel', 'inherit']),
  strokeMiterlimit: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  strokeOpacity: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  strokeWidth: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  textAnchor: React.PropTypes.oneOf(['start', 'middle', 'end', 'inherit']),
  textDecoration: React.PropTypes.oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
  textRendering: React.PropTypes.oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
  unicodeBidi: React.PropTypes.oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
  visibility: React.PropTypes.oneOf(['visible', 'hidden', 'collapse', 'inherit']),
  wordSpacing: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  writingMode: React.PropTypes.oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
  transform: React.PropTypes.string,
  style: React.PropTypes.object,

  width: React.PropTypes.number,
  height: React.PropTypes.number,
  dx: React.PropTypes.number,
  dy: React.PropTypes.number,
  x: React.PropTypes.number,
  y: React.PropTypes.number,
  r: React.PropTypes.number
};

var EVENT_ATTRIBUTES = {
  onClick: React.PropTypes.func,
  onMouseDown: React.PropTypes.func,
  onMouseUp: React.PropTypes.func,
  onMouseOver: React.PropTypes.func,
  onMouseMove: React.PropTypes.func,
  onMouseOut: React.PropTypes.func,
  onMouseEnter: React.PropTypes.func,
  onMouseLeave: React.PropTypes.func
};
/**
 * Get the display name of a component
 * @param  {Object} Comp Specified Component
 * @return {String}      Display name of Component
 */
var getDisplayName = function getDisplayName(Comp) {
  if (!Comp) {
    return '';
  }
  if (typeof Comp === 'string') {
    return Comp;
  }
  return Comp.displayName || Comp.name || 'Component';
};

/*
 * Find and return all matched children by type. `type` can be a React element class or
 * string
 */
var findAllByType = function findAllByType(children, type) {
  var result = [];
  var types = [];

  if (___default.isArray(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }

  React__default.Children.forEach(children, function (child) {
    var childType = child && child.type && (child.type.displayName || child.type.name);
    if (types.indexOf(childType) !== -1) {
      result.push(child);
    }
  });

  return result;
};
/*
 * Return the first matched child by type, return null otherwise.
 * `type` can be a React element class or string.
 */
var findChildByType = function findChildByType(children, type) {
  var result = findAllByType(children, type);

  return result && result[0];
};

/*
 * Create a new array of children excluding the ones matched the type
 */


/**
 * get all the presentation attribute of svg element
 * @param  {Object} el A react element or the props of a react element
 * @return {Object}    attributes or null
 */
var getPresentationAttributes = function getPresentationAttributes(el) {
  if (!el || ___default.isFunction(el)) {
    return null;
  }

  var props = React__default.isValidElement(el) ? el.props : el;

  if (!___default.isObject(props)) {
    return null;
  }

  var out = null;
  // eslint-disable-next-line no-restricted-syntax
  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
      if (!out) out = {};
      out[i] = props[i];
    }
  }
  return out;
};

/**
 * get all the event attribute of svg element
 * @param  {Object} el A react element or the props of a react element
 * @return {Object}    attributes or null
 */
var filterEventAttributes = function filterEventAttributes(el) {
  if (!el || ___default.isFunction(el)) {
    return null;
  }

  var props = React__default.isValidElement(el) ? el.props : el;

  if (!___default.isObject(props)) {
    return null;
  }

  var out = null;
  // eslint-disable-next-line no-restricted-syntax
  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
      if (!out) out = {};
      out[i] = props[i];
    }
  }
  return out;
};

var getEventHandler = function getEventHandler(originalHandler, data, index) {
  return function (e) {
    originalHandler(data, index, e);

    return null;
  };
};

var filterEventsOfChild = function filterEventsOfChild(props, data, index) {
  if (!___default.isObject(props)) {
    return null;
  }

  var out = null;
  // eslint-disable-next-line no-restricted-syntax
  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && ___default.isFunction(props[i])) {
      if (!out) out = {};
      out[i] = getEventHandler(props[i], data, index);
    }
  }
  return out;
};

/**
 * validate the width and height props of a chart element
 * @param  {Object} el A chart element
 * @return {Boolean}   true If the props width and height are number, and greater than 0
 */
var validateWidthHeight = function validateWidthHeight(el) {
  if (!el || !el.props) {
    return false;
  }
  var _el$props = el.props,
      width = _el$props.width,
      height = _el$props.height;


  if (!isNumber(width) || width <= 0 || !isNumber(height) || height <= 0) {
    return false;
  }

  return true;
};

var isSsr = function isSsr() {
  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};

var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
/**
 * Filter all the svg elements of children
 * @param  {Array} children The children of a react element
 * @return {Array}          All the svg elements
 */
var filterSvgElements = function filterSvgElements(children) {
  var svgElements = [];

  React__default.Children.forEach(children, function (entry) {
    if (entry && entry.type && ___default.isString(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
      svgElements.push(entry);
    }
  });

  return svgElements;
};

var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
  if (___default.isNil(nextChild) && ___default.isNil(prevChild)) {
    return true;
  } else if (!___default.isNil(nextChild) && !___default.isNil(prevChild)) {
    return shallowEqual(nextChild.props, prevChild.props);
  }

  return false;
};
/**
 * Wether props of children changed
 * @param  {Object} nextChildren The latest children
 * @param  {Object} prevChildren The prev children
 * @return {Boolean}             equal or not
 */
var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
  if (nextChildren === prevChildren) {
    return true;
  }

  if (React.Children.count(nextChildren) !== React.Children.count(prevChildren)) {
    return false;
  }

  var count = React.Children.count(nextChildren);

  if (count === 0) {
    return true;
  }
  if (count === 1) {
    return isSingleChildEqual(nextChildren, prevChildren);
  }

  for (var i = 0; i < count; i++) {
    var nextChild = nextChildren[i];
    var prevChild = prevChildren[i];

    if (!isSingleChildEqual(nextChild, prevChild)) {
      return false;
    }
  }

  return true;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/**
 * @fileOverview Surface
 */
var propTypes = {
  width: React.PropTypes.number.isRequired,
  height: React.PropTypes.number.isRequired,
  viewBox: React.PropTypes.shape({
    x: React.PropTypes.number,
    y: React.PropTypes.number,
    width: React.PropTypes.number,
    height: React.PropTypes.number
  }),
  className: React.PropTypes.string,
  style: React.PropTypes.object,
  children: React.PropTypes.oneOfType([React.PropTypes.arrayOf(React.PropTypes.node), React.PropTypes.node])
};
function Surface(props) {
  var children = props.children,
      width = props.width,
      height = props.height,
      viewBox = props.viewBox,
      className = props.className,
      style = props.style,
      others = objectWithoutProperties(props, ['children', 'width', 'height', 'viewBox', 'className', 'style']);

  var svgView = viewBox || { width: width, height: height, x: 0, y: 0 };
  var layerClass = classNames('recharts-surface', className);
  var attrs = getPresentationAttributes(others);

  return React__default.createElement(
    'svg',
    _extends({}, attrs, {
      className: layerClass,
      width: width,
      height: height,
      style: style,
      viewBox: svgView.x + ' ' + svgView.y + ' ' + svgView.width + ' ' + svgView.height,
      version: '1.1'
    }),
    children
  );
}

/**
 * @fileOverview Layer
 */
var propTypes$1 = {
  className: React.PropTypes.string,
  children: React.PropTypes.oneOfType([React.PropTypes.arrayOf(React.PropTypes.node), React.PropTypes.node])
};

function Layer(props) {
  var children = props.children,
      className = props.className,
      others = objectWithoutProperties(props, ['children', 'className']);

  var layerClass = classNames('recharts-layer', className);

  return React__default.createElement(
    'g',
    _extends({ className: layerClass }, others),
    children
  );
}

var _class$2;

/**
 * @fileOverview Curve
 */
var SYMBOL_FACTORIES = {
  symbolCircle: d3Shape.symbolCircle, symbolCross: d3Shape.symbolCross, symbolDiamond: d3Shape.symbolDiamond,
  symbolSquare: d3Shape.symbolSquare, symbolStar: d3Shape.symbolStar, symbolTriangle: d3Shape.symbolTriangle, symbolWye: d3Shape.symbolWye
};
var RADIAN = Math.PI / 180;

var getSymbolFactory = function getSymbolFactory(type) {
  var name = 'symbol' + type.slice(0, 1).toUpperCase() + type.slice(1);

  return SYMBOL_FACTORIES[name] || d3Shape.symbolCircle;
};

var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
  if (sizeType === 'area') {
    return size;
  }

  switch (type) {
    case 'cross':
      return 5 * size * size / 9;
    case 'diamond':
      return 0.5 * size * size / Math.sqrt(3);
    case 'square':
      return size * size;
    case 'star':
      {
        var angle = 18 * RADIAN;

        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
      }
    case 'triangle':
      return Math.sqrt(3) * size * size / 4;
    case 'wye':
      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
    default:
      return Math.PI * size * size / 4;
  }
};

var Symbols = pureRenderDecorator$1(_class$2 = function (_Component) {
  inherits(Symbols, _Component);

  function Symbols() {
    classCallCheck(this, Symbols);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * Calculate the path of curve
   * @return {String} path
   */
  Symbols.prototype.getPath = function getPath() {
    var _props = this.props,
        size = _props.size,
        sizeType = _props.sizeType,
        type = _props.type;

    var symbolFactory = getSymbolFactory(type);
    var symbol$$1 = d3Shape.symbol().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));

    return symbol$$1();
  };

  Symbols.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        cx = _props2.cx,
        cy = _props2.cy,
        size = _props2.size;


    if (cx === +cx && cy === +cy && size === +size) {

      return React__default.createElement('path', _extends({}, getPresentationAttributes(this.props), filterEventAttributes(this.props), {
        className: classNames('recharts-symbols', className),
        transform: 'translate(' + cx + ', ' + cy + ')',
        d: this.getPath()
      }));
    }

    return null;
  };

  return Symbols;
}(React.Component)) || _class$2;

Symbols.displayName = 'Symbols';
Symbols.defaultProps = {
  type: 'circle',
  size: 64,
  sizeType: 'area'
};

var _class$1;

/**
 * @fileOverview Default Legend Content
 */
var SIZE = 32;

var DefaultLegendContent = pureRenderDecorator$1(_class$1 = function (_Component) {
  inherits(DefaultLegendContent, _Component);

  function DefaultLegendContent() {
    classCallCheck(this, DefaultLegendContent);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * Render the path of icon
   * @param {Object} data Data of each legend item
   * @return {String} Path element
   */
  DefaultLegendContent.prototype.renderIcon = function renderIcon(data) {
    var color = data.color;

    var halfSize = SIZE / 2;
    var sixthSize = SIZE / 6;
    var thirdSize = SIZE / 3;

    if (data.type === 'line') {
      return React__default.createElement('path', {
        strokeWidth: 4,
        fill: 'none',
        stroke: color,
        d: 'M0,' + halfSize + 'h' + thirdSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + 2 * thirdSize + ',' + halfSize + '\n            H' + SIZE + 'M' + 2 * thirdSize + ',' + halfSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + thirdSize + ',' + halfSize,
        className: 'recharts-legend-icon'
      });
    } else if (data.type === 'rect') {
      return React__default.createElement('path', {
        stroke: 'none',
        fill: color,
        d: 'M0,' + SIZE / 8 + 'h' + SIZE + 'v' + SIZE * 3 / 4 + 'h' + -SIZE + 'z',
        className: 'recharts-legend-icon'
      });
    }

    return React__default.createElement(Symbols, {
      fill: color,
      cx: halfSize,
      cy: halfSize,
      size: SIZE,
      sizeType: 'diameter',
      type: data.type
    });
  };

  /**
   * Draw items of legend
   * @return {ReactElement} Items
   */


  DefaultLegendContent.prototype.renderItems = function renderItems() {
    var _this2 = this;

    var _props = this.props,
        payload = _props.payload,
        iconSize = _props.iconSize,
        layout = _props.layout,
        formatter = _props.formatter;

    var viewBox = { x: 0, y: 0, width: SIZE, height: SIZE };
    var itemStyle = {
      display: layout === 'horizontal' ? 'inline-block' : 'block',
      marginRight: 10
    };
    var svgStyle = { display: 'inline-block', verticalAlign: 'middle', marginRight: 4 };

    return payload.map(function (entry, i) {
      var finalFormatter = entry.formatter || formatter;

      return React__default.createElement(
        'li',
        _extends({
          className: 'recharts-legend-item legend-item-' + i,
          style: itemStyle,
          key: 'legend-item-' + i
        }, filterEventsOfChild(_this2.props, entry, i)),
        React__default.createElement(
          Surface,
          { width: iconSize, height: iconSize, viewBox: viewBox, style: svgStyle },
          _this2.renderIcon(entry, iconSize)
        ),
        React__default.createElement(
          'span',
          { className: 'recharts-legend-item-text' },
          finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value
        )
      );
    });
  };

  DefaultLegendContent.prototype.render = function render() {
    var _props2 = this.props,
        payload = _props2.payload,
        layout = _props2.layout,
        align = _props2.align;


    if (!payload || !payload.length) {
      return null;
    }

    var finalStyle = {
      padding: 0,
      margin: 0,
      textAlign: layout === 'horizontal' ? align : 'left'
    };

    return React__default.createElement(
      'ul',
      { className: 'recharts-default-legend', style: finalStyle },
      this.renderItems()
    );
  };

  return DefaultLegendContent;
}(React.Component)) || _class$1;

DefaultLegendContent.displayName = 'Legend';
DefaultLegendContent.defaultProps = {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'middle'
};

var _class;

/**
 * @fileOverview Legend
 */
var renderContent = function renderContent(content, props) {
  if (React__default.isValidElement(content)) {
    return React__default.cloneElement(content, props);
  } else if (___default.isFunction(content)) {
    return content(props);
  }

  return React__default.createElement(DefaultLegendContent, props);
};

var EPS = 1;

var Legend = pureRenderDecorator$1(_class = function (_Component) {
  inherits(Legend, _Component);

  function Legend() {
    var _temp, _this, _ret;

    classCallCheck(this, Legend);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      boxWidth: -1,
      boxHeight: -1
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Legend.getWithHeight = function getWithHeight(item, chartWidth) {
    var layout = item.props.layout;


    if (layout === 'vertical' && isNumber(item.props.height)) {
      return {
        height: item.props.height
      };
    } else if (layout === 'horizontal') {
      return {
        width: item.props.width || chartWidth
      };
    }

    return null;
  };

  Legend.prototype.componentDidMount = function componentDidMount() {
    this.updateBBox();
  };

  Legend.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateBBox();
  };

  Legend.prototype.getBBox = function getBBox() {
    var _state = this.state,
        boxWidth = _state.boxWidth,
        boxHeight = _state.boxHeight;


    if (boxWidth >= 0 && boxHeight >= 0) {
      return { width: boxWidth, height: boxHeight };
    }

    return null;
  };

  Legend.prototype.getDefaultPosition = function getDefaultPosition(style) {
    var _props = this.props,
        layout = _props.layout,
        align = _props.align,
        verticalAlign = _props.verticalAlign,
        margin = _props.margin,
        chartWidth = _props.chartWidth,
        chartHeight = _props.chartHeight;

    var hPos = void 0,
        vPos = void 0;

    if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
      if (align === 'center' && layout === 'vertical') {
        var box = this.getBBox() || { width: 0 };
        hPos = { left: ((chartWidth || 0) - box.width) / 2 };
      } else {
        hPos = align === 'right' ? { right: margin && margin.right || 0 } : { left: margin && margin.left || 0 };
      }
    }

    if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
      if (verticalAlign === 'middle') {
        var _box = this.getBBox() || { height: 0 };
        vPos = { top: ((chartHeight || 0) - _box.height) / 2 };
      } else {
        vPos = verticalAlign === 'bottom' ? { bottom: margin && margin.bottom || 0 } : { top: margin && margin.top || 0 };
      }
    }

    return _extends({}, hPos, vPos);
  };

  Legend.prototype.updateBBox = function updateBBox() {
    var _this2 = this;

    var _state2 = this.state,
        boxWidth = _state2.boxWidth,
        boxHeight = _state2.boxHeight;
    var onBBoxUpdate = this.props.onBBoxUpdate;


    if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
      (function () {
        var box = _this2.wrapperNode.getBoundingClientRect();

        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
          _this2.setState({
            boxWidth: box.width,
            boxHeight: box.height
          }, function () {
            if (onBBoxUpdate) {
              onBBoxUpdate(box);
            }
          });
        }
      })();
    } else if (boxWidth !== -1 || boxHeight !== -1) {
      this.setState({
        boxWidth: -1,
        boxHeight: -1
      }, function () {
        if (onBBoxUpdate) {
          onBBoxUpdate(null);
        }
      });
    }
  };

  Legend.prototype.render = function render() {
    var _this3 = this;

    var _props2 = this.props,
        content = _props2.content,
        width = _props2.width,
        height = _props2.height,
        wrapperStyle = _props2.wrapperStyle;

    var outerStyle = _extends({
      position: 'absolute',
      width: width || 'auto',
      height: height || 'auto'
    }, this.getDefaultPosition(wrapperStyle), wrapperStyle);

    return React__default.createElement(
      'div',
      {
        className: 'recharts-legend-wrapper',
        style: outerStyle,
        ref: function ref(node) {
          _this3.wrapperNode = node;
        }
      },
      renderContent(content, this.props)
    );
  };

  return Legend;
}(React.Component)) || _class;

Legend.displayName = 'Legend';
Legend.defaultProps = {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom'
};

function setRafTimeout(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var currTime = -1;

  var shouldUpdate = function shouldUpdate(now) {
    if (currTime < 0) {
      currTime = now;
    }

    if (now - currTime > timeout) {
      callback(now);
      currTime = -1;
    } else {
      raf__default(shouldUpdate);
    }
  };

  raf__default(shouldUpdate);
}

function createAnimateManager() {
  var currStyle = {};
  var handleChange = function handleChange() {
    return null;
  };
  var shouldStop = false;

  var setStyle = function setStyle(_style) {
    if (shouldStop) {
      return;
    }

    if (Array.isArray(_style)) {
      if (!_style.length) {
        return;
      }

      var styles = _style;
      var curr = styles[0],
          restStyles = styles.slice(1);


      if (typeof curr === 'number') {
        setRafTimeout(setStyle.bind(null, restStyles), curr);

        return;
      }

      setStyle(curr);
      setRafTimeout(setStyle.bind(null, restStyles));
      return;
    }

    if ((typeof _style === 'undefined' ? 'undefined' : _typeof(_style)) === 'object') {
      currStyle = _style;
      handleChange(currStyle);
    }

    if (typeof _style === 'function') {
      _style();
    }
  };

  return {
    stop: function stop() {
      shouldStop = true;
    },
    start: function start(style) {
      shouldStop = false;
      setStyle(style);
    },
    subscribe: function subscribe(_handleChange) {
      handleChange = _handleChange;

      return function () {
        handleChange = function handleChange() {
          return null;
        };
      };
    }
  };
}

function shallowEqual$1(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    var keyA = keysA[i];

    if (objA[keyA] === objB[keyA]) {
      continue;
    }

    // special diff with Array or Object
    if (___default.isArray(objA[keyA])) {
      if (!___default.isArray(objB[keyA]) || objA[keyA].length !== objB[keyA].length) {
        return false;
      } else if (!___default.isEqual(objA[keyA], objB[keyA])) {
        return false;
      }
    } else if (___default.isPlainObject(objA[keyA])) {
      if (!___default.isPlainObject(objB[keyA]) || !___default.isEqual(objA[keyA], objB[keyA])) {
        return false;
      }
    } else if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual$1(instance.props, nextProps) || !shallowEqual$1(instance.state, nextState);
}

function shouldComponentUpdate$1(nextProps, nextState) {
  return shallowCompare(this, nextProps, nextState);
}
/* eslint-disable no-param-reassign */
function pureRenderDecorator$2(component) {
  component.prototype.shouldComponentUpdate = shouldComponentUpdate$1;
}

/* eslint no-console: 0 */
var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];

var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
  return _.intersection(Object.keys(preObj), Object.keys(nextObj));
};

var identity = function identity(param) {
  return param;
};

/*
 * @description: convert camel case to dash case
 * string => string
 */
var getDashCase = function getDashCase(name) {
  return name.replace(/([A-Z])/g, function (v) {
    return '-' + v.toLowerCase();
  });
};

/*
 * @description: add compatible style prefix
 * (string, string) => object
 */
var generatePrefixStyle = function generatePrefixStyle(name, value) {
  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
    var _ref;

    return _ref = {}, _ref[name] = value, _ref;
  }

  var isTransition = name === 'transition';
  var camelName = name.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  var styleVal = value;

  return PREFIX_LIST.reduce(function (result, property, i) {
    var _babelHelpers$extends;

    if (isTransition) {
      styleVal = value.replace(/(transform|transform-origin)/gim, IN_LINE_PREFIX_LIST[i] + '$1');
    }

    return _extends({}, result, (_babelHelpers$extends = {}, _babelHelpers$extends[property + camelName] = styleVal, _babelHelpers$extends));
  }, {});
};



/*
 * @description: log the value of a varible
 * string => any => any
 */


/*
 * @description: log name, args, return value of a function
 * function => function
 */


/*
 * @description: map object on every element in this object.
 * (function, object) => object
 */
var mapObject = function mapObject(fn, obj) {
  return Object.keys(obj).reduce(function (res, key) {
    var _babelHelpers$extends2;

    return _extends({}, res, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[key] = fn(key, obj[key]), _babelHelpers$extends2));
  }, {});
};

/*
 * @description: add compatible prefix to style
 * object => object
 */
var translateStyle = function translateStyle(style) {
  return Object.keys(style).reduce(function (res, key) {
    return _extends({}, res, generatePrefixStyle(key, res[key]));
  }, style);
};



var getTransitionVal = function getTransitionVal(props, duration, easing) {
  return props.map(function (prop) {
    return getDashCase(prop) + ' ' + duration + 'ms ' + easing;
  }).join(',');
};

var isDev = true;

var warn = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }

    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        (function () {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;

          console.warn(format.replace(/%s/g, function () {
            return args[argIndex++];
          }));
        })();
      }
    }
  }
};

var ACCURACY = 1e-4;

var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
};

var multyTime = function multyTime(params, t) {
  return params.map(function (param, i) {
    return param * Math.pow(t, i);
  }).reduce(function (pre, curr) {
    return pre + curr;
  });
};

var cubicBezier = function cubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);

    return multyTime(params, t);
  };
};

var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);
    var newParams = [].concat(params.map(function (param, i) {
      return param * i;
    }).slice(1), [0]);

    return multyTime(newParams, t);
  };
};

// calculate cubic-bezier using Newton's method
var configBezier = function configBezier() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var x1 = args[0],
      y1 = args[1],
      x2 = args[2],
      y2 = args[3];


  if (args.length === 1) {
    switch (args[0]) {
      case 'linear':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;

        break;
      case 'ease':
        x1 = 0.25;
        y1 = 0.1;
        x2 = 0.25;
        y2 = 1.0;

        break;
      case 'ease-in':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;

        break;
      case 'ease-out':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;

        break;
      case 'ease-in-out':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;

        break;
      default:
        warn(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\', instead received %s', args);
    }
  }

  warn([x1, x2, y1, y2].every(function (num) {
    return typeof num === 'number' && num >= 0 && num <= 1;
  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);

  var curveX = cubicBezier(x1, x2);
  var curveY = cubicBezier(y1, y2);
  var derCurveX = derivativeCubicBezier(x1, x2);
  var rangeValue = function rangeValue(value) {
    if (value > 1) {
      return 1;
    } else if (value < 0) {
      return 0;
    }

    return value;
  };

  var bezier = function bezier(_t) {
    var t = _t > 1 ? 1 : _t;
    var x = t;

    for (var i = 0; i < 8; ++i) {
      var evalT = curveX(x) - t;
      var derVal = derCurveX(x);

      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
        return curveY(x);
      }

      x = rangeValue(x - evalT / derVal);
    }

    return curveY(x);
  };

  bezier.isStepper = false;

  return bezier;
};

var configSpring = function configSpring() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$stiff = config.stiff,
      stiff = _config$stiff === undefined ? 100 : _config$stiff,
      _config$damping = config.damping,
      damping = _config$damping === undefined ? 8 : _config$damping,
      _config$dt = config.dt,
      dt = _config$dt === undefined ? 17 : _config$dt;

  var stepper = function stepper(currX, destX, currV) {
    var FSpring = -(currX - destX) * stiff;
    var FDamping = currV * damping;
    var newV = currV + (FSpring - FDamping) * dt / 1000;
    var newX = currV * dt / 1000 + currX;

    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
      return [destX, 0];
    }
    return [newX, newV];
  };

  stepper.isStepper = true;
  stepper.dt = dt;

  return stepper;
};

var configEasing = function configEasing() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var easing = args[0];


  if (typeof easing === 'string') {
    switch (easing) {
      case 'ease':
      case 'ease-in-out':
      case 'ease-out':
      case 'ease-in':
      case 'linear':
        return configBezier(easing);
      case 'spring':
        return configSpring();
      default:
        warn(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\', \'linear\' and \'spring\', instead  received %s', args);
    }
  }

  if (typeof easing === 'function') {
    return easing;
  }

  warn(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);

  return null;
};

var alpha = function alpha(begin, end, k) {
  return begin + (end - begin) * k;
};
var needContinue = function needContinue(_ref) {
  var from = _ref.from,
      to = _ref.to;
  return from !== to;
};

/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */
var calStepperVals = function calStepperVals(easing, preVals, steps) {
  var nextStepVals = mapObject(function (key, val) {
    if (needContinue(val)) {
      var _easing = easing(val.from, val.to, val.velocity),
          newX = _easing[0],
          newV = _easing[1];

      return _extends({}, val, {
        from: newX,
        velocity: newV
      });
    }

    return val;
  }, preVals);

  if (steps < 1) {
    return mapObject(function (key, val) {
      if (needContinue(val)) {
        return _extends({}, val, {
          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
          from: alpha(val.from, nextStepVals[key].from, steps)
        });
      }

      return val;
    }, preVals);
  }

  return calStepperVals(easing, nextStepVals, steps - 1);
};

// configure update function
var configUpdate = (function (from, to, easing, duration, render) {
  var interKeys = getIntersectionKeys(from, to);
  var timingStyle = interKeys.reduce(function (res, key) {
    var _babelHelpers$extends;

    return _extends({}, res, (_babelHelpers$extends = {}, _babelHelpers$extends[key] = [from[key], to[key]], _babelHelpers$extends));
  }, {});

  var stepperStyle = interKeys.reduce(function (res, key) {
    var _babelHelpers$extends2;

    return _extends({}, res, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[key] = {
      from: from[key],
      velocity: 0,
      to: to[key]
    }, _babelHelpers$extends2));
  }, {});
  var cafId = -1;
  var preTime = void 0;
  var beginTime = void 0;
  var update = function update() {
    return null;
  };

  var getCurrStyle = function getCurrStyle() {
    return mapObject(function (key, val) {
      return val.from;
    }, stepperStyle);
  };
  var shouldStopAnimation = function shouldStopAnimation() {
    return !_.filter(stepperStyle, needContinue).length;
  };

  // stepper timing function like spring
  var stepperUpdate = function stepperUpdate(now) {
    if (!preTime) {
      preTime = now;
    }
    var deltaTime = now - preTime;
    var steps = deltaTime / easing.dt;

    stepperStyle = calStepperVals(easing, stepperStyle, steps);
    // get union set and add compatible prefix
    render(_extends({}, from, to, getCurrStyle(stepperStyle)));

    preTime = now;

    if (!shouldStopAnimation()) {
      cafId = raf__default(update);
    }
  };

  // t => val timing function like cubic-bezier
  var timingUpdate = function timingUpdate(now) {
    if (!beginTime) {
      beginTime = now;
    }

    var t = (now - beginTime) / duration;
    var currStyle = mapObject(function (key, val) {
      return alpha.apply(undefined, val.concat([easing(t)]));
    }, timingStyle);

    // get union set and add compatible prefix
    render(_extends({}, from, to, currStyle));

    if (t < 1) {
      cafId = raf__default(update);
    } else {
      var finalStyle = mapObject(function (key, val) {
        return alpha.apply(undefined, val.concat([easing(1)]));
      }, timingStyle);

      render(_extends({}, from, to, finalStyle));
    }
  };

  update = easing.isStepper ? stepperUpdate : timingUpdate;

  // return start animation method
  return function () {
    raf__default(update);

    // return stop animation method
    return function () {
      raf.cancel(cafId);
    };
  };
});

var _class$4;

var Animate = pureRenderDecorator$2(_class$4 = function (_Component) {
  inherits(Animate, _Component);

  function Animate(props, context) {
    classCallCheck(this, Animate);

    var _this = possibleConstructorReturn(this, _Component.call(this, props, context));

    var _this$props = _this.props,
        isActive = _this$props.isActive,
        attributeName = _this$props.attributeName,
        from = _this$props.from,
        to = _this$props.to,
        steps = _this$props.steps,
        children = _this$props.children;


    _this.handleStyleChange = _this.handleStyleChange.bind(_this);
    _this.changeStyle = _this.changeStyle.bind(_this);

    if (!isActive) {
      _this.state = { style: {} };

      // if children is a function and animation is not active, set style to 'to'
      if (typeof children === 'function') {
        _this.state = { style: to };
      }

      return possibleConstructorReturn(_this);
    }

    if (steps && steps.length) {
      _this.state = { style: steps[0].style };
    } else if (from) {
      var _ref;

      if (typeof children === 'function') {
        _this.state = {
          style: from
        };

        return possibleConstructorReturn(_this);
      }
      _this.state = {
        style: attributeName ? (_ref = {}, _ref[attributeName] = from, _ref) : from
      };
    } else {
      _this.state = { style: {} };
    }
    return _this;
  }

  Animate.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        isActive = _props.isActive,
        canBegin = _props.canBegin;


    this.mounted = true;

    if (!isActive || !canBegin) {
      return;
    }

    this.runAnimation(this.props);
  };

  Animate.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref3;

    var isActive = nextProps.isActive,
        canBegin = nextProps.canBegin,
        attributeName = nextProps.attributeName,
        shouldReAnimate = nextProps.shouldReAnimate;


    if (!canBegin) {
      return;
    }

    if (!isActive) {
      var _ref2;

      this.setState({
        style: attributeName ? (_ref2 = {}, _ref2[attributeName] = nextProps.to, _ref2) : nextProps.to
      });

      return;
    }

    var animateProps = ['to', 'canBegin', 'isActive'];

    if (___default.isEqual(this.props.to, nextProps.to) && this.props.canBegin && this.props.isActive) {
      return;
    }

    var isTriggered = !this.props.canBegin || !this.props.isActive;

    if (this.manager) {
      this.manager.stop();
    }

    if (this.stopJSAnimation) {
      this.stopJSAnimation();
    }

    var from = isTriggered || shouldReAnimate ? nextProps.from : this.props.to;

    this.setState({
      style: attributeName ? (_ref3 = {}, _ref3[attributeName] = from, _ref3) : from
    });

    this.runAnimation(_extends({}, nextProps, {
      from: from,
      begin: 0
    }));
  };

  Animate.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;

    if (this.unSubscribe) {
      this.unSubscribe();
    }

    if (this.manager) {
      this.manager.stop();
      this.manager = null;
    }

    if (this.stopJSAnimation) {
      this.stopJSAnimation();
    }
  };

  Animate.prototype.runJSAnimation = function runJSAnimation(props) {
    var _this2 = this;

    var from = props.from,
        to = props.to,
        duration = props.duration,
        easing = props.easing,
        begin = props.begin,
        onAnimationEnd = props.onAnimationEnd,
        onAnimationStart = props.onAnimationStart;

    var startAnimation = configUpdate(from, to, configEasing(easing), duration, this.changeStyle);

    var finalStartAnimation = function finalStartAnimation() {
      _this2.stopJSAnimation = startAnimation();
    };

    this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
  };

  Animate.prototype.runStepAnimation = function runStepAnimation(props) {
    var _this3 = this;

    var steps = props.steps,
        begin = props.begin,
        onAnimationStart = props.onAnimationStart;
    var _steps$ = steps[0],
        initialStyle = _steps$.style,
        _steps$$duration = _steps$.duration,
        initialTime = _steps$$duration === undefined ? 0 : _steps$$duration;


    var addStyle = function addStyle(sequence, nextItem, index) {
      if (index === 0) {
        return sequence;
      }

      var duration = nextItem.duration,
          _nextItem$easing = nextItem.easing,
          easing = _nextItem$easing === undefined ? 'ease' : _nextItem$easing,
          style = nextItem.style,
          nextProperties = nextItem.properties,
          onAnimationEnd = nextItem.onAnimationEnd;


      var preItem = index > 0 ? steps[index - 1] : nextItem;
      var properties = nextProperties || Object.keys(style);

      if (typeof easing === 'function' || easing === 'spring') {
        return [].concat(sequence, [_this3.runJSAnimation.bind(_this3, {
          from: preItem.style,
          to: style,
          duration: duration,
          easing: easing
        }), duration]);
      }

      var transition = getTransitionVal(properties, duration, easing);
      var newStyle = _extends({}, preItem.style, style, {
        transition: transition
      });

      return [].concat(sequence, [newStyle, duration, onAnimationEnd]).filter(identity);
    };

    return this.manager.start([onAnimationStart].concat(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)]), [props.onAnimationEnd]));
  };

  Animate.prototype.runAnimation = function runAnimation(props) {
    var _ref4;

    if (!this.manager) {
      this.manager = createAnimateManager();
    }
    var begin = props.begin,
        duration = props.duration,
        attributeName = props.attributeName,
        propsFrom = props.from,
        propsTo = props.to,
        easing = props.easing,
        onAnimationStart = props.onAnimationStart,
        onAnimationEnd = props.onAnimationEnd,
        steps = props.steps,
        children = props.children;


    var manager = this.manager;

    this.unSubscribe = manager.subscribe(this.handleStyleChange);

    if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
      this.runJSAnimation(props);
      return;
    }

    if (steps.length > 1) {
      this.runStepAnimation(props);
      return;
    }

    var to = attributeName ? (_ref4 = {}, _ref4[attributeName] = propsTo, _ref4) : propsTo;
    var transition = getTransitionVal(Object.keys(to), duration, easing);

    manager.start([onAnimationStart, begin, _extends({}, to, { transition: transition }), duration, onAnimationEnd]);
  };

  Animate.prototype.handleStyleChange = function handleStyleChange(style) {
    this.changeStyle(style);
  };

  Animate.prototype.changeStyle = function changeStyle(style) {
    if (this.mounted) {
      this.setState({
        style: style
      });
    }
  };

  Animate.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        begin = _props2.begin,
        duration = _props2.duration,
        attributeName = _props2.attributeName,
        easing = _props2.easing,
        isActive = _props2.isActive,
        steps = _props2.steps,
        from = _props2.from,
        to = _props2.to,
        canBegin = _props2.canBegin,
        onAnimationEnd = _props2.onAnimationEnd,
        shouldReAnimate = _props2.shouldReAnimate,
        onAnimationReStart = _props2.onAnimationReStart,
        others = objectWithoutProperties(_props2, ['children', 'begin', 'duration', 'attributeName', 'easing', 'isActive', 'steps', 'from', 'to', 'canBegin', 'onAnimationEnd', 'shouldReAnimate', 'onAnimationReStart']);

    var count = React.Children.count(children);
    var stateStyle = translateStyle(this.state.style);

    if (typeof children === 'function') {
      return children(stateStyle);
    }

    if (!isActive || count === 0) {
      return children;
    }

    var cloneContainer = function cloneContainer(container) {
      var _container$props = container.props,
          _container$props$styl = _container$props.style,
          style = _container$props$styl === undefined ? {} : _container$props$styl,
          className = _container$props.className;


      var res = React.cloneElement(container, _extends({}, others, {
        style: _extends({}, style, stateStyle),
        className: className
      }));
      return res;
    };

    if (count === 1) {
      var onlyChild = React.Children.only(children);

      return cloneContainer(React.Children.only(children));
    }

    return React__default.createElement(
      'div',
      null,
      React.Children.map(children, function (child) {
        return cloneContainer(child);
      })
    );
  };

  return Animate;
}(React.Component)) || _class$4;

Animate.displayName = 'Animate';
Animate.defaultProps = {
  begin: 0,
  duration: 1000,
  from: '',
  to: '',
  attributeName: '',
  easing: 'ease',
  isActive: true,
  canBegin: true,
  steps: [],
  onAnimationEnd: function onAnimationEnd() {},
  onAnimationStart: function onAnimationStart() {}
};

function assign(obj, props) {
	for (var i in props) {
		if (props.hasOwnProperty(i)) obj[i] = props[i];
	}return obj;
}

function getKey(vnode, fallback) {
	var key = vnode.attributes && vnode.attributes.key;
	return key === null || key === undefined ? fallback : key;
}

function linkRef(component, name) {
	var cache = component._ptgLinkedRefs || (component._ptgLinkedRefs = {});
	return cache[name] || (cache[name] = function (c) {
		component.refs[name] = c;
	});
}

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 *	Additional credit to the Author of rc-css-transition-group: https://github.com/yiminghe
 *	File originally extracted from the React source, converted to ES6 by https://github.com/developit
 */

function getChildMapping(children) {
	var out = {};
	for (var i = 0; i < children.length; i++) {
		var key = getKey(children[i], i.toString(36));
		out[key] = children[i];
	}
	return out;
}

function mergeChildMappings(prev, next) {
	prev = prev || {};
	next = next || {};

	var getValueForKey = function getValueForKey(key) {
		return next.hasOwnProperty(key) ? next[key] : prev[key];
	};

	// For each key of `next`, the list of keys to insert before that key in
	// the combined list
	var nextKeysPending = {};

	var pendingKeys = [];
	for (var prevKey in prev) {
		if (next.hasOwnProperty(prevKey)) {
			if (pendingKeys.length) {
				nextKeysPending[prevKey] = pendingKeys;
				pendingKeys = [];
			}
		} else {
			pendingKeys.push(prevKey);
		}
	}

	var childMapping = {};
	for (var nextKey in next) {
		if (nextKeysPending.hasOwnProperty(nextKey)) {
			for (var i = 0; i < nextKeysPending[nextKey].length; i++) {
				var pendingNextKey = nextKeysPending[nextKey][i];
				childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
			}
		}
		childMapping[nextKey] = getValueForKey(nextKey);
	}

	// Finally, add the keys which didn't appear before any key in `next`
	for (var _i = 0; _i < pendingKeys.length; _i++) {
		childMapping[pendingKeys[_i]] = getValueForKey(pendingKeys[_i]);
	}

	return childMapping;
}

var identity$1 = function identity(i) {
	return i;
};

var TransitionGroup = function (_Component) {
	inherits(TransitionGroup, _Component);

	function TransitionGroup() {
		var _temp, _this, _ret;

		classCallCheck(this, TransitionGroup);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.refs = {}, _this.state = {
			children: getChildMapping(_this.props.children || [])
		}, _this.performEnter = function (key) {
			_this.currentlyTransitioningKeys[key] = true;

			var component = _this.refs[key];

			if (component.componentWillEnter) {
				component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
			} else {
				_this._handleDoneEntering(key);
			}
		}, _this.performLeave = function (key) {
			_this.currentlyTransitioningKeys[key] = true;

			var component = _this.refs[key];
			if (component.componentWillLeave) {
				component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
			} else {
				// Note that this is somewhat dangerous b/c it calls setState()
				// again, effectively mutating the component before all the work
				// is done.
				_this._handleDoneLeaving(key);
			}
		}, _temp), possibleConstructorReturn(_this, _ret);
	}

	TransitionGroup.prototype.componentWillMount = function componentWillMount() {
		this.currentlyTransitioningKeys = {};
		this.keysToEnter = [];
		this.keysToLeave = [];
	};

	TransitionGroup.prototype.componentDidMount = function componentDidMount() {
		var initialChildMapping = this.state.children;
		for (var key in initialChildMapping) {
			if (initialChildMapping[key]) {
				// this.performAppear(getKey(initialChildMapping[key], key));
				this.performAppear(key);
			}
		}
	};

	TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		var nextChildMapping = getChildMapping(nextProps.children || []);
		var prevChildMapping = this.state.children;

		this.setState({
			children: mergeChildMappings(prevChildMapping, nextChildMapping)
		});

		var key = void 0;

		for (key in nextChildMapping) {
			if (nextChildMapping.hasOwnProperty(key)) {
				var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
				if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
					this.keysToEnter.push(key);
				}
			}
		}for (key in prevChildMapping) {
			if (prevChildMapping.hasOwnProperty(key)) {
				var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
				if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
					this.keysToLeave.push(key);
				}
			}
		}
	};

	TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
		var keysToEnter = this.keysToEnter;
		this.keysToEnter = [];
		keysToEnter.forEach(this.performEnter);

		var keysToLeave = this.keysToLeave;
		this.keysToLeave = [];
		keysToLeave.forEach(this.performLeave);
	};

	TransitionGroup.prototype.performAppear = function performAppear(key) {
		this.currentlyTransitioningKeys[key] = true;

		var component = this.refs[key];

		if (component.componentWillAppear) {
			component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
		} else {
			this._handleDoneAppearing(key);
		}
	};

	TransitionGroup.prototype._handleDoneAppearing = function _handleDoneAppearing(key) {
		var component = this.refs[key];
		if (component.componentDidAppear) {
			component.componentDidAppear();
		}

		delete this.currentlyTransitioningKeys[key];

		var currentChildMapping = getChildMapping(this.props.children || []);

		if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
			// This was removed before it had fully appeared. Remove it.
			this.performLeave(key);
		}
	};

	TransitionGroup.prototype._handleDoneEntering = function _handleDoneEntering(key) {
		var component = this.refs[key];
		if (component.componentDidEnter) {
			component.componentDidEnter();
		}

		delete this.currentlyTransitioningKeys[key];

		var currentChildMapping = getChildMapping(this.props.children || []);

		if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
			// This was removed before it had fully entered. Remove it.
			this.performLeave(key);
		}
	};

	TransitionGroup.prototype._handleDoneLeaving = function _handleDoneLeaving(key) {
		var component = this.refs[key];

		if (component.componentDidLeave) {
			component.componentDidLeave();
		}

		delete this.currentlyTransitioningKeys[key];

		var currentChildMapping = getChildMapping(this.props.children || []);

		if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
			// This entered again before it fully left. Add it again.
			this.performEnter(key);
		} else {
			var children = assign({}, this.state.children);
			delete children[key];
			this.setState({ children: children });
		}
	};

	TransitionGroup.prototype.render = function render(_ref, _ref2) {
		var children = _ref2.children;
		var childFactory = _ref.childFactory,
		    transitionLeave = _ref.transitionLeave,
		    transitionName = _ref.transitionName,
		    transitionAppear = _ref.transitionAppear,
		    transitionEnter = _ref.transitionEnter,
		    transitionLeaveTimeout = _ref.transitionLeaveTimeout,
		    transitionEnterTimeout = _ref.transitionEnterTimeout,
		    transitionAppearTimeout = _ref.transitionAppearTimeout,
		    component = _ref.component,
		    props = objectWithoutProperties(_ref, ['childFactory', 'transitionLeave', 'transitionName', 'transitionAppear', 'transitionEnter', 'transitionLeaveTimeout', 'transitionEnterTimeout', 'transitionAppearTimeout', 'component']);

		// TODO: we could get rid of the need for the wrapper node
		// by cloning a single child
		var childrenToRender = [];
		for (var key in children) {
			if (children.hasOwnProperty(key)) {
				var child = children[key];
				if (child) {
					var ref = linkRef(this, key),
					    el = preact.cloneElement(childFactory(child), { ref: ref, key: key });
					childrenToRender.push(el);
				}
			}
		}return preact.h(component, props, childrenToRender);
	};

	return TransitionGroup;
}(preact.Component);
TransitionGroup.defaultProps = {
	component: 'span',
	childFactory: identity$1
};

var AnimateGroupChild = function (_Component) {
  inherits(AnimateGroupChild, _Component);

  function AnimateGroupChild() {
    var _temp, _this, _ret;

    classCallCheck(this, AnimateGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      isActive: false
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  AnimateGroupChild.prototype.handleStyleActive = function handleStyleActive(style, done) {
    if (style) {
      var onAnimationEnd = style.onAnimationEnd ? function () {
        style.onAnimationEnd();
        done();
      } : done;

      this.setState(_extends({}, style, {
        onAnimationEnd: onAnimationEnd,
        isActive: true
      }));
    } else {
      done();
    }
  };

  AnimateGroupChild.prototype.componentWillAppear = function componentWillAppear(done) {
    this.handleStyleActive(this.props.appear, done);
  };

  AnimateGroupChild.prototype.componentWillEnter = function componentWillEnter(done) {
    this.handleStyleActive(this.props.enter, done);
  };

  AnimateGroupChild.prototype.componentWillLeave = function componentWillLeave(done) {
    this.handleStyleActive(this.props.leave, done);
  };

  AnimateGroupChild.prototype.render = function render() {
    return React__default.createElement(
      Animate,
      this.state,
      React.Children.only(this.props.children)
    );
  };

  return AnimateGroupChild;
}(React.Component);

var AnimateGroup = function (_Component) {
  inherits(AnimateGroup, _Component);

  function AnimateGroup() {
    classCallCheck(this, AnimateGroup);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AnimateGroup.prototype.wrapChild = function wrapChild(child) {
    var _props = this.props,
        appear = _props.appear,
        leave = _props.leave,
        enter = _props.enter;


    return React__default.createElement(
      AnimateGroupChild,
      {
        appear: appear,
        leave: leave,
        enter: enter
      },
      child
    );
  };

  AnimateGroup.prototype.render = function render() {
    var _props2 = this.props,
        component = _props2.component,
        children = _props2.children;


    return React__default.createElement(
      TransitionGroup,
      {
        component: component,
        childFactory: this.wrapChild.bind(this)
      },
      children
    );
  };

  return AnimateGroup;
}(React.Component);

AnimateGroup.defaultProps = {
  component: 'span'
};

var _class$5;

/**
 * @fileOverview Default Tooltip Content
 */
var defaultFormatter = function defaultFormatter(value) {
  return ___default.isArray(value) && isNumOrStr(value[0]) && isNumOrStr(value[1]) ? value.join(' ~ ') : value;
};

var DefaultTooltipContent = pureRenderDecorator$1(_class$5 = function (_Component) {
  inherits(DefaultTooltipContent, _Component);

  function DefaultTooltipContent() {
    classCallCheck(this, DefaultTooltipContent);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  DefaultTooltipContent.prototype.renderContent = function renderContent() {
    var _props = this.props,
        payload = _props.payload,
        separator = _props.separator,
        formatter = _props.formatter,
        itemStyle = _props.itemStyle,
        itemSorter = _props.itemSorter;


    if (payload && payload.length) {
      var listStyle = { padding: 0, margin: 0 };

      var items = payload.filter(function (entry) {
        return !___default.isNil(entry.value);
      }).sort(itemSorter).map(function (entry, i) {
        var finalItemStyle = _extends({
          display: 'block',
          paddingTop: 4,
          paddingBottom: 4,
          color: entry.color || '#000'
        }, itemStyle);
        var finalFormatter = entry.formatter || formatter || defaultFormatter;

        return React__default.createElement(
          'li',
          { className: 'recharts-tooltip-item', key: 'tooltip-item-' + i, style: finalItemStyle },
          entry.name ? React__default.createElement(
            'span',
            { className: 'recharts-tooltip-item-name' },
            entry.name
          ) : null,
          entry.name ? React__default.createElement(
            'span',
            { className: 'recharts-tooltip-item-separator' },
            separator
          ) : null,
          React__default.createElement(
            'span',
            { className: 'recharts-tooltip-item-value' },
            finalFormatter ? finalFormatter(entry.value, entry.name, entry, i) : entry.value
          ),
          React__default.createElement(
            'span',
            { className: 'recharts-tooltip-item-unit' },
            entry.unit || ''
          )
        );
      });

      return React__default.createElement(
        'ul',
        { className: 'recharts-tooltip-item-list', style: listStyle },
        items
      );
    }

    return null;
  };

  DefaultTooltipContent.prototype.render = function render() {
    var _props2 = this.props,
        labelStyle = _props2.labelStyle,
        label = _props2.label,
        labelFormatter = _props2.labelFormatter,
        wrapperStyle = _props2.wrapperStyle;

    var finalStyle = _extends({
      margin: 0,
      padding: 10,
      backgroundColor: '#fff',
      border: '1px solid #ccc',
      whiteSpace: 'nowrap'
    }, wrapperStyle);
    var finalLabelStyle = _extends({
      margin: 0
    }, labelStyle);
    var hasLabel = isNumOrStr(label);
    var finalLabel = hasLabel ? label : '';

    if (hasLabel && labelFormatter) {
      finalLabel = labelFormatter(label);
    }

    return React__default.createElement(
      'div',
      { className: 'recharts-default-tooltip', style: finalStyle },
      React__default.createElement(
        'p',
        { className: 'recharts-tooltip-label', style: finalLabelStyle },
        finalLabel
      ),
      this.renderContent()
    );
  };

  return DefaultTooltipContent;
}(React.Component)) || _class$5;

DefaultTooltipContent.displayName = 'DefaultTooltipContent';
DefaultTooltipContent.defaultProps = {
  separator: ' : ',
  itemStyle: {},
  labelStyle: {}
};

var _class$3;

/**
 * @fileOverview Tooltip
 */
var EPS$1 = 1;

var propTypes$2 = {
  content: React.PropTypes.oneOfType([React.PropTypes.element, React.PropTypes.func]),
  viewBox: React.PropTypes.shape({
    x: React.PropTypes.number,
    y: React.PropTypes.number,
    width: React.PropTypes.number,
    height: React.PropTypes.number
  }),

  active: React.PropTypes.bool,
  separator: React.PropTypes.string,
  formatter: React.PropTypes.func,
  offset: React.PropTypes.number,

  itemStyle: React.PropTypes.object,
  labelStyle: React.PropTypes.object,
  wrapperStyle: React.PropTypes.object,
  cursor: React.PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.element, React.PropTypes.object]),

  coordinate: React.PropTypes.shape({
    x: React.PropTypes.number,
    y: React.PropTypes.number
  }),
  position: React.PropTypes.shape({
    x: React.PropTypes.number,
    y: React.PropTypes.number
  }),

  label: React.PropTypes.any,
  payload: React.PropTypes.arrayOf(React.PropTypes.shape({
    name: React.PropTypes.any,
    value: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string, React.PropTypes.array]),
    unit: React.PropTypes.any
  })),

  isAnimationActive: React.PropTypes.bool,
  animationDuration: React.PropTypes.number,
  animationEasing: React.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  itemSorter: React.PropTypes.func
};

var defaultProps = {
  active: false,
  offset: 10,
  viewBox: { x1: 0, x2: 0, y1: 0, y2: 0 },
  coordinate: { x: 0, y: 0 },
  cursorStyle: {},
  separator: ' : ',
  wrapperStyle: {},
  itemStyle: {},
  labelStyle: {},
  cursor: true,
  isAnimationActive: !isSsr(),
  animationEasing: 'ease',
  animationDuration: 400,
  itemSorter: function itemSorter() {
    return -1;
  }
};

var renderContent$1 = function renderContent(content, props) {
  if (React__default.isValidElement(content)) {
    return React__default.cloneElement(content, props);
  } else if (___default.isFunction(content)) {
    return content(props);
  }

  return React__default.createElement(DefaultTooltipContent, props);
};

var Tooltip = pureRenderDecorator$1(_class$3 = function (_Component) {
  inherits(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      boxWidth: -1,
      boxHeight: -1
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Tooltip.prototype.componentDidMount = function componentDidMount() {
    this.updateBBox();
  };

  Tooltip.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateBBox();
  };

  Tooltip.prototype.updateBBox = function updateBBox() {
    var _state = this.state,
        boxWidth = _state.boxWidth,
        boxHeight = _state.boxHeight;


    if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
      var box = this.wrapperNode.getBoundingClientRect();

      if (Math.abs(box.width - boxWidth) > EPS$1 || Math.abs(box.height - boxHeight) > EPS$1) {
        this.setState({
          boxWidth: box.width,
          boxHeight: box.height
        });
      }
    } else if (boxWidth !== -1 || boxHeight !== -1) {
      this.setState({
        boxWidth: -1,
        boxHeight: -1
      });
    }
  };

  Tooltip.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        payload = _props.payload,
        isAnimationActive = _props.isAnimationActive,
        animationDuration = _props.animationDuration,
        animationEasing = _props.animationEasing;

    var hasPayload = payload && payload.length && payload.filter(function (entry) {
      return !___default.isNil(entry.value);
    }).length;
    var _props2 = this.props,
        content = _props2.content,
        viewBox = _props2.viewBox,
        coordinate = _props2.coordinate,
        position = _props2.position,
        active = _props2.active,
        offset = _props2.offset,
        wrapperStyle = _props2.wrapperStyle;

    var outerStyle = _extends({
      pointerEvents: 'none',
      visibility: active && hasPayload ? 'visible' : 'hidden',
      position: 'absolute',
      top: 0
    }, wrapperStyle);
    var translateX = void 0,
        translateY = void 0;

    if (position && isNumber(position.x) && isNumber(position.y)) {
      translateX = position.x;
      translateY = position.y;
    } else {
      var _state2 = this.state,
          boxWidth = _state2.boxWidth,
          boxHeight = _state2.boxHeight;


      if (boxWidth > 0 && boxHeight > 0 && coordinate) {
        translateX = position && isNumber(position.x) ? position.x : Math.max(coordinate.x + boxWidth + offset > viewBox.x + viewBox.width ? coordinate.x - boxWidth - offset : coordinate.x + offset, viewBox.x);

        translateY = position && isNumber(position.y) ? position.y : Math.max(coordinate.y + boxHeight + offset > viewBox.y + viewBox.height ? coordinate.y - boxHeight - offset : coordinate.y + offset, viewBox.y);
      } else {
        outerStyle.visibility = 'hidden';
      }
    }

    outerStyle = _extends({}, outerStyle, translateStyle({
      transform: 'translate(' + translateX + 'px, ' + translateY + 'px)'
    }));

    if (isAnimationActive && active) {
      outerStyle = _extends({}, outerStyle, translateStyle({
        transition: 'transform ' + animationDuration + 'ms ' + animationEasing
      }));
    }

    return React__default.createElement(
      'div',
      {
        className: 'recharts-tooltip-wrapper',
        style: outerStyle,
        ref: function ref(node) {
          _this2.wrapperNode = node;
        }
      },
      renderContent$1(content, this.props)
    );
  };

  return Tooltip;
}(React.Component)) || _class$3;

Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = defaultProps;

function unwrapExports (x) {
	return x && x.__esModule ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var resizeDetectorStyles = createCommonjsModule(function (module, exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var parentStyle = exports.parentStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    zIndex: -1,
    visibility: 'hidden'
  };

  var shrinkChildStyle = exports.shrinkChildStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '200%',
    height: '200%'
  };

  var expandChildStyle = exports.expandChildStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
  };
});

var require$$0 = ( compat && compat['default'] ) || compat;

var ResizeDetector_1 = createCommonjsModule(function (module, exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;_e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }return _arr;
    }return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
      }
    }return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
  }();

  var _react = require$$0;

  var _react2 = _interopRequireDefault(_react);

  var _resizeDetectorStyles = resizeDetectorStyles;

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ResizeDetector = function (_Component) {
    _inherits(ResizeDetector, _Component);

    function ResizeDetector() {
      _classCallCheck(this, ResizeDetector);

      var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this));

      _this.state = {
        expandChildHeight: 0,
        expandChildWidth: 0,
        expandScrollLeft: 0,
        expandScrollTop: 0,
        shrinkScrollTop: 0,
        shrinkScrollLeft: 0,
        lastWidth: 0,
        lastHeight: 0
      };

      _this.reset = _this.reset.bind(_this);
      _this.handleScroll = _this.handleScroll.bind(_this);
      return _this;
    }

    _createClass(ResizeDetector, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.forceUpdate();
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _containerSize = this.containerSize();

        var _containerSize2 = _slicedToArray(_containerSize, 2);

        var width = _containerSize2[0];
        var height = _containerSize2[1];

        this.reset(width, height);
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return this.props !== nextProps;
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.expand.scrollLeft = this.expand.scrollWidth;
        this.expand.scrollTop = this.expand.scrollHeight;

        this.shrink.scrollLeft = this.shrink.scrollWidth;
        this.shrink.scrollTop = this.shrink.scrollHeight;
      }
    }, {
      key: 'containerSize',
      value: function containerSize() {
        return [this.props.handleWidth && this.container.parentElement.offsetWidth, this.props.handleHeight && this.container.parentElement.offsetHeight];
      }
    }, {
      key: 'reset',
      value: function reset(containerWidth, containerHeight) {
        if (typeof window === 'undefined') {
          return;
        }

        var parent = this.container.parentElement;

        var position = 'static';
        if (parent.currentStyle) {
          position = parent.currentStyle.position;
        } else if (window.getComputedStyle) {
          position = window.getComputedStyle(parent).position;
        }
        if (position === 'static') {
          parent.style.position = 'relative';
        }

        this.setState({
          expandChildHeight: this.expand.offsetHeight + 10,
          expandChildWidth: this.expand.offsetWidth + 10,
          lastWidth: containerWidth,
          lastHeight: containerHeight
        });
      }
    }, {
      key: 'handleScroll',
      value: function handleScroll() {
        if (typeof window === 'undefined') {
          return;
        }

        var state = this.state;

        var _containerSize3 = this.containerSize();

        var _containerSize4 = _slicedToArray(_containerSize3, 2);

        var width = _containerSize4[0];
        var height = _containerSize4[1];

        if (width !== state.lastWidth || height !== state.lastHeight) {
          this.props.onResize(width, height);
        }

        this.reset(width, height);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var state = this.state;

        var expandStyle = _extends({}, _resizeDetectorStyles.expandChildStyle, {
          width: state.expandChildWidth,
          height: state.expandChildHeight
        });

        return _react2.default.createElement('div', { style: _resizeDetectorStyles.parentStyle, ref: function ref(e) {
            _this2.container = e;
          } }, _react2.default.createElement('div', { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
            _this2.expand = e;
          } }, _react2.default.createElement('div', { style: expandStyle })), _react2.default.createElement('div', { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
            _this2.shrink = e;
          } }, _react2.default.createElement('div', { style: _resizeDetectorStyles.shrinkChildStyle })));
      }
    }]);

    return ResizeDetector;
  }(_react.Component);

  exports.default = ResizeDetector;

  ResizeDetector.propTypes = {
    handleWidth: _react.PropTypes.bool,
    handleHeight: _react.PropTypes.bool,
    onResize: _react.PropTypes.func
  };

  ResizeDetector.defaultProps = {
    handleWidth: false,
    handleHeight: false,
    onResize: function onResize(e) {
      return e;
    }
  };
});

var index$1 = createCommonjsModule(function (module, exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _ResizeDetector = ResizeDetector_1;

  var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  exports.default = _ResizeDetector2.default;
});

var ReactResizeDetector = unwrapExports(index$1);

/* eslint no-console: 0 */
var isDev$1 = true;

var warn$1 = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev$1 && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }

    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        (function () {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;

          console.warn(format.replace(/%s/g, function () {
            return args[argIndex++];
          }));
        })();
      }
    }
  }
};

/**
 * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
 */
var ResponsiveContainer = function (_Component) {
  inherits(ResponsiveContainer, _Component);

  function ResponsiveContainer(props) {
    classCallCheck(this, ResponsiveContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.updateDimensionsImmediate = function () {
      if (!_this.mounted) {
        return;
      }

      var newSize = _this.getContainerSize();

      if (newSize) {
        var _this$state = _this.state,
            oldWidth = _this$state.containerWidth,
            oldHeight = _this$state.containerHeight;
        var containerWidth = newSize.containerWidth,
            containerHeight = newSize.containerHeight;


        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
          _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
        }
      }
    };

    _this.state = {
      containerWidth: -1,
      containerHeight: -1
    };

    _this.handleResize = props.debounce > 0 ? ___default.debounce(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
    return _this;
  }

  /* eslint-disable  react/no-did-mount-set-state */


  ResponsiveContainer.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;

    var size = this.getContainerSize();

    if (size) {
      this.setState(size);
    }
  };

  ResponsiveContainer.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  ResponsiveContainer.prototype.getContainerSize = function getContainerSize() {
    if (!this.container) {
      return null;
    }

    return {
      containerWidth: this.container.clientWidth,
      containerHeight: this.container.clientHeight
    };
  };

  ResponsiveContainer.prototype.renderChart = function renderChart() {
    var _state = this.state,
        containerWidth = _state.containerWidth,
        containerHeight = _state.containerHeight;


    if (containerWidth < 0 || containerHeight < 0) {
      return null;
    }

    var _props = this.props,
        aspect = _props.aspect,
        width = _props.width,
        height = _props.height,
        minWidth = _props.minWidth,
        minHeight = _props.minHeight,
        maxHeight = _props.maxHeight,
        children = _props.children;


    warn$1(isPercent(width) || isPercent(height), 'The width(%s) and height(%s) are both fixed numbers,\n       maybe you don\'t need to use a ResponsiveContainer.', width, height);

    warn$1(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);

    var calculatedWidth = isPercent(width) ? containerWidth : width;
    var calculatedHeight = isPercent(height) ? containerHeight : height;

    if (aspect && aspect > 0) {
      // Preserve the desired aspect ratio
      calculatedHeight = calculatedWidth / aspect;
      // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
      if (maxHeight && calculatedHeight > maxHeight) {
        calculatedHeight = maxHeight;
      }
    }

    warn$1(calculatedWidth > 0 && calculatedHeight > 0, 'The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.', calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);

    return React__default.cloneElement(children, {
      width: calculatedWidth,
      height: calculatedHeight
    });
  };

  ResponsiveContainer.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        minWidth = _props2.minWidth,
        minHeight = _props2.minHeight,
        width = _props2.width,
        height = _props2.height,
        maxHeight = _props2.maxHeight;

    var style = { width: width, height: height, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight };

    return React__default.createElement(
      'div',
      {
        className: 'recharts-responsive-container',
        style: style,
        ref: function ref(node) {
          _this2.container = node;
        }
      },
      this.renderChart(),
      React__default.createElement(ReactResizeDetector, { handleWidth: true, handleHeight: true, onResize: this.handleResize })
    );
  };

  return ResponsiveContainer;
}(React.Component);

ResponsiveContainer.displayName = 'ResponsiveContainer';
ResponsiveContainer.defaultProps = {
  width: '100%',
  height: '100%',
  debounce: 0
};

/**
 * @fileOverview Cross
 */
var Cell = function (_Component) {
  inherits(Cell, _Component);

  function Cell() {
    classCallCheck(this, Cell);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Cell.prototype.render = function render() {
    return null;
  };

  return Cell;
}(React.Component);

Cell.displayName = 'Cell';

var stringCache = {
  widthCache: {},
  cacheCount: 0
};
var MAX_CACHE_NUM = 2000;
var SPAN_STYLE = {
  position: 'absolute',
  top: '-20000px',
  left: 0,
  padding: 0,
  margin: 0,
  border: 'none',
  whiteSpace: 'pre'
};
var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';

function autoCompleteStyle(name, value) {
  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
    return value + 'px';
  }

  return value;
}

function camelToMiddleLine(text) {
  var strs = text.split('');

  var formatStrs = strs.reduce(function (result, entry) {
    if (entry === entry.toUpperCase()) {
      return [].concat(result, ['-', entry.toLowerCase()]);
    }

    return [].concat(result, [entry]);
  }, []);

  return formatStrs.join('');
}

var getStyleString = function getStyleString(style) {
  return Object.keys(style).reduce(function (result, s) {
    return '' + result + camelToMiddleLine(s) + ':' + autoCompleteStyle(s, style[s]) + ';';
  }, '');
};

var getStringSize = function getStringSize(text) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (text === undefined || text === null || isSsr()) {
    return { width: 0, height: 0 };
  }

  var str = '' + text;
  var styleString = getStyleString(style);
  var cacheKey = str + '-' + styleString;

  if (stringCache.widthCache[cacheKey]) {
    return stringCache.widthCache[cacheKey];
  }

  try {
    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
    if (!measurementSpan) {
      measurementSpan = document.createElement('span');
      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
      document.body.appendChild(measurementSpan);
    }

    measurementSpan.setAttribute('style', getStyleString(_extends({}, SPAN_STYLE, style)));
    measurementSpan.textContent = str;

    var rect = measurementSpan.getBoundingClientRect();
    var result = { width: rect.width, height: rect.height };

    stringCache.widthCache[cacheKey] = result;

    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
      stringCache.cacheCount = 0;
      stringCache.widthCache = {};
    }

    return result;
  } catch (e) {
    return { width: 0, height: 0 };
  }
};

var getOffset = function getOffset(el) {
  var html = el.ownerDocument.documentElement;
  var box = { top: 0, left: 0 };

  // If we don't have gBCR, just use 0,0 rather than error
  // BlackBerry 5, iOS 3 (original iPhone)
  if (typeof el.getBoundingClientRect !== 'undefined') {
    box = el.getBoundingClientRect();
  }

  return {
    top: box.top + window.pageYOffset - html.clientTop,
    left: box.left + window.pageXOffset - html.clientLeft
  };
};

/**
 * Calculate coordinate of cursor in chart
 * @param  {Object} event  Event object
 * @param  {Object} offset The offset of main part in the svg element
 * @return {Object}        {chartX, chartY}
 */
var calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
  return {
    chartX: Math.round(event.pageX - offset.left),
    chartY: Math.round(event.pageY - offset.top)
  };
};

var calculateWordWidths = function calculateWordWidths(props) {
  try {
    var words = !___default.isNil(props.children) ? props.children.toString().split(/\s+/) : [];
    var wordsWithComputedWidth = words.map(function (word) {
      return { word: word, width: getStringSize(word, props.style).width };
    });

    var spaceWidth = getStringSize('\xA0', props.style).width;

    return { wordsWithComputedWidth: wordsWithComputedWidth, spaceWidth: spaceWidth };
  } catch (e) {
    return null;
  }
};

var Text = function (_Component) {
  inherits(Text, _Component);

  function Text() {
    var _temp, _this, _ret;

    classCallCheck(this, Text);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      wordsByLines: []
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Text.prototype.componentWillMount = function componentWillMount() {
    this.updateWordsByLines(this.props, true);
  };

  Text.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var needCalculate = this.props.children !== nextProps.children || this.props.style !== nextProps.style;
    this.updateWordsByLines(nextProps, needCalculate);
  };

  Text.prototype.updateWordsByLines = function updateWordsByLines(props, needCalculate) {
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((props.width || props.scaleToFit) && !isSsr()) {
      if (needCalculate) {
        var wordWidths = calculateWordWidths(props);

        if (wordWidths) {
          var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
              spaceWidth = wordWidths.spaceWidth;


          this.wordsWithComputedWidth = wordsWithComputedWidth;
          this.spaceWidth = spaceWidth;
        } else {
          this.updateWordsWithoutCalculate(props);

          return;
        }
      }

      var wordsByLines = this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
      this.setState({ wordsByLines: wordsByLines });
    } else {
      this.updateWordsWithoutCalculate(props);
    }
  };

  Text.prototype.updateWordsWithoutCalculate = function updateWordsWithoutCalculate(props) {
    var words = !___default.isNil(props.children) ? props.children.toString().split(/\s+/) : [];
    this.setState({ wordsByLines: [{ words: words }] });
  };

  Text.prototype.calculateWordsByLines = function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
    var scaleToFit = this.props.scaleToFit;

    return wordsWithComputedWidth.reduce(function (result, _ref) {
      var word = _ref.word,
          width = _ref.width;

      var currentLine = result[result.length - 1];

      if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
        // Word can be added to an existing line
        currentLine.words.push(word);
        currentLine.width += width + spaceWidth;
      } else {
        // Add first word to line or word is too long to scaleToFit on existing line
        var newLine = { words: [word], width: width };
        result.push(newLine);
      }

      return result;
    }, []);
  };

  Text.prototype.render = function render() {
    var _props = this.props,
        dx = _props.dx,
        dy = _props.dy,
        textAnchor = _props.textAnchor,
        verticalAnchor = _props.verticalAnchor,
        scaleToFit = _props.scaleToFit,
        angle = _props.angle,
        lineHeight = _props.lineHeight,
        capHeight = _props.capHeight,
        className = _props.className,
        textProps = objectWithoutProperties(_props, ['dx', 'dy', 'textAnchor', 'verticalAnchor', 'scaleToFit', 'angle', 'lineHeight', 'capHeight', 'className']);
    var wordsByLines = this.state.wordsByLines;


    if (!isNumOrStr(textProps.x) || !isNumOrStr(textProps.y)) {
      return null;
    }
    var x = textProps.x + (isNumber(dx) ? dx : 0);
    var y = textProps.y + (isNumber(dy) ? dy : 0);

    var startDy = void 0;
    switch (verticalAnchor) {
      case 'start':
        startDy = reduceCSSCalc('calc(' + capHeight + ')');
        break;
      case 'middle':
        startDy = reduceCSSCalc('calc(' + (wordsByLines.length - 1) / 2 + ' * -' + lineHeight + ' + (' + capHeight + ' / 2))');
        break;
      default:
        startDy = reduceCSSCalc('calc(' + (wordsByLines.length - 1) + ' * -' + lineHeight + ')');
        break;
    }

    var transforms = [];
    if (scaleToFit) {
      var lineWidth = wordsByLines[0].width;
      transforms.push('scale(' + this.props.width / lineWidth + ')');
    }
    if (angle) {
      transforms.push('rotate(' + angle + ', ' + x + ', ' + y + ')');
    }
    if (transforms.length) {
      textProps.transform = transforms.join(' ');
    }

    return React__default.createElement(
      'text',
      _extends({}, getPresentationAttributes(textProps), {
        x: x,
        y: y,
        className: classNames('recharts-text', className),
        textAnchor: textAnchor
      }),
      wordsByLines.map(function (line$$1, index) {
        return React__default.createElement(
          'tspan',
          { x: x, dy: index === 0 ? startDy : lineHeight, key: index },
          line$$1.words.join(' ')
        );
      })
    );
  };

  return Text;
}(React.Component);

Text.defaultProps = {
  x: 0,
  y: 0,
  lineHeight: '1em',
  capHeight: '0.71em', // Magic number from d3
  scaleToFit: false,
  textAnchor: 'start',
  verticalAnchor: 'end' };

var RADIAN$1 = Math.PI / 180;

var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
  return {
    x: cx + Math.cos(-RADIAN$1 * angle) * radius,
    y: cy + Math.sin(-RADIAN$1 * angle) * radius
  };
};

var getMaxRadius = function getMaxRadius(width, height) {
  var margin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    top: 0, right: 0, bottom: 0, left: 0
  };
  return Math.min(Math.abs(width - (margin.left || 0) - (margin.right || 0)), Math.abs(height - (margin.left || 0) - (margin.right || 0))) / 2;
};

var _class$6;

/**
 * @fileOverview Sector
 */
var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
  var sign = Math.sign(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);

  return sign * deltaAngle;
};

var getTangentCircle = function getTangentCircle(_ref) {
  var cx = _ref.cx,
      cy = _ref.cy,
      radius = _ref.radius,
      angle = _ref.angle,
      sign = _ref.sign,
      isExternal = _ref.isExternal,
      cornerRadius = _ref.cornerRadius;

  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
  var theta = Math.asin(cornerRadius / centerRadius) / RADIAN$1;
  var centerAngle = angle + sign * theta;
  var center = polarToCartesian(cx, cy, centerRadius, centerAngle);
  // The coordinate of point which is tangent to the circle
  var circleTangency = polarToCartesian(cx, cy, radius, centerAngle);
  // The coordinate of point which is tangent to the radius line
  var lineTangency = polarToCartesian(cx, cy, centerRadius * Math.cos(theta * RADIAN$1), angle);

  return { center: center, circleTangency: circleTangency, lineTangency: lineTangency, theta: theta };
};

var getSectorPath = function getSectorPath(_ref2) {
  var cx = _ref2.cx,
      cy = _ref2.cy,
      innerRadius = _ref2.innerRadius,
      outerRadius = _ref2.outerRadius,
      startAngle = _ref2.startAngle,
      endAngle = _ref2.endAngle;

  var angle = getDeltaAngle(startAngle, endAngle);

  // When the angle of sector equals to 360, star point and end point coincide
  var tempEndAngle = startAngle + angle;
  var outerStartPoint = polarToCartesian(cx, cy, outerRadius, startAngle);
  var outerEndPoint = polarToCartesian(cx, cy, outerRadius, tempEndAngle);

  var path = 'M ' + outerStartPoint.x + ',' + outerStartPoint.y + '\n    A ' + outerRadius + ',' + outerRadius + ',0,\n    ' + +(Math.abs(angle) > 180) + ',' + +(startAngle > tempEndAngle) + ',\n    ' + outerEndPoint.x + ',' + outerEndPoint.y + '\n  ';

  if (innerRadius > 0) {
    var innerStartPoint = polarToCartesian(cx, cy, innerRadius, startAngle);
    var innerEndPoint = polarToCartesian(cx, cy, innerRadius, tempEndAngle);
    path += 'L ' + innerEndPoint.x + ',' + innerEndPoint.y + '\n            A ' + innerRadius + ',' + innerRadius + ',0,\n            ' + +(Math.abs(angle) > 180) + ',' + +(startAngle <= tempEndAngle) + ',\n            ' + innerStartPoint.x + ',' + innerStartPoint.y + ' Z';
  } else {
    path += 'L ' + cx + ',' + cy + ' Z';
  }

  return path;
};

var getSectorWithCorner = function getSectorWithCorner(_ref3) {
  var cx = _ref3.cx,
      cy = _ref3.cy,
      innerRadius = _ref3.innerRadius,
      outerRadius = _ref3.outerRadius,
      cornerRadius = _ref3.cornerRadius,
      startAngle = _ref3.startAngle,
      endAngle = _ref3.endAngle;

  var sign = Math.sign(endAngle - startAngle);

  var _getTangentCircle = getTangentCircle({
    cx: cx, cy: cy, radius: outerRadius, angle: startAngle, sign: sign, cornerRadius: cornerRadius
  }),
      soct = _getTangentCircle.circleTangency,
      solt = _getTangentCircle.lineTangency,
      sot = _getTangentCircle.theta;

  var _getTangentCircle2 = getTangentCircle({
    cx: cx, cy: cy, radius: outerRadius, angle: endAngle, sign: -sign, cornerRadius: cornerRadius
  }),
      eoct = _getTangentCircle2.circleTangency,
      eolt = _getTangentCircle2.lineTangency,
      eot = _getTangentCircle2.theta;

  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;

  if (outerArcAngle < 0) {
    return getSectorPath({
      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
    });
  }

  var path = 'M ' + solt.x + ',' + solt.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + soct.x + ',' + soct.y + '\n    A' + outerRadius + ',' + outerRadius + ',0,' + +(outerArcAngle > 180) + ',' + +(sign < 0) + ',' + eoct.x + ',' + eoct.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eolt.x + ',' + eolt.y + '\n  ';

  if (innerRadius > 0) {
    var _getTangentCircle3 = getTangentCircle({
      cx: cx, cy: cy, radius: innerRadius, angle: startAngle, sign: sign, isExternal: true, cornerRadius: cornerRadius
    }),
        sict = _getTangentCircle3.circleTangency,
        silt = _getTangentCircle3.lineTangency,
        sit = _getTangentCircle3.theta;

    var _getTangentCircle4 = getTangentCircle({
      cx: cx, cy: cy, radius: innerRadius, angle: endAngle, sign: -sign, isExternal: true, cornerRadius: cornerRadius
    }),
        eict = _getTangentCircle4.circleTangency,
        eilt = _getTangentCircle4.lineTangency,
        eit = _getTangentCircle4.theta;

    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;

    if (innerArcAngle < 0) {
      return path + 'L' + cx + ',' + cy + 'Z';
    }

    path += 'L' + eilt.x + ',' + eilt.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eict.x + ',' + eict.y + '\n      A' + innerRadius + ',' + innerRadius + ',0,' + +(innerArcAngle > 180) + ',' + +(sign > 0) + ',' + sict.x + ',' + sict.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + silt.x + ',' + silt.y + 'Z';
  } else {
    path += 'L' + cx + ',' + cy + 'Z';
  }

  return path;
};

var Sector = pureRenderDecorator$1(_class$6 = function (_Component) {
  inherits(Sector, _Component);

  function Sector() {
    classCallCheck(this, Sector);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Sector.prototype.render = function render() {
    var _props = this.props,
        cx = _props.cx,
        cy = _props.cy,
        innerRadius = _props.innerRadius,
        outerRadius = _props.outerRadius,
        cornerRadius = _props.cornerRadius,
        startAngle = _props.startAngle,
        endAngle = _props.endAngle,
        className = _props.className;


    if (outerRadius < innerRadius || startAngle === endAngle) {
      return null;
    }

    var layerClass = classNames('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = getPercentValue(cornerRadius, deltaRadius, 0, true);
    var path = void 0;

    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
      path = getSectorWithCorner({
        cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        startAngle: startAngle, endAngle: endAngle
      });
    } else {
      path = getSectorPath({ cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle });
    }

    return React__default.createElement('path', _extends({}, getPresentationAttributes(this.props), filterEventAttributes(this.props), {
      className: layerClass,
      d: path
    }));
  };

  return Sector;
}(React.Component)) || _class$6;

Sector.displayName = 'Sector';
Sector.defaultProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0
};

var _class$7;

/**
 * @fileOverview Curve
 */
var CURVE_FACTORIES = {
  curveBasisClosed: d3Shape.curveBasisClosed, curveBasisOpen: d3Shape.curveBasisOpen, curveBasis: d3Shape.curveBasis, curveLinearClosed: d3Shape.curveLinearClosed, curveLinear: d3Shape.curveLinear,
  curveMonotoneX: d3Shape.curveMonotoneX, curveMonotoneY: d3Shape.curveMonotoneY, curveNatural: d3Shape.curveNatural, curveStep: d3Shape.curveStep, curveStepAfter: d3Shape.curveStepAfter,
  curveStepBefore: d3Shape.curveStepBefore
};

var defined = function defined(p) {
  return p.x === +p.x && p.y === +p.y;
};
var getX = function getX(p) {
  return p.x;
};
var getY = function getY(p) {
  return p.y;
};

var getCurveFactory = function getCurveFactory(type, layout) {
  if (___default.isFunction(type)) {
    return type;
  }

  var name = 'curve' + type.slice(0, 1).toUpperCase() + type.slice(1);

  if (name === 'curveMonotone' && layout) {
    return CURVE_FACTORIES['' + name + (layout === 'vertical' ? 'Y' : 'X')];
  }
  return CURVE_FACTORIES[name] || d3Shape.curveLinear;
};

var Curve = pureRenderDecorator$1(_class$7 = function (_Component) {
  inherits(Curve, _Component);

  function Curve() {
    classCallCheck(this, Curve);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * Calculate the path of curve
   * @return {String} path
   */
  Curve.prototype.getPath = function getPath() {
    var _props = this.props,
        type = _props.type,
        points = _props.points,
        baseLine = _props.baseLine,
        layout = _props.layout,
        connectNulls = _props.connectNulls;

    var curveFactory = getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function (entry) {
      return defined(entry);
    }) : points;
    var lineFunction = void 0;

    if (___default.isArray(baseLine)) {
      var areaPoints = formatPoints.map(function (entry, index) {
        return _extends({}, entry, { base: baseLine[index] });
      });
      if (layout === 'vertical') {
        lineFunction = d3Shape.area().y(getY).x1(getX).x0(function (d) {
          return d.base.x;
        });
      } else {
        lineFunction = d3Shape.area().x(getX).y1(getY).y0(function (d) {
          return d.base.y;
        });
      }
      lineFunction.defined(defined).curve(curveFactory);

      return lineFunction(areaPoints);
    } else if (layout === 'vertical' && isNumber(baseLine)) {
      lineFunction = d3Shape.area().y(getY).x1(getX).x0(baseLine);
    } else if (isNumber(baseLine)) {
      lineFunction = d3Shape.area().x(getX).y1(getY).y0(baseLine);
    } else {
      lineFunction = d3Shape.line().x(getX).y(getY);
    }

    lineFunction.defined(defined).curve(curveFactory);

    return lineFunction(formatPoints);
  };

  Curve.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        points = _props2.points,
        pathRef = _props2.pathRef;


    if (!points || !points.length) {
      return null;
    }

    return React__default.createElement('path', _extends({}, getPresentationAttributes(this.props), filterEventAttributes(this.props), {
      className: classNames('recharts-curve', className),
      d: this.getPath(),
      ref: pathRef
    }));
  };

  return Curve;
}(React.Component)) || _class$7;

Curve.displayName = 'Curve';
Curve.defaultProps = {
  type: 'linear',
  points: [],
  connectNulls: false
};

var _class$8;

/**
 * @fileOverview Rectangle
 */
var getRectangePath = function getRectangePath(x, y, width, height, radius) {
  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
  var sign = height >= 0 ? 1 : -1;
  var clockWise = height >= 0 ? 1 : 0;
  var path = void 0;

  if (maxRadius > 0 && radius instanceof Array) {
    var newRadius = [];
    for (var i = 0, len = 4; i < len; i++) {
      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
    }

    path = 'M' + x + ',' + (y + sign * newRadius[0]);

    if (newRadius[0] > 0) {
      path += 'A ' + newRadius[0] + ',' + newRadius[0] + ',0,0,' + clockWise + ',' + (x + newRadius[0]) + ',' + y;
    }

    path += 'L ' + (x + width - newRadius[1]) + ',' + y;

    if (newRadius[1] > 0) {
      path += 'A ' + newRadius[1] + ',' + newRadius[1] + ',0,0,' + clockWise + ',\n        ' + (x + width) + ',' + (y + sign * newRadius[1]);
    }
    path += 'L ' + (x + width) + ',' + (y + height - sign * newRadius[2]);

    if (newRadius[2] > 0) {
      path += 'A ' + newRadius[2] + ',' + newRadius[2] + ',0,0,' + clockWise + ',\n        ' + (x + width - newRadius[2]) + ',' + (y + height);
    }
    path += 'L ' + (x + newRadius[3]) + ',' + (y + height);

    if (newRadius[3] > 0) {
      path += 'A ' + newRadius[3] + ',' + newRadius[3] + ',0,0,' + clockWise + ',\n        ' + x + ',' + (y + height - sign * newRadius[3]);
    }
    path += 'Z';
  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
    var _newRadius = Math.min(maxRadius, radius);

    path = 'M ' + x + ',' + (y + sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + _newRadius) + ',' + y + '\n            L ' + (x + width - _newRadius) + ',' + y + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width) + ',' + (y + sign * _newRadius) + '\n            L ' + (x + width) + ',' + (y + height - sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width - _newRadius) + ',' + (y + height) + '\n            L ' + (x + _newRadius) + ',' + (y + height) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + x + ',' + (y + height - sign * _newRadius) + ' Z';
  } else {
    path = 'M ' + x + ',' + y + ' h ' + width + ' v ' + height + ' h ' + -width + ' Z';
  }

  return path;
};

var Rectangle = pureRenderDecorator$1(_class$8 = function (_Component) {
  inherits(Rectangle, _Component);

  function Rectangle() {
    var _temp, _this, _ret;

    classCallCheck(this, Rectangle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      totalLength: -1
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  /* eslint-disable  react/no-did-mount-set-state */
  Rectangle.prototype.componentDidMount = function componentDidMount() {
    if (this.node && this.node.getTotalLength) {
      var totalLength = this.node.getTotalLength();

      if (totalLength) {
        this.setState({
          totalLength: totalLength
        });
      }
    }
  };

  Rectangle.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        x = _props.x,
        y = _props.y,
        width = _props.width,
        height = _props.height,
        radius = _props.radius,
        className = _props.className;
    var totalLength = this.state.totalLength;
    var _props2 = this.props,
        animationEasing = _props2.animationEasing,
        animationDuration = _props2.animationDuration,
        animationBegin = _props2.animationBegin,
        isAnimationActive = _props2.isAnimationActive,
        isUpdateAnimationActive = _props2.isUpdateAnimationActive;


    if (x !== +x || y !== +y || width !== +width || height !== +height) {
      return null;
    }

    var layerClass = classNames('recharts-rectangle', className);

    if (!isUpdateAnimationActive) {
      return React__default.createElement('path', _extends({}, getPresentationAttributes(this.props), filterEventAttributes(this.props), {
        className: layerClass,
        d: getRectangePath(x, y, width, height, radius)
      }));
    }

    return React__default.createElement(
      Animate,
      {
        canBegin: totalLength > 0,
        from: { width: width, height: height, x: x, y: y },
        to: { width: width, height: height, x: x, y: y },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
      },
      function (_ref) {
        var currWidth = _ref.width,
            currHeight = _ref.height,
            currX = _ref.x,
            currY = _ref.y;
        return React__default.createElement(
          Animate,
          {
            canBegin: totalLength > 0,
            from: '0px ' + (totalLength === -1 ? 1 : totalLength) + 'px',
            to: totalLength + 'px 0px',
            attributeName: 'strokeDasharray',
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
          },
          React__default.createElement('path', _extends({}, getPresentationAttributes(_this2.props), filterEventAttributes(_this2.props), {
            className: layerClass,
            d: getRectangePath(currX, currY, currWidth, currHeight, radius),
            ref: function ref(node) {
              _this2.node = node;
            }
          }))
        );
      }
    );
  };

  return Rectangle;
}(React.Component)) || _class$8;

Rectangle.displayName = 'Rectangle';
Rectangle.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: false,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};

var _class$9;

/**
 * @fileOverview Polygon
 */
var getPolygonPoints = function getPolygonPoints(points) {
  return points.reduce(function (result, entry) {
    if (entry.x === +entry.x && entry.y === +entry.y) {
      result.push([entry.x, entry.y]);
    }

    return result;
  }, []).join(' ');
};

var Polygon = pureRenderDecorator$1(_class$9 = function (_Component) {
  inherits(Polygon, _Component);

  function Polygon() {
    classCallCheck(this, Polygon);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Polygon.prototype.render = function render() {
    var _props = this.props,
        points = _props.points,
        className = _props.className;


    if (!points || !points.length) {
      return null;
    }

    var layerClass = classNames('recharts-polygon', className);

    return React__default.createElement('polygon', _extends({}, getPresentationAttributes(this.props), filterEventAttributes(this.props), {
      className: layerClass,
      points: getPolygonPoints(points)
    }));
  };

  return Polygon;
}(React.Component)) || _class$9;

Polygon.displayName = 'Polygon';

var _class$10;

/**
 * @fileOverview Dot
 */
var Dot = pureRenderDecorator$1(_class$10 = function (_Component) {
  inherits(Dot, _Component);

  function Dot() {
    classCallCheck(this, Dot);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Dot.prototype.render = function render() {
    var _props = this.props,
        cx = _props.cx,
        cy = _props.cy,
        r = _props.r,
        className = _props.className;

    var layerClass = classNames('recharts-dot', className);

    if (cx === +cx && cy === +cy && r === +r) {
      return React__default.createElement('circle', _extends({}, getPresentationAttributes(this.props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
      }));
    }

    return null;
  };

  return Dot;
}(React.Component)) || _class$10;

Dot.displayName = 'Dot';

var _class$11;

/**
 * @fileOverview Cross
 */
var Cross = pureRenderDecorator$1(_class$11 = function (_Component) {
  inherits(Cross, _Component);

  function Cross() {
    classCallCheck(this, Cross);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Cross.prototype.getPath = function getPath(x, y, width, height, top, left) {
    return 'M' + x + ',' + top + 'v' + height + 'M' + left + ',' + y + 'h' + width;
  };

  Cross.prototype.render = function render() {
    var _props = this.props,
        x = _props.x,
        y = _props.y,
        width = _props.width,
        height = _props.height,
        top = _props.top,
        left = _props.left,
        className = _props.className;


    if (!isNumber(x) || !isNumber(y) || !isNumber(width) || !isNumber(height) || !isNumber(top) || !isNumber(left)) {
      return null;
    }

    return React__default.createElement('path', _extends({}, getPresentationAttributes(this.props), {
      className: classNames('recharts-cross', className),
      d: this.getPath(x, y, width, height, top, left)
    }));
  };

  return Cross;
}(React.Component)) || _class$11;

Cross.displayName = 'Cross';
Cross.defaultProps = {
  x: 0,
  y: 0,
  top: 0,
  left: 0,
  width: 0,
  height: 0
};

var _class$12;

/**
 * @fileOverview Polar Grid
 */
var PolarGrid = pureRenderDecorator$1(_class$12 = function (_Component) {
  inherits(PolarGrid, _Component);

  function PolarGrid() {
    classCallCheck(this, PolarGrid);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  PolarGrid.prototype.getPolygonPath = function getPolygonPath(radius) {
    var _props = this.props,
        cx = _props.cx,
        cy = _props.cy,
        polarAngles = _props.polarAngles;


    var path = '';

    polarAngles.forEach(function (angle, i) {
      var point = polarToCartesian(cx, cy, radius, angle);

      if (i) {
        path += 'L ' + point.x + ',' + point.y;
      } else {
        path += 'M ' + point.x + ',' + point.y;
      }
    });
    path += 'Z';

    return path;
  };
  /**
   * Draw axis of radial line
   * @return {[type]} The lines
   */


  PolarGrid.prototype.renderPolarAngles = function renderPolarAngles() {
    var _props2 = this.props,
        cx = _props2.cx,
        cy = _props2.cy,
        innerRadius = _props2.innerRadius,
        outerRadius = _props2.outerRadius,
        polarAngles = _props2.polarAngles;


    if (!polarAngles || !polarAngles.length) {
      return null;
    }
    var props = _extends({
      stroke: '#ccc'
    }, getPresentationAttributes(this.props));

    return React__default.createElement(
      'g',
      { className: 'recharts-polar-grid-angle' },
      polarAngles.map(function (entry, i) {
        var start = polarToCartesian(cx, cy, innerRadius, entry);
        var end = polarToCartesian(cx, cy, outerRadius, entry);

        return React__default.createElement('line', _extends({}, props, {
          key: 'line-' + i,
          x1: start.x,
          y1: start.y,
          x2: end.x,
          y2: end.y
        }));
      })
    );
  };
  /**
   * Draw concentric circles
   * @param {Number} radius The radius of circle
   * @param {Number} index  The index of circle
   * @param {Object} extraProps Extra props
   * @return {ReactElement} circle
   */


  PolarGrid.prototype.renderConcentricCircle = function renderConcentricCircle(radius, index, extraProps) {
    var _props3 = this.props,
        cx = _props3.cx,
        cy = _props3.cy;

    var props = _extends({
      stroke: '#ccc'
    }, getPresentationAttributes(this.props), {
      fill: 'none'
    }, extraProps);

    return React__default.createElement('circle', _extends({}, props, {
      className: 'recharts-polar-grid-concentric-circle',
      key: 'circle-' + index,
      cx: cx,
      cy: cy,
      r: radius
    }));
  };
  /**
   * Draw concentric polygons
   * @param {Number} radius     The radius of polygon
   * @param {Number} index      The index of polygon
   * @param {Object} extraProps Extra props
   * @return {ReactElement} polygon
   */


  PolarGrid.prototype.renderConcentricPolygon = function renderConcentricPolygon(radius, index, extraProps) {
    var props = _extends({
      stroke: '#ccc'
    }, getPresentationAttributes(this.props), {
      fill: 'none'
    }, extraProps);

    return React__default.createElement('path', _extends({}, props, {
      className: 'recharts-polar-grid-concentric-polygon',
      key: 'path-' + index,
      d: this.getPolygonPath(radius)
    }));
  };

  /**
   * Draw concentric axis
   * @return {ReactElement} Concentric axis
   * @todo Optimize the name
   */


  PolarGrid.prototype.renderConcentricPath = function renderConcentricPath() {
    var _this2 = this;

    var _props4 = this.props,
        polarRadius = _props4.polarRadius,
        gridType = _props4.gridType;


    if (!polarRadius || !polarRadius.length) {
      return null;
    }

    return React__default.createElement(
      'g',
      { className: 'recharts-polar-grid-concentric' },
      polarRadius.map(function (entry, i) {
        return gridType === 'circle' ? _this2.renderConcentricCircle(entry, i) : _this2.renderConcentricPolygon(entry, i);
      })
    );
  };

  PolarGrid.prototype.render = function render() {
    var outerRadius = this.props.outerRadius;


    if (outerRadius <= 0) {
      return null;
    }

    return React__default.createElement(
      'g',
      { className: 'recharts-polar-grid' },
      this.renderPolarAngles(),
      this.renderConcentricPath()
    );
  };

  return PolarGrid;
}(React.Component)) || _class$12;

PolarGrid.displayName = 'PolarGrid';
PolarGrid.defaultProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  gridType: 'polygon'
};

var _class$13;

/**
 * @fileOverview The axis of polar coordinate system
 */
var PolarRadiusAxis = pureRenderDecorator$1(_class$13 = function (_Component) {
  inherits(PolarRadiusAxis, _Component);

  function PolarRadiusAxis() {
    classCallCheck(this, PolarRadiusAxis);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * Calculate the coordinate of tick
   * @param  {Object} radius The data of a simple tick
   * @return {Object} (x, y)
   */
  PolarRadiusAxis.prototype.getTickValueCoord = function getTickValueCoord(_ref) {
    var radius = _ref.radius;
    var _props = this.props,
        angle = _props.angle,
        cx = _props.cx,
        cy = _props.cy;


    return polarToCartesian(cx, cy, radius, angle);
  };

  PolarRadiusAxis.prototype.getTickTextAnchor = function getTickTextAnchor() {
    var orientation = this.props.orientation;

    var textAnchor = void 0;

    switch (orientation) {
      case 'left':
        textAnchor = 'end';
        break;
      case 'right':
        textAnchor = 'start';
        break;
      default:
        textAnchor = 'middle';
        break;
    }

    return textAnchor;
  };

  PolarRadiusAxis.prototype.renderAxisLine = function renderAxisLine() {
    var _props2 = this.props,
        cx = _props2.cx,
        cy = _props2.cy,
        angle = _props2.angle,
        ticks = _props2.ticks,
        axisLine = _props2.axisLine,
        others = objectWithoutProperties(_props2, ['cx', 'cy', 'angle', 'ticks', 'axisLine']);

    var extent = ticks.reduce(function (result, entry) {
      return [Math.min(result[0], entry.radius), Math.max(result[1], entry.radius)];
    }, [Infinity, -Infinity]);
    var point0 = polarToCartesian(cx, cy, extent[0], angle);
    var point1 = polarToCartesian(cx, cy, extent[1], angle);

    var props = _extends({}, getPresentationAttributes(others), {
      fill: 'none'
    }, getPresentationAttributes(axisLine), {
      x1: point0.x,
      y1: point0.y,
      x2: point1.x,
      y2: point1.y
    });

    return React__default.createElement('line', _extends({ className: 'recharts-polar-radius-axis-line' }, props));
  };

  PolarRadiusAxis.prototype.renderTickItem = function renderTickItem(option, props, value) {
    var tickItem = void 0;

    if (React__default.isValidElement(option)) {
      tickItem = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      tickItem = option(props);
    } else {
      tickItem = React__default.createElement(
        Text,
        _extends({}, props, {
          className: 'recharts-polar-radius-axis-tick-value'
        }),
        value
      );
    }

    return tickItem;
  };

  PolarRadiusAxis.prototype.renderTicks = function renderTicks() {
    var _this2 = this;

    var _props3 = this.props,
        ticks = _props3.ticks,
        tick = _props3.tick,
        angle = _props3.angle,
        tickFormatter = _props3.tickFormatter,
        stroke = _props3.stroke,
        others = objectWithoutProperties(_props3, ['ticks', 'tick', 'angle', 'tickFormatter', 'stroke']);

    var textAnchor = this.getTickTextAnchor();
    var axisProps = getPresentationAttributes(others);
    var customTickProps = getPresentationAttributes(tick);

    var items = ticks.map(function (entry, i) {
      var coord = _this2.getTickValueCoord(entry);
      var tickProps = _extends({
        textAnchor: textAnchor,
        transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
      }, axisProps, {
        stroke: 'none', fill: stroke
      }, customTickProps, {
        index: i
      }, coord, {
        payload: entry
      });

      return React__default.createElement(
        Layer,
        _extends({
          className: 'recharts-polar-radius-axis-tick',
          key: 'tick-' + i
        }, filterEventsOfChild(_this2.props, entry, i)),
        _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
      );
    });

    return React__default.createElement(
      Layer,
      { className: 'recharts-polar-radius-axis-ticks' },
      items
    );
  };

  PolarRadiusAxis.prototype.renderLabel = function renderLabel() {
    var label = this.props.label;
    var _props4 = this.props,
        ticks = _props4.ticks,
        angle = _props4.angle,
        stroke = _props4.stroke,
        others = objectWithoutProperties(_props4, ['ticks', 'angle', 'stroke']);

    var maxRadiusTick = ___default.maxBy(ticks, function (entry) {
      return entry.radius || 0;
    });
    var radius = maxRadiusTick.radius || 0;
    var coord = this.getTickValueCoord({ radius: radius + 10 });
    var props = _extends({}, others, {
      stroke: 'none',
      fill: stroke
    }, coord, {
      textAnchor: 'middle',
      transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
    });

    if (React__default.isValidElement(label)) {
      return React__default.cloneElement(label, props);
    } else if (___default.isFunction(label)) {
      return label(props);
    } else if (isNumOrStr(label)) {
      return React__default.createElement(
        Layer,
        { className: 'recharts-polar-radius-axis-label' },
        React__default.createElement(
          Text,
          props,
          label
        )
      );
    }

    return null;
  };

  PolarRadiusAxis.prototype.render = function render() {
    var _props5 = this.props,
        ticks = _props5.ticks,
        axisLine = _props5.axisLine,
        tick = _props5.tick;


    if (!ticks || !ticks.length) {
      return null;
    }

    return React__default.createElement(
      Layer,
      { className: 'recharts-polar-radius-axis' },
      axisLine && this.renderAxisLine(),
      tick && this.renderTicks(),
      this.renderLabel()
    );
  };

  return PolarRadiusAxis;
}(React.Component)) || _class$13;

PolarRadiusAxis.displayName = 'PolarRadiusAxis';
PolarRadiusAxis.defaultProps = {
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: 'right',
  stroke: '#ccc',
  axisLine: true,
  tick: true,
  tickCount: 5,
  domain: [0, 'auto'],
  allowDataOverflow: false,
  scale: 'auto'
};

var _class$14;

/**
 * @fileOverview Axis of radial direction
 */
var RADIAN$2 = Math.PI / 180;
var eps = 1e-5;

var PolarAngleAxis = pureRenderDecorator$1(_class$14 = function (_Component) {
  inherits(PolarAngleAxis, _Component);

  function PolarAngleAxis() {
    classCallCheck(this, PolarAngleAxis);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  /**
   * Calculate the coordinate of line endpoint
   * @param  {Object} data The Data if ticks
   * @return {Object} (x0, y0): The start point of text,
   *                  (x1, y1): The end point close to text,
   *                  (x2, y2): The end point close to axis
   */
  PolarAngleAxis.prototype.getTickLineCoord = function getTickLineCoord(data) {
    var _props = this.props,
        cx = _props.cx,
        cy = _props.cy,
        radius = _props.radius,
        orientation = _props.orientation,
        tickLine = _props.tickLine;

    var tickLineSize = tickLine && tickLine.size || 8;
    var p1 = polarToCartesian(cx, cy, radius, data.angle);
    var p2 = polarToCartesian(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.angle);

    return { x1: p1.x, y1: p1.y, x2: p2.x, y2: p2.y };
  };
  /**
   * Get the text-anchor of each tick
   * @param  {Object} data Data of ticks
   * @return {String} text-anchor
   */


  PolarAngleAxis.prototype.getTickTextAnchor = function getTickTextAnchor(data) {
    var orientation = this.props.orientation;

    var cos = Math.cos(-data.angle * RADIAN$2);
    var textAnchor = void 0;

    if (cos > eps) {
      textAnchor = orientation === 'outer' ? 'start' : 'end';
    } else if (cos < -eps) {
      textAnchor = orientation === 'outer' ? 'end' : 'start';
    } else {
      textAnchor = 'middle';
    }

    return textAnchor;
  };

  PolarAngleAxis.prototype.renderAxisLine = function renderAxisLine() {
    var _props2 = this.props,
        cx = _props2.cx,
        cy = _props2.cy,
        radius = _props2.radius,
        axisLine = _props2.axisLine,
        axisLineType = _props2.axisLineType;

    var props = _extends({}, getPresentationAttributes(this.props), {
      fill: 'none'
    }, getPresentationAttributes(axisLine));

    if (axisLineType === 'circle') {
      return React__default.createElement(Dot, _extends({
        className: 'recharts-polar-angle-axis-line'
      }, props, {
        cx: cx,
        cy: cy,
        r: radius
      }));
    }
    var ticks = this.props.ticks;

    var points = ticks.map(function (entry) {
      return polarToCartesian(cx, cy, radius, entry.angle);
    });

    return React__default.createElement(Polygon, _extends({ className: 'recharts-polar-angle-axis-line' }, props, { points: points }));
  };

  PolarAngleAxis.prototype.renderTickItem = function renderTickItem(option, props, value) {
    var tickItem = void 0;

    if (React__default.isValidElement(option)) {
      tickItem = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      tickItem = option(props);
    } else {
      tickItem = React__default.createElement(
        Text,
        _extends({}, props, {
          className: 'recharts-polar-angle-axis-tick-value'
        }),
        value
      );
    }

    return tickItem;
  };

  PolarAngleAxis.prototype.renderTicks = function renderTicks() {
    var _this2 = this;

    var _props3 = this.props,
        ticks = _props3.ticks,
        tick = _props3.tick,
        tickLine = _props3.tickLine,
        tickFormatter = _props3.tickFormatter,
        stroke = _props3.stroke;

    var axisProps = getPresentationAttributes(this.props);
    var customTickProps = getPresentationAttributes(tick);
    var tickLineProps = _extends({}, axisProps, { fill: 'none' }, getPresentationAttributes(tickLine));

    var items = ticks.map(function (entry, i) {
      var lineCoord = _this2.getTickLineCoord(entry);
      var textAnchor = _this2.getTickTextAnchor(entry);
      var tickProps = _extends({
        textAnchor: textAnchor
      }, axisProps, {
        stroke: 'none', fill: stroke
      }, customTickProps, {
        index: i, payload: entry,
        x: lineCoord.x2, y: lineCoord.y2
      });

      return React__default.createElement(
        Layer,
        _extends({
          className: 'recharts-polar-angle-axis-tick',
          key: 'tick-' + i
        }, filterEventsOfChild(_this2.props, entry, i)),
        tickLine && React__default.createElement('line', _extends({
          className: 'recharts-polar-angle-axis-tick-line'
        }, tickLineProps, lineCoord)),
        tick && _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
      );
    });

    return React__default.createElement(
      Layer,
      { className: 'recharts-polar-angle-axis-ticks' },
      items
    );
  };

  PolarAngleAxis.prototype.render = function render() {
    var _props4 = this.props,
        ticks = _props4.ticks,
        radius = _props4.radius,
        axisLine = _props4.axisLine;


    if (radius <= 0 || !ticks || !ticks.length) {
      return null;
    }

    return React__default.createElement(
      Layer,
      { className: 'recharts-polar-angle-axis' },
      axisLine && this.renderAxisLine(),
      this.renderTicks()
    );
  };

  return PolarAngleAxis;
}(React.Component)) || _class$14;

PolarAngleAxis.displayName = 'PolarAngleAxis';
PolarAngleAxis.defaultProps = {
  cx: 0,
  cy: 0,
  orientation: 'outer',
  axisLine: true,
  tickLine: true,
  tick: true,
  hide: false
};

var AnimationDecorator = function (WrappedComponent) {
  var AnimationDecorator = function (_Component) {
    inherits(AnimationDecorator, _Component);

    function AnimationDecorator() {
      var _temp, _this, _ret;

      classCallCheck(this, AnimationDecorator);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
        animationId: 0
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    AnimationDecorator.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var animationId = this.state.animationId;


      if (this.props.data !== nextProps.data) {
        this.setState({
          animationId: animationId + 1
        });
      }
    };

    AnimationDecorator.prototype.render = function render() {
      return React__default.createElement(WrappedComponent, _extends({}, this.props, { animationId: this.state.animationId }));
    };

    return AnimationDecorator;
  }(React.Component);

  AnimationDecorator.displayName = 'AnimationDecorator(' + getDisplayName(WrappedComponent) + ')';
  AnimationDecorator.WrappedComponent = WrappedComponent;
  AnimationDecorator.defaultProps = WrappedComponent.defaultProps;


  return AnimationDecorator;
};

var _class$15;

/**
 * @fileOverview Render sectors of a pie
 */
var Pie = AnimationDecorator(_class$15 = pureRenderDecorator$1(_class$15 = function (_Component) {
  inherits(Pie, _Component);

  function Pie() {
    var _temp, _this, _ret;

    classCallCheck(this, Pie);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = uniqueId('recharts-pie-'), _this.handleAnimationEnd = function () {
      _this.setState({
        isAnimationFinished: true
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Pie.prototype.getDeltaAngle = function getDeltaAngle() {
    var _props = this.props,
        startAngle = _props.startAngle,
        endAngle = _props.endAngle;

    var sign = Math.sign(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);

    return sign * deltaAngle;
  };

  Pie.prototype.getSectors = function getSectors(data) {
    var _props2 = this.props,
        cx = _props2.cx,
        cy = _props2.cy,
        innerRadius = _props2.innerRadius,
        outerRadius = _props2.outerRadius,
        cornerRadius = _props2.cornerRadius,
        startAngle = _props2.startAngle,
        paddingAngle = _props2.paddingAngle,
        minAngle = _props2.minAngle,
        nameKey = _props2.nameKey,
        valueKey = _props2.valueKey;

    var len = data.length;
    var deltaAngle = this.getDeltaAngle();
    var absDeltaAngle = Math.abs(deltaAngle);
    var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
    var sum = data.reduce(function (result, entry) {
      return result + getValueByDataKey(entry, valueKey, 0);
    }, 0);

    var sectors = [];
    var prev = void 0;

    if (sum > 0) {
      sectors = data.map(function (entry, i) {
        var percent = getValueByDataKey(entry, valueKey, 0) / sum;

        var tempStartAngle = void 0;

        if (i) {
          tempStartAngle = (deltaAngle < 0 ? prev.endAngle : prev.startAngle) + Math.sign(deltaAngle) * paddingAngle;
        } else {
          tempStartAngle = startAngle;
        }

        var tempEndAngle = tempStartAngle + Math.sign(deltaAngle) * (minAngle + percent * (absDeltaAngle - len * minAngle - totalPadingAngle));

        prev = _extends({
          percent: percent,
          cornerRadius: cornerRadius
        }, entry, {
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          name: getValueByDataKey(entry, nameKey),
          value: getValueByDataKey(entry, valueKey),
          startAngle: deltaAngle < 0 ? tempStartAngle : tempEndAngle,
          endAngle: deltaAngle < 0 ? tempEndAngle : tempStartAngle,
          midAngle: (tempStartAngle + tempEndAngle) / 2
        });

        return prev;
      });
    }

    return sectors;
  };

  Pie.prototype.getTextAnchor = function getTextAnchor(x, cx) {
    if (x > cx) {
      return 'start';
    } else if (x < cx) {
      return 'end';
    }

    return 'middle';
  };

  Pie.prototype.isActiveIndex = function isActiveIndex(i) {
    var activeIndex = this.props.activeIndex;


    if (Array.isArray(activeIndex)) {
      return activeIndex.indexOf(i) !== -1;
    }

    return i === activeIndex;
  };

  Pie.prototype.renderClipPath = function renderClipPath() {
    var _props3 = this.props,
        cx = _props3.cx,
        cy = _props3.cy,
        maxRadius = _props3.maxRadius,
        startAngle = _props3.startAngle,
        isAnimationActive = _props3.isAnimationActive,
        animationDuration = _props3.animationDuration,
        animationEasing = _props3.animationEasing,
        animationBegin = _props3.animationBegin,
        animationId = _props3.animationId;


    return React__default.createElement(
      'defs',
      null,
      React__default.createElement(
        'clipPath',
        { id: this.id },
        React__default.createElement(
          Animate,
          {
            easing: animationEasing,
            isActive: isAnimationActive,
            duration: animationDuration,
            key: animationId,
            animationBegin: animationBegin,
            onAnimationEnd: this.handleAnimationEnd,
            from: {
              endAngle: startAngle
            },
            to: {
              outerRadius: Math.max(this.props.outerRadius, maxRadius || 0),
              innerRadius: 0,
              endAngle: this.props.endAngle
            }
          },
          function (_ref) {
            var outerRadius = _ref.outerRadius,
                innerRadius = _ref.innerRadius,
                endAngle = _ref.endAngle;
            return React__default.createElement(Sector, {
              cx: cx,
              cy: cy,
              outerRadius: outerRadius,
              innerRadius: innerRadius,
              startAngle: startAngle,
              endAngle: endAngle
            });
          }
        )
      )
    );
  };

  Pie.prototype.renderLabelLineItem = function renderLabelLineItem(option, props) {
    if (React__default.isValidElement(option)) {
      return React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      return option(props);
    }

    return React__default.createElement(Curve, _extends({}, props, { type: 'linear', className: 'recharts-pie-label-line' }));
  };

  Pie.prototype.renderLabelItem = function renderLabelItem(option, props, value) {
    if (React__default.isValidElement(option)) {
      return React__default.cloneElement(option, props);
    }
    var label = value;
    if (___default.isFunction(option)) {
      label = option(props);
      if (React__default.isValidElement(label)) {
        return label;
      }
    }

    return React__default.createElement(
      Text,
      _extends({}, props, {
        alignmentBaseline: 'middle',
        className: 'recharts-pie-label-text'
      }),
      label
    );
  };

  Pie.prototype.renderLabels = function renderLabels(sectors) {
    var _this2 = this;

    var isAnimationActive = this.props.isAnimationActive;


    if (isAnimationActive && !this.state.isAnimationFinished) {
      return null;
    }
    var _props4 = this.props,
        label = _props4.label,
        labelLine = _props4.labelLine,
        valueKey = _props4.valueKey;

    var pieProps = getPresentationAttributes(this.props);
    var customLabelProps = getPresentationAttributes(label);
    var customLabelLineProps = getPresentationAttributes(labelLine);
    var offsetRadius = label && label.offsetRadius || 20;

    var labels = sectors.map(function (entry, i) {
      var midAngle = (entry.startAngle + entry.endAngle) / 2;
      var endPoint = polarToCartesian(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
      var labelProps = _extends({}, pieProps, entry, {
        stroke: 'none'
      }, customLabelProps, {
        index: i,
        textAnchor: _this2.getTextAnchor(endPoint.x, entry.cx)
      }, endPoint);
      var lineProps = _extends({}, pieProps, entry, {
        fill: 'none',
        stroke: entry.fill
      }, customLabelLineProps, {
        points: [polarToCartesian(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint]
      });

      return React__default.createElement(
        Layer,
        { key: 'label-' + i },
        labelLine && _this2.renderLabelLineItem(labelLine, lineProps),
        _this2.renderLabelItem(label, labelProps, getValueByDataKey(entry, valueKey))
      );
    });

    return React__default.createElement(
      Layer,
      { className: 'recharts-pie-labels' },
      labels
    );
  };

  Pie.prototype.renderSectorItem = function renderSectorItem(option, props) {
    if (React__default.isValidElement(option)) {
      return React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      return option(props);
    } else if (___default.isPlainObject(option)) {
      return React__default.createElement(Sector, _extends({}, props, option));
    }

    return React__default.createElement(Sector, props);
  };

  Pie.prototype.renderSectors = function renderSectors(sectors) {
    var _this3 = this;

    var activeShape = this.props.activeShape;


    return sectors.map(function (entry, i) {
      return React__default.createElement(
        Layer,
        _extends({
          className: 'recharts-pie-sector'
        }, filterEventsOfChild(_this3.props, entry, i), {
          key: 'sector-' + i
        }),
        _this3.renderSectorItem(_this3.isActiveIndex(i) ? activeShape : null, entry)
      );
    });
  };

  Pie.prototype.render = function render() {
    var _props5 = this.props,
        data = _props5.data,
        composedData = _props5.composedData,
        className = _props5.className,
        label = _props5.label,
        cx = _props5.cx,
        cy = _props5.cy,
        innerRadius = _props5.innerRadius,
        outerRadius = _props5.outerRadius;

    var pieData = composedData || data;

    if (!pieData || !pieData.length || !isNumber(cx) || !isNumber(cy) || !isNumber(innerRadius) || !isNumber(outerRadius)) {
      return null;
    }

    var sectors = this.getSectors(pieData);
    var layerClass = classNames('recharts-pie', className);

    return React__default.createElement(
      Layer,
      { className: layerClass },
      this.renderClipPath(),
      React__default.createElement(
        'g',
        { clipPath: 'url(#' + this.id + ')' },
        this.renderSectors(sectors)
      ),
      label && this.renderLabels(sectors)
    );
  };

  return Pie;
}(React.Component)) || _class$15) || _class$15;

Pie.displayName = 'Pie';
Pie.defaultProps = {
  stroke: '#fff',
  fill: '#808080',
  legendType: 'rect',
  // The abscissa of pole
  cx: '50%',
  // The ordinate of pole
  cy: '50%',
  // The start angle of first sector
  startAngle: 0,
  // The direction of drawing sectors
  endAngle: 360,
  // The inner radius of sectors
  innerRadius: 0,
  // The outer radius of sectors
  outerRadius: '80%',
  paddingAngle: 0,
  nameKey: 'name',
  valueKey: 'value',
  labelLine: true,
  data: [],
  minAngle: 0,
  isAnimationActive: !isSsr(),
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: 'ease'
};

var _class$16;

/**
 * @fileOverview Radar
 */
var Radar = pureRenderDecorator$1(_class$16 = function (_Component) {
  inherits(Radar, _Component);

  function Radar() {
    var _temp, _this, _ret;

    classCallCheck(this, Radar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleMouseEnter = function (e) {
      var onMouseEnter = _this.props.onMouseEnter;


      if (onMouseEnter) {
        onMouseEnter(_this.props, e);
      }
    }, _this.handleMouseLeave = function (e) {
      var onMouseLeave = _this.props.onMouseLeave;


      if (onMouseLeave) {
        onMouseLeave(_this.props, e);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Radar.prototype.renderPolygon = function renderPolygon() {
    /* eslint-disable no-unused-vars */
    var _props = this.props,
        shape = _props.shape,
        points = _props.points,
        animationDuration = _props.animationDuration,
        animationEasing = _props.animationEasing,
        animationBegin = _props.animationBegin,
        isAnimationActive = _props.isAnimationActive,
        animationId = _props.animationId,
        dataKey = _props.dataKey,
        className = _props.className,
        others = objectWithoutProperties(_props, ['shape', 'points', 'animationDuration', 'animationEasing', 'animationBegin', 'isAnimationActive', 'animationId', 'dataKey', 'className']);
    /* eslint-enable no-unused-vars */

    if (React__default.isValidElement(shape)) {
      return React__default.cloneElement(shape, _extends({}, others, { points: points }));
    } else if (___default.isFunction(shape)) {
      return shape(this.props);
    }

    var point = points[0];
    var transformPoints = points.map(function (p) {
      return { x: p.x - point.cx, y: p.y - point.cy };
    });

    return React__default.createElement(
      Layer,
      { className: 'recharts-radar-polygon', transform: 'translate(' + point.cx + ', ' + point.cy + ')' },
      React__default.createElement(
        Animate,
        {
          from: 'scale(0)',
          to: 'scale(1)',
          attributeName: 'transform',
          isActive: isAnimationActive,
          begin: animationBegin,
          easing: animationEasing,
          duration: animationDuration,
          key: animationId
        },
        React__default.createElement(Polygon, _extends({
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        }, getPresentationAttributes(this.props), {
          points: transformPoints
        }))
      )
    );
  };

  Radar.prototype.renderLabelItem = function renderLabelItem(option, props, value) {
    var labelItem = void 0;

    if (React__default.isValidElement(option)) {
      labelItem = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      labelItem = option(props);
    } else {
      labelItem = React__default.createElement(
        Text,
        _extends({
          key: props.key
        }, props, {
          className: 'recharts-radar-label'
        }),
        value
      );
    }

    return labelItem;
  };

  Radar.prototype.renderLabels = function renderLabels() {
    var _this2 = this;

    var _props2 = this.props,
        points = _props2.points,
        label = _props2.label;

    var baseProps = getPresentationAttributes(this.props);
    var customLabelProps = getPresentationAttributes(label);

    var labels = points.map(function (entry, i) {
      var labelProps = _extends({
        textAnchor: 'middle'
      }, baseProps, {
        stroke: 'none',
        fill: baseProps && baseProps.stroke || '#666'
      }, customLabelProps, entry, {
        index: i,
        key: 'label-' + i,
        payload: entry
      });

      return _this2.renderLabelItem(label, labelProps, entry.value);
    });

    return React__default.createElement(
      Layer,
      { className: 'recharts-radar-labels' },
      labels
    );
  };

  Radar.prototype.renderDotItem = function renderDotItem(option, props) {
    var dotItem = void 0;

    if (React__default.isValidElement(option)) {
      dotItem = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      dotItem = option(props);
    } else {
      dotItem = React__default.createElement(Dot, _extends({}, props, { className: 'recharts-radar-dot' }));
    }

    return dotItem;
  };

  Radar.prototype.renderDots = function renderDots() {
    var _this3 = this;

    var _props3 = this.props,
        dot = _props3.dot,
        points = _props3.points;

    var baseProps = getPresentationAttributes(this.props);
    var customDotProps = getPresentationAttributes(dot);

    var dots = points.map(function (entry, i) {
      var dotProps = _extends({
        key: 'dot-' + i,
        r: 3
      }, baseProps, customDotProps, {
        cx: entry.x,
        cy: entry.y,
        index: i,
        playload: entry
      });

      return _this3.renderDotItem(dot, dotProps);
    });

    return React__default.createElement(
      Layer,
      { className: 'recharts-radar-dots' },
      dots
    );
  };

  Radar.prototype.render = function render() {
    var _props4 = this.props,
        className = _props4.className,
        points = _props4.points,
        label = _props4.label,
        dot = _props4.dot;


    if (!points || !points.length) {
      return null;
    }

    var layerClass = classNames('recharts-radar', className);

    return React__default.createElement(
      Layer,
      { className: layerClass },
      this.renderPolygon(),
      label && this.renderLabels(),
      dot && this.renderDots()
    );
  };

  return Radar;
}(React.Component)) || _class$16;

Radar.displayName = 'Radar';
Radar.defaultProps = {
  dot: false,
  label: false,
  legendType: 'rect',
  isAnimationActive: !isSsr(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};

var _class$17;

/**
 * @fileOverview Render a group of radial bar
 */
var RADIAN$3 = Math.PI / 180;

var RadialBar = pureRenderDecorator$1(_class$17 = function (_Component) {
  inherits(RadialBar, _Component);

  function RadialBar() {
    var _temp, _this, _ret;

    classCallCheck(this, RadialBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      isAnimationFinished: false
    }, _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  RadialBar.prototype.getDeltaAngle = function getDeltaAngle() {
    var _props = this.props,
        startAngle = _props.startAngle,
        endAngle = _props.endAngle;

    var sign = Math.sign(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);

    return sign * deltaAngle;
  };

  RadialBar.prototype.getSectors = function getSectors() {
    var _props2 = this.props,
        cx = _props2.cx,
        cy = _props2.cy,
        startAngle = _props2.startAngle,
        data = _props2.data,
        minAngle = _props2.minAngle,
        maxAngle = _props2.maxAngle;

    var maxValue = Math.max.apply(null, data.map(function (entry) {
      return Math.abs(entry.value);
    }));
    var absMinAngle = Math.abs(minAngle);
    var absMaxAngle = Math.abs(maxAngle);
    var deltaAngle = this.getDeltaAngle();
    var gapAngle = Math.min(Math.abs(absMaxAngle - absMinAngle), 360);

    var sectors = data.map(function (entry) {
      var value = entry.value;
      var tempEndAngle = maxValue === 0 ? startAngle : startAngle + Math.sign(value * deltaAngle) * (absMinAngle + gapAngle * Math.abs(entry.value) / maxValue);

      return _extends({}, entry, {
        cx: cx, cy: cy,
        startAngle: startAngle,
        endAngle: tempEndAngle,
        payload: entry
      });
    });

    return sectors;
  };

  RadialBar.prototype.getLabelPathArc = function getLabelPathArc(data, labelContent, style) {
    var label = this.props.label;

    var labelProps = React__default.isValidElement(label) ? label.props : label;
    var offsetRadius = labelProps.offsetRadius || 2;
    var orientation = labelProps.orientation || 'inner';
    var cx = data.cx,
        cy = data.cy,
        innerRadius = data.innerRadius,
        outerRadius = data.outerRadius,
        startAngle = data.startAngle,
        endAngle = data.endAngle;

    var clockWise = this.getDeltaAngle() < 0 && data.value > 0;
    var radius = clockWise ? innerRadius + offsetRadius : Math.max(outerRadius - offsetRadius, 0);

    if (radius <= 0) {
      return '';
    }

    var labelSize = getStringSize(labelContent, style);
    var deltaAngle = labelSize.width / (radius * RADIAN$3);
    var tempStartAngle = void 0,
        tempEndAngle = void 0;

    if (clockWise) {
      tempStartAngle = orientation === 'inner' ? Math.min(endAngle + deltaAngle, startAngle) : endAngle;
      tempEndAngle = tempStartAngle - deltaAngle;
    } else {
      tempStartAngle = orientation === 'inner' ? Math.max(endAngle - deltaAngle, startAngle) : endAngle;
      tempEndAngle = tempStartAngle + deltaAngle;
    }

    var startPoint = polarToCartesian(cx, cy, radius, tempStartAngle);
    var endPoint = polarToCartesian(cx, cy, radius, tempEndAngle);

    return 'M' + startPoint.x + ',' + startPoint.y + '\n            A' + radius + ',' + radius + ',0,\n            ' + (deltaAngle >= 180 ? 1 : 0) + ',\n            ' + (clockWise ? 1 : 0) + ',\n            ' + endPoint.x + ',' + endPoint.y;
  };

  RadialBar.prototype.renderSectorShape = function renderSectorShape(shape, props) {
    var sectorShape = void 0;

    if (React__default.isValidElement(shape)) {
      sectorShape = React__default.cloneElement(shape, props);
    } else if (___default.isFunction(shape)) {
      sectorShape = shape(props);
    } else {
      sectorShape = React__default.createElement(Sector, props);
    }

    return sectorShape;
  };

  RadialBar.prototype.renderSectors = function renderSectors(sectors) {
    var _this2 = this;

    var _props3 = this.props,
        shape = _props3.shape,
        activeShape = _props3.activeShape,
        activeIndex = _props3.activeIndex,
        cornerRadius = _props3.cornerRadius;
    var _props4 = this.props,
        animationEasing = _props4.animationEasing,
        animationDuration = _props4.animationDuration,
        animationBegin = _props4.animationBegin,
        isAnimationActive = _props4.isAnimationActive;

    var baseProps = getPresentationAttributes(this.props);

    return sectors.map(function (entry, i) {
      var startAngle = entry.startAngle,
          endAngle = entry.endAngle;


      return React__default.createElement(
        Animate,
        {
          from: { angle: startAngle },
          to: { angle: endAngle },
          begin: animationBegin,
          isActive: isAnimationActive,
          duration: animationDuration,
          easing: animationEasing,
          shouldReAnimate: true,
          key: 'aniamte-' + i,
          onAnimationStart: _this2.handleAnimationStart,
          onAnimationEnd: _this2.handleAnimationEnd
        },
        function (_ref) {
          var angle = _ref.angle;

          var props = _extends({}, baseProps, {
            cornerRadius: cornerRadius
          }, entry, filterEventsOfChild(_this2.props, entry, i), {
            endAngle: angle,
            key: 'sector-' + i,
            className: 'recharts-radial-bar-sector'
          });

          return _this2.renderSectorShape(i === activeIndex ? activeShape : shape, props);
        }
      );
    });
  };

  RadialBar.prototype.renderBackground = function renderBackground(sectors) {
    var _this3 = this;

    var _props5 = this.props,
        startAngle = _props5.startAngle,
        endAngle = _props5.endAngle,
        background = _props5.background,
        cornerRadius = _props5.cornerRadius;

    var backgroundProps = getPresentationAttributes(background);

    return sectors.map(function (entry, i) {
      // eslint-disable-next-line no-unused-vars
      var value = entry.value,
          rest = objectWithoutProperties(entry, ['value']);

      var props = _extends({
        cornerRadius: cornerRadius
      }, rest, {
        fill: '#eee'
      }, backgroundProps, filterEventsOfChild(_this3.props, entry, i), {
        startAngle: startAngle,
        endAngle: endAngle,
        index: i,
        key: 'sector-' + i,
        className: 'recharts-radial-bar-background-sector'
      });

      return _this3.renderSectorShape(background, props);
    });
  };

  RadialBar.prototype.renderLabelItem = function renderLabelItem(option, props, value) {
    var labelItem = void 0;

    if (React__default.isValidElement(option)) {
      labelItem = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      labelItem = option(props);
    } else {
      var id = uniqueId('recharts-defs-');
      var filteredProps = getPresentationAttributes(props);
      var path = this.getLabelPathArc(props, value, filteredProps);

      labelItem = React__default.createElement(
        'text',
        _extends({}, filteredProps, { key: props.key, className: 'recharts-radial-bar-label' }),
        React__default.createElement(
          'defs',
          null,
          React__default.createElement('path', { id: id, d: path })
        ),
        React__default.createElement(
          'textPath',
          { xlinkHref: '#' + id },
          value
        )
      );
    }

    return labelItem;
  };

  RadialBar.prototype.renderLabels = function renderLabels(sectors) {
    var _this4 = this;

    var isAnimationActive = this.props.isAnimationActive;

    if (isAnimationActive && !this.state.isAnimationFinished) {
      return null;
    }

    var label = this.props.label;


    return sectors.map(function (entry, i) {
      var props = _extends({
        fontSize: 10
      }, entry, getPresentationAttributes(label), {
        index: i,
        key: 'label-' + i
      });

      return _this4.renderLabelItem(label, props, entry.value);
    });
  };

  RadialBar.prototype.render = function render() {
    var _props6 = this.props,
        data = _props6.data,
        className = _props6.className,
        background = _props6.background,
        label = _props6.label;


    if (!data || !data.length) {
      return null;
    }

    var sectors = this.getSectors();
    var layerClass = classNames('recharts-area', className);

    return React__default.createElement(
      Layer,
      { className: layerClass },
      background && React__default.createElement(
        Layer,
        { className: 'recharts-radial-bar-background' },
        this.renderBackground(sectors)
      ),
      React__default.createElement(
        Layer,
        { className: 'recharts-radial-bar-sectors' },
        this.renderSectors(sectors)
      ),
      label && React__default.createElement(
        Layer,
        { className: 'recharts-radial-bar-labels' },
        this.renderLabels(sectors)
      )
    );
  };

  return RadialBar;
}(React.Component)) || _class$17;

RadialBar.displayName = 'RadialBar';
RadialBar.defaultProps = {
  startAngle: 180,
  endAngle: 0,
  maxAngle: 135,
  minAngle: 0,
  legendType: 'rect',
  data: [],
  isAnimationActive: !isSsr(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};

var _class$18;

/**
 * @fileOverview Brush
 */
var Brush = pureRenderDecorator$1(_class$18 = function (_Component) {
  inherits(Brush, _Component);

  function Brush(props) {
    classCallCheck(this, Brush);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleDrag = function (e) {
      if (_this.leaveTimer) {
        clearTimeout(_this.leaveTimer);
        _this.leaveTimer = null;
      }

      if (_this.state.isTravellerMoving) {
        _this.handleTravellerMove(e);
      } else if (_this.state.isSlideMoving) {
        _this.handleSlideDrag(e);
      }
    };

    _this.handleTouchMove = function (e) {
      if (e.changedTouches != null && e.changedTouches.length > 0) {
        _this.handleDrag(e.changedTouches[0]);
      }
    };

    _this.handleDragEnd = function () {
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: false
      });
    };

    _this.handleLeaveWrapper = function () {
      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
        _this.leaveTimer = setTimeout(_this.handleDragEnd, 1000);
      }
    };

    _this.handleEnterSlideOrTraveller = function () {
      _this.setState({
        isTextActive: true
      });
    };

    _this.handleLeaveSlideOrTraveller = function () {
      _this.setState({
        isTextActive: false
      });
    };

    _this.handleSlideDragStart = function (e) {
      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;

      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: true,
        slideMoveStartX: event.pageX
      });
    };

    _this.travellerDragStartHandlers = {
      startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
      endX: _this.handleTravellerDragStart.bind(_this, 'endX')
    };

    if (props.data && props.data.length) {
      _this.updateScale(props);
    } else {
      _this.state = {};
    }
    return _this;
  }

  Brush.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var _props = this.props,
        data = _props.data,
        width = _props.width,
        x = _props.x,
        travellerWidth = _props.travellerWidth,
        updateId = _props.updateId;


    if (nextProps.data !== data || nextProps.updateId !== updateId) {
      this.updateScale(nextProps);
    } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
      this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
      this.scaleValues = this.scale.domain().map(function (entry) {
        return _this2.scale(entry);
      });

      this.setState({
        startX: this.scale(nextProps.startIndex),
        endX: this.scale(nextProps.endIndex)
      });
    }
  };

  Brush.prototype.componentWillUnmount = function componentWillUnmount() {
    this.scale = null;
    this.scaleValues = null;

    if (this.leaveTimer) {
      clearTimeout(this.leaveTimer);
      this.leaveTimer = null;
    }
  };

  Brush.prototype.getIndexInRange = function getIndexInRange(range, x) {
    var len = range.length;
    var start = 0;
    var end = len - 1;

    while (end - start > 1) {
      var middle = Math.floor((start + end) / 2);

      if (range[middle] > x) {
        end = middle;
      } else {
        start = middle;
      }
    }

    return x >= range[end] ? end : start;
  };

  Brush.prototype.getIndex = function getIndex(_ref) {
    var startX = _ref.startX,
        endX = _ref.endX;

    var min = Math.min(startX, endX);
    var max = Math.max(startX, endX);
    var minIndex = this.getIndexInRange(this.scaleValues, min);
    var maxIndex = this.getIndexInRange(this.scaleValues, max);

    return {
      startIndex: minIndex,
      endIndex: maxIndex
    };
  };

  Brush.prototype.getTextOfTick = function getTextOfTick(index) {
    var _props2 = this.props,
        data = _props2.data,
        tickFormatter = _props2.tickFormatter,
        dataKey = _props2.dataKey;

    var text = getValueByDataKey(data[index], dataKey, index);

    return ___default.isFunction(tickFormatter) ? tickFormatter(text) : text;
  };

  Brush.prototype.handleSlideDrag = function handleSlideDrag(e) {
    var _state = this.state,
        slideMoveStartX = _state.slideMoveStartX,
        startX = _state.startX,
        endX = _state.endX;
    var _props3 = this.props,
        x = _props3.x,
        width = _props3.width,
        travellerWidth = _props3.travellerWidth,
        startIndex = _props3.startIndex,
        endIndex = _props3.endIndex,
        onChange = _props3.onChange;

    var delta = e.pageX - slideMoveStartX;

    if (delta > 0) {
      delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
    } else if (delta < 0) {
      delta = Math.max(delta, x - startX, x - endX);
    }
    var newIndex = this.getIndex({
      startX: startX + delta,
      endX: endX + delta
    });

    if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
      onChange(newIndex);
    }

    this.setState({
      startX: startX + delta,
      endX: endX + delta,
      slideMoveStartX: e.pageX
    });
  };

  Brush.prototype.handleTravellerDragStart = function handleTravellerDragStart(id, e) {
    var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;

    this.setState({
      isSlideMoving: false,
      isTravellerMoving: true,
      movingTravellerId: id,
      brushMoveStartX: event.pageX
    });
  };

  Brush.prototype.handleTravellerMove = function handleTravellerMove(e) {
    var _setState;

    var _state2 = this.state,
        brushMoveStartX = _state2.brushMoveStartX,
        movingTravellerId = _state2.movingTravellerId;

    var prevValue = this.state[movingTravellerId];
    var _props4 = this.props,
        x = _props4.x,
        width = _props4.width,
        travellerWidth = _props4.travellerWidth,
        onChange = _props4.onChange;


    var params = { startX: this.state.startX, endX: this.state.endX };
    var delta = e.pageX - brushMoveStartX;

    if (delta > 0) {
      delta = Math.min(delta, x + width - travellerWidth - prevValue);
    } else if (delta < 0) {
      delta = Math.max(delta, x - prevValue);
    }

    params[movingTravellerId] = prevValue + delta;
    var newIndex = this.getIndex(params);

    this.setState((_setState = {}, _setState[movingTravellerId] = prevValue + delta, _setState.brushMoveStartX = e.pageX, _setState), function () {
      if (onChange) {
        onChange(newIndex);
      }
    });
  };

  Brush.prototype.updateScale = function updateScale(props) {
    var _this3 = this;

    var data = props.data,
        startIndex = props.startIndex,
        endIndex = props.endIndex,
        x = props.x,
        width = props.width,
        travellerWidth = props.travellerWidth;


    if (data && data.length) {
      var len = data.length;
      this.scale = d3Scales.scalePoint().domain(___default.range(0, len)).range([x, x + width - travellerWidth]);
      this.scaleValues = this.scale.domain().map(function (entry) {
        return _this3.scale(entry);
      });
      this.state = {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        startX: this.scale(startIndex),
        endX: this.scale(endIndex)
      };
    }
  };

  Brush.prototype.renderBackground = function renderBackground() {
    var _props5 = this.props,
        x = _props5.x,
        y = _props5.y,
        width = _props5.width,
        height = _props5.height,
        fill = _props5.fill,
        stroke = _props5.stroke;


    return React__default.createElement('rect', {
      stroke: stroke,
      fill: fill,
      x: x,
      y: y,
      width: width,
      height: height
    });
  };

  Brush.prototype.renderTraveller = function renderTraveller(startX, id) {
    var _props6 = this.props,
        y = _props6.y,
        travellerWidth = _props6.travellerWidth,
        height = _props6.height,
        stroke = _props6.stroke;

    var lineY = Math.floor(y + height / 2) - 1;
    var x = Math.max(startX, this.props.x);

    return React__default.createElement(
      Layer,
      {
        className: 'recharts-brush-traveller',
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[id],
        onTouchStart: this.travellerDragStartHandlers[id],
        style: { cursor: 'col-resize' }
      },
      React__default.createElement('rect', {
        x: x,
        y: y,
        width: travellerWidth,
        height: height,
        fill: stroke,
        stroke: 'none'
      }),
      React__default.createElement('line', {
        x1: x + 1,
        y1: lineY,
        x2: x + travellerWidth - 1,
        y2: lineY,
        fill: 'none',
        stroke: '#fff'
      }),
      React__default.createElement('line', {
        x1: x + 1,
        y1: lineY + 2,
        x2: x + travellerWidth - 1,
        y2: lineY + 2,
        fill: 'none',
        stroke: '#fff'
      })
    );
  };

  Brush.prototype.renderSlide = function renderSlide(startX, endX) {
    var _props7 = this.props,
        y = _props7.y,
        height = _props7.height,
        stroke = _props7.stroke;


    return React__default.createElement('rect', {
      className: 'recharts-brush-slide',
      onMouseEnter: this.handleEnterSlideOrTraveller,
      onMouseLeave: this.handleLeaveSlideOrTraveller,
      onMouseDown: this.handleSlideDragStart,
      onTouchStart: this.handleSlideDragStart,
      style: { cursor: 'move' },
      stroke: 'none',
      fill: stroke,
      fillOpacity: 0.2,
      x: Math.min(startX, endX),
      y: y,
      width: Math.abs(endX - startX),
      height: height
    });
  };

  Brush.prototype.renderText = function renderText() {
    var _props8 = this.props,
        startIndex = _props8.startIndex,
        endIndex = _props8.endIndex,
        y = _props8.y,
        height = _props8.height,
        travellerWidth = _props8.travellerWidth,
        stroke = _props8.stroke;
    var _state3 = this.state,
        startX = _state3.startX,
        endX = _state3.endX;

    var offset = 5;
    var style = {
      pointerEvents: 'none',
      fill: stroke
    };

    return React__default.createElement(
      Layer,
      { className: 'recharts-brush-texts' },
      React__default.createElement(
        Text,
        {
          textAnchor: 'end',
          verticalAnchor: 'middle',
          style: style,
          x: Math.min(startX, endX) - offset,
          y: y + height / 2
        },
        this.getTextOfTick(startIndex)
      ),
      React__default.createElement(
        Text,
        {
          textAnchor: 'start',
          verticalAnchor: 'middle',
          style: style,
          x: Math.max(startX, endX) + travellerWidth + offset,
          y: y + height / 2
        },
        this.getTextOfTick(endIndex)
      )
    );
  };

  Brush.prototype.render = function render() {
    var _props9 = this.props,
        data = _props9.data,
        className = _props9.className;
    var _state4 = this.state,
        startX = _state4.startX,
        endX = _state4.endX,
        isTextActive = _state4.isTextActive,
        isSlideMoving = _state4.isSlideMoving,
        isTravellerMoving = _state4.isTravellerMoving;


    if (!data || !data.length) {
      return null;
    }

    var layerClass = classNames('recharts-brush', className);

    return React__default.createElement(
      Layer,
      {
        className: layerClass,
        onMouseMove: this.handleDrag,
        onMouseLeave: this.handleLeaveWrapper,
        onMouseUp: this.handleDragEnd,
        onTouchEnd: this.handleDragEnd,
        onTouchMove: this.handleTouchMove
      },
      this.renderBackground(),
      this.renderSlide(startX, endX),
      this.renderTraveller(startX, 'startX'),
      this.renderTraveller(endX, 'endX'),
      (isTextActive || isSlideMoving || isTravellerMoving) && this.renderText()
    );
  };

  return Brush;
}(React.Component)) || _class$18;

Brush.displayName = 'Brush';
Brush.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 40,
  travellerWidth: 5,
  fill: '#fff',
  stroke: '#666'
};

var _class$19;

/**
 * @fileOverview Reference Line
 */
var renderLine = function renderLine(option, props) {
  var line$$1 = void 0;

  if (React__default.isValidElement(option)) {
    line$$1 = React__default.cloneElement(option, props);
  } else if (___default.isFunction(option)) {
    line$$1 = option(props);
  } else {
    line$$1 = React__default.createElement('line', _extends({}, props, {
      className: 'recharts-reference-line-line'
    }));
  }

  return line$$1;
};

var ReferenceLine = pureRenderDecorator$1(_class$19 = function (_Component) {
  inherits(ReferenceLine, _Component);

  function ReferenceLine() {
    classCallCheck(this, ReferenceLine);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ReferenceLine.prototype.getEndPoints = function getEndPoints(isX, isY) {
    var _props = this.props,
        xAxis = _props.xAxis,
        yAxis = _props.yAxis,
        viewBox = _props.viewBox;
    var x = viewBox.x,
        y = viewBox.y,
        width = viewBox.width,
        height = viewBox.height;


    if (isY) {
      var value = this.props.y;
      var scale = yAxis.scale;

      var offset = scale.bandwidth ? scale.bandwidth() / 2 : 0;
      var coord = scale(value) + offset;

      if (validateCoordinateInRange(coord, scale)) {
        return yAxis.orientation === 'left' ? [{ x: x, y: coord }, { x: x + width, y: coord }] : [{ x: x + width, y: coord }, { x: x, y: coord }];
      }
    } else if (isX) {
      var _value = this.props.x;
      var _scale = xAxis.scale;

      var _offset = _scale.bandwidth ? _scale.bandwidth() / 2 : 0;
      var _coord = _scale(_value) + _offset;

      if (validateCoordinateInRange(_coord, _scale)) {
        return xAxis.orientation === 'top' ? [{ x: _coord, y: y }, { x: _coord, y: y + height }] : [{ x: _coord, y: y + height }, { x: _coord, y: y }];
      }
    }

    return null;
  };

  ReferenceLine.prototype.getLabelProps = function getLabelProps(isX, isY) {
    var _props2 = this.props,
        xAxis = _props2.xAxis,
        yAxis = _props2.yAxis,
        labelPosition = _props2.labelPosition;


    if (isY) {
      var axis = yAxis;

      if (axis.orientation === 'left' && labelPosition === 'end') {
        return { dx: 6, dy: 6, textAnchor: 'start' };
      }
      if (axis.orientation === 'right' && labelPosition === 'start') {
        return { dx: 6, dy: 6, textAnchor: 'start' };
      }
      return { dx: -6, dy: 6, textAnchor: 'end' };
    } else if (isX) {
      var _axis = xAxis;

      if (_axis.orientation === 'top') {
        return { dy: 6, textAnchor: 'middle' };
      }
      return { dy: -6, textAnchor: 'middle' };
    }

    return null;
  };

  ReferenceLine.prototype.renderLabel = function renderLabel(isX, isY, end) {
    var _props3 = this.props,
        label = _props3.label,
        stroke = _props3.stroke;

    var props = _extends({}, getPresentationAttributes(label), {
      stroke: 'none',
      fill: stroke
    }, end, this.getLabelProps(isX, isY));

    if (React__default.isValidElement(label)) {
      return React__default.cloneElement(label, props);
    } else if (___default.isFunction(label)) {
      return label(props);
    } else if (isNumOrStr(label)) {
      return React__default.createElement(
        'g',
        { className: 'recharts-reference-line-label' },
        React__default.createElement(
          Text,
          props,
          label
        )
      );
    }

    return null;
  };

  ReferenceLine.prototype.render = function render() {
    var _props4 = this.props,
        x = _props4.x,
        y = _props4.y,
        labelPosition = _props4.labelPosition,
        shape = _props4.shape;

    var isX = isNumOrStr(x);
    var isY = isNumOrStr(y);

    if (!isX && !isY) {
      return null;
    }

    var endPoints = this.getEndPoints(isX, isY);

    if (!endPoints) {
      return null;
    }

    var start = endPoints[0],
        end = endPoints[1];

    var props = _extends({}, getPresentationAttributes(this.props), filterEventAttributes(this.props), {
      x1: start.x,
      y1: start.y,
      x2: end.x,
      y2: end.y
    });

    return React__default.createElement(
      Layer,
      { className: 'recharts-reference-line' },
      renderLine(shape, props),
      this.renderLabel(isX, isY, labelPosition === 'start' ? start : end)
    );
  };

  return ReferenceLine;
}(React.Component)) || _class$19;

ReferenceLine.displayName = 'ReferenceLine';
ReferenceLine.defaultProps = {
  isFront: false,
  alwaysShow: false,
  xAxisId: 0,
  yAxisId: 0,
  fill: 'none',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1,
  labelPosition: 'end'
};

var _class$20;

/**
 * @fileOverview Reference Line
 */
var ReferenceDot = pureRenderDecorator$1(_class$20 = function (_Component) {
  inherits(ReferenceDot, _Component);

  function ReferenceDot() {
    classCallCheck(this, ReferenceDot);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ReferenceDot.prototype.getCoordinate = function getCoordinate() {
    var _props = this.props,
        x = _props.x,
        y = _props.y,
        xAxis = _props.xAxis,
        yAxis = _props.yAxis;

    var xScale = xAxis.scale;
    var yScale = yAxis.scale;
    var result = {
      cx: xScale(x) + (xScale.bandwidth ? xScale.bandwidth() / 2 : 0),
      cy: yScale(y) + (yScale.bandwidth ? yScale.bandwidth() / 2 : 0)
    };

    if (validateCoordinateInRange(result.cx, xScale) && validateCoordinateInRange(result.cy, yScale)) {
      return result;
    }

    return null;
  };

  ReferenceDot.prototype.renderLabel = function renderLabel(coordinate) {
    var _props2 = this.props,
        label = _props2.label,
        stroke = _props2.stroke;

    var props = _extends({}, getPresentationAttributes(label), {
      stroke: 'none',
      fill: stroke,
      x: coordinate.cx,
      y: coordinate.cy,
      textAnchor: 'middle',
      verticalAnchor: 'middle'
    });

    if (React__default.isValidElement(label)) {
      return React__default.cloneElement(label, props);
    } else if (___default.isFunction(label)) {
      return label(props);
    } else if (isNumOrStr(label)) {
      return React__default.createElement(
        'g',
        { className: 'recharts-reference-dot-label' },
        React__default.createElement(
          Text,
          props,
          label
        )
      );
    }

    return null;
  };

  ReferenceDot.prototype.renderDot = function renderDot(option, props) {
    var dot = void 0;

    if (React__default.isValidElement(option)) {
      dot = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      dot = option(props);
    } else {
      dot = React__default.createElement(Dot, _extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: 'recharts-reference-dot-dot'
      }));
    }

    return dot;
  };

  ReferenceDot.prototype.render = function render() {
    var _props3 = this.props,
        x = _props3.x,
        y = _props3.y;

    var isX = isNumOrStr(x);
    var isY = isNumOrStr(y);

    if (!isX || !isY) {
      return null;
    }

    var coordinate = this.getCoordinate();

    if (!coordinate) {
      return null;
    }

    var shape = this.props.shape;


    return React__default.createElement(
      Layer,
      { className: 'recharts-reference-dot' },
      this.renderDot(shape, _extends({}, getPresentationAttributes(this.props), coordinate)),
      this.renderLabel(coordinate)
    );
  };

  return ReferenceDot;
}(React.Component)) || _class$20;

ReferenceDot.displayName = 'ReferenceDot';
ReferenceDot.defaultProps = {
  isFront: false,
  alwaysShow: false,
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#fff',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1
};

var _class$21;

/**
 * @fileOverview Reference Line
 */
var ReferenceArea = pureRenderDecorator$1(_class$21 = function (_Component) {
  inherits(ReferenceArea, _Component);

  function ReferenceArea() {
    classCallCheck(this, ReferenceArea);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ReferenceArea.prototype.getRect = function getRect(hasX, hasY) {
    var _props = this.props,
        xValue1 = _props.x1,
        xValue2 = _props.x2,
        yValue1 = _props.y1,
        yValue2 = _props.y2,
        xAxis = _props.xAxis,
        yAxis = _props.yAxis;

    var xScale = xAxis.scale;
    var yScale = yAxis.scale;
    var xOffset = xScale.bandwidth ? xScale.bandwidth() / 2 : 0;
    var yOffset = yScale.bandwidth ? yScale.bandwidth() / 2 : 0;
    var xRange = xScale.range();
    var yRange = yScale.range();
    var x1 = void 0,
        x2 = void 0,
        y1 = void 0,
        y2 = void 0;

    if (hasX && isNumOrStr(xValue1)) {
      x1 = xScale(xValue1) + xOffset;
    } else if (hasY) {
      x1 = xRange[0];
    }
    if (hasX && isNumOrStr(xValue2)) {
      x2 = xScale(xValue2) + xOffset;
    } else if (hasY) {
      x2 = xRange[1];
    }
    if (hasY && isNumOrStr(yValue1)) {
      y1 = yScale(yValue1) + yOffset;
    } else if (hasX) {
      y1 = yRange[0];
    }
    if (hasY && isNumOrStr(yValue2)) {
      y2 = yScale(yValue2) + yOffset;
    } else if (hasX) {
      y2 = yRange[1];
    }

    if (validateCoordinateInRange(x1, xScale) && validateCoordinateInRange(x2, xScale) && validateCoordinateInRange(y1, yScale) && validateCoordinateInRange(y2, yScale)) {
      return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
      };
    }

    return null;
  };

  ReferenceArea.prototype.renderLabel = function renderLabel(_ref) {
    var x = _ref.x,
        y = _ref.y,
        width = _ref.width,
        height = _ref.height;
    var _props2 = this.props,
        label = _props2.label,
        stroke = _props2.stroke;

    var props = _extends({}, label, {
      stroke: 'none',
      fill: stroke,
      x: x + width / 2,
      y: y + height / 2,
      textAnchor: 'middle'
    });

    if (React__default.isValidElement(label)) {
      return React__default.cloneElement(label, props);
    } else if (___default.isFunction(label)) {
      return label(props);
    } else if (isNumOrStr(label)) {
      return React__default.createElement(
        'g',
        { className: 'recharts-reference-area-label' },
        React__default.createElement(
          Text,
          props,
          label
        )
      );
    }

    return null;
  };

  ReferenceArea.prototype.renderRect = function renderRect(option, props) {
    var rect = void 0;

    if (React__default.isValidElement(option)) {
      rect = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      rect = option(props);
    } else {
      rect = React__default.createElement(Rectangle, _extends({}, props, {
        className: 'recharts-reference-area-rect'
      }));
    }

    return rect;
  };

  ReferenceArea.prototype.render = function render() {
    var _props3 = this.props,
        x1 = _props3.x1,
        x2 = _props3.x2,
        y1 = _props3.y1,
        y2 = _props3.y2;

    var hasX = isNumOrStr(x1) && isNumOrStr(x2);
    var hasY = isNumOrStr(y1) && isNumOrStr(y2);

    if (!hasX && !hasY) {
      return null;
    }

    var rect = this.getRect(hasX, hasY);

    if (!rect) {
      return null;
    }

    var shape = this.props.shape;


    return React__default.createElement(
      Layer,
      { className: 'recharts-reference-area' },
      this.renderRect(shape, _extends({}, this.props, rect)),
      this.renderLabel(rect)
    );
  };

  return ReferenceArea;
}(React.Component)) || _class$21;

ReferenceArea.displayName = 'ReferenceArea';
ReferenceArea.defaultProps = {
  isFront: false,
  alwaysShow: false,
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#ccc',
  fillOpacity: 0.5,
  stroke: 'none',
  strokeWidth: 1
};

/**
 * @fileOverview Cartesian Axis
 */
var CartesianAxis = function (_Component) {
  inherits(CartesianAxis, _Component);

  function CartesianAxis() {
    classCallCheck(this, CartesianAxis);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  CartesianAxis.getTicks = function getTicks(props) {
    var ticks = props.ticks,
        viewBox = props.viewBox,
        minTickGap = props.minTickGap,
        orientation = props.orientation,
        interval = props.interval,
        tickFormatter = props.tickFormatter;


    if (!ticks || !ticks.length) {
      return [];
    }

    if (isNumber(interval) || isSsr()) {
      return CartesianAxis.getNumberIntervalTicks(ticks, isNumber(interval) ? interval : 0);
    }

    if (interval === 'preserveStartEnd') {
      return CartesianAxis.getTicksStart({
        ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap
      }, true);
    } else if (interval === 'preserveStart') {
      return CartesianAxis.getTicksStart({
        ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap
      });
    }

    return CartesianAxis.getTicksEnd({ ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap });
  };

  CartesianAxis.getNumberIntervalTicks = function getNumberIntervalTicks(ticks, interval) {
    return ticks.filter(function (entry, i) {
      return i % (interval + 1) === 0;
    });
  };

  CartesianAxis.getTicksStart = function getTicksStart(_ref, preserveEnd) {
    var ticks = _ref.ticks,
        tickFormatter = _ref.tickFormatter,
        viewBox = _ref.viewBox,
        orientation = _ref.orientation,
        minTickGap = _ref.minTickGap;
    var x = viewBox.x,
        y = viewBox.y,
        width = viewBox.width,
        height = viewBox.height;

    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var result = (ticks || []).slice();
    var len = result.length;
    var sign = len >= 2 ? Math.sign(result[1].coordinate - result[0].coordinate) : 1;

    var start = void 0,
        end = void 0;

    if (sign === 1) {
      start = sizeKey === 'width' ? x : y;
      end = sizeKey === 'width' ? x + width : y + height;
    } else {
      start = sizeKey === 'width' ? x + width : y + height;
      end = sizeKey === 'width' ? x : y;
    }

    if (preserveEnd) {
      // Try to guarantee the tail to be displayed
      var tail = ticks[len - 1];
      var tailContent = ___default.isFunction(tickFormatter) ? tickFormatter(tail.value) : tail.value;
      var tailSize = getStringSize(tailContent)[sizeKey];
      var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
      result[len - 1] = tail = _extends({}, tail, {
        tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
      });

      var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;

      if (isTailShow) {
        end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
        result[len - 1] = _extends({}, tail, { isShow: true });
      }
    }

    var count = preserveEnd ? len - 1 : len;
    for (var i = 0; i < count; i++) {
      var entry = result[i];
      var content = ___default.isFunction(tickFormatter) ? tickFormatter(entry.value) : entry.value;
      var size = getStringSize(content)[sizeKey];

      if (i === 0) {
        var gap = sign * (entry.coordinate - sign * size / 2 - start);
        result[i] = entry = _extends({}, entry, {
          tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
        });
      } else {
        result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
      }

      var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;

      if (isShow) {
        start = entry.tickCoord + sign * (size / 2 + minTickGap);
        result[i] = _extends({}, entry, { isShow: true });
      }
    }

    return result.filter(function (entry) {
      return entry.isShow;
    });
  };

  CartesianAxis.getTicksEnd = function getTicksEnd(_ref2) {
    var ticks = _ref2.ticks,
        tickFormatter = _ref2.tickFormatter,
        viewBox = _ref2.viewBox,
        orientation = _ref2.orientation,
        minTickGap = _ref2.minTickGap;
    var x = viewBox.x,
        y = viewBox.y,
        width = viewBox.width,
        height = viewBox.height;

    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var result = (ticks || []).slice();
    var len = result.length;
    var sign = len >= 2 ? Math.sign(result[1].coordinate - result[0].coordinate) : 1;

    var start = void 0,
        end = void 0;

    if (sign === 1) {
      start = sizeKey === 'width' ? x : y;
      end = sizeKey === 'width' ? x + width : y + height;
    } else {
      start = sizeKey === 'width' ? x + width : y + height;
      end = sizeKey === 'width' ? x : y;
    }

    for (var i = len - 1; i >= 0; i--) {
      var entry = result[i];
      var content = ___default.isFunction(tickFormatter) ? tickFormatter(entry.value) : entry.value;
      var size = getStringSize(content)[sizeKey];

      if (i === len - 1) {
        var gap = sign * (entry.coordinate + sign * size / 2 - end);
        result[i] = entry = _extends({}, entry, {
          tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
        });
      } else {
        result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
      }

      var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;

      if (isShow) {
        end = entry.tickCoord - sign * (size / 2 + minTickGap);
        result[i] = _extends({}, entry, { isShow: true });
      }
    }

    return result.filter(function (entry) {
      return entry.isShow;
    });
  };

  CartesianAxis.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref3, state) {
    var viewBox = _ref3.viewBox,
        restProps = objectWithoutProperties(_ref3, ['viewBox']);

    // props.viewBox is sometimes generated every time -
    // check that specially as object equality is likely to fail
    var _props = this.props,
        viewBoxOld = _props.viewBox,
        restPropsOld = objectWithoutProperties(_props, ['viewBox']);

    return !shallowEqual(viewBox, viewBoxOld) || !shallowEqual(restProps, restPropsOld) || !shallowEqual(state, this.state);
  };

  /**
   * Calculate the coordinates of endpoints in ticks
   * @param  {Object} data The data of a simple tick
   * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
   *  (x2, y2): The coordinate of endpoint close to axis
   */


  CartesianAxis.prototype.getTickLineCoord = function getTickLineCoord(data) {
    var _props2 = this.props,
        x = _props2.x,
        y = _props2.y,
        width = _props2.width,
        height = _props2.height,
        orientation = _props2.orientation,
        tickSize = _props2.tickSize,
        mirror = _props2.mirror;

    var x1 = void 0,
        x2 = void 0,
        y1 = void 0,
        y2 = void 0,
        tx = void 0,
        ty = void 0;

    var sign = mirror ? -1 : 1;
    var finalTickSize = data.tickSize || tickSize;
    var tickCoord = isNumber(data.tickCoord) ? data.tickCoord : data.coordinate;

    switch (orientation) {
      case 'top':
        x1 = x2 = data.coordinate;
        y2 = y + !mirror * height;
        y1 = ty = y2 - sign * finalTickSize;
        tx = tickCoord;
        break;
      case 'left':
        y1 = y2 = data.coordinate;
        x2 = x + !mirror * width;
        x1 = tx = x2 - sign * finalTickSize;
        ty = tickCoord;
        break;
      case 'right':
        y1 = y2 = data.coordinate;
        x2 = x + mirror * width;
        x1 = tx = x2 + sign * finalTickSize;
        ty = tickCoord;
        break;
      default:
        x1 = x2 = data.coordinate;
        y2 = y + mirror * height;
        y1 = ty = y2 + sign * finalTickSize;
        tx = tickCoord;
        break;
    }

    return { line: { x1: x1, y1: y1, x2: x2, y2: y2 }, tick: { x: tx, y: ty } };
  };

  CartesianAxis.prototype.getTickTextAnchor = function getTickTextAnchor() {
    var _props3 = this.props,
        orientation = _props3.orientation,
        mirror = _props3.mirror;

    var textAnchor = void 0;

    switch (orientation) {
      case 'left':
        textAnchor = mirror ? 'start' : 'end';
        break;
      case 'right':
        textAnchor = mirror ? 'end' : 'start';
        break;
      default:
        textAnchor = 'middle';
        break;
    }

    return textAnchor;
  };

  CartesianAxis.prototype.getTickVerticalAnchor = function getTickVerticalAnchor() {
    var _props4 = this.props,
        orientation = _props4.orientation,
        mirror = _props4.mirror;

    var verticalAnchor = 'end';

    switch (orientation) {
      case 'left':
      case 'right':
        verticalAnchor = 'middle';
        break;
      case 'top':
        verticalAnchor = mirror ? 'start' : 'end';
        break;
      default:
        verticalAnchor = mirror ? 'end' : 'start';
        break;
    }

    return verticalAnchor;
  };

  CartesianAxis.prototype.getLabelProps = function getLabelProps() {
    var _props5 = this.props,
        x = _props5.x,
        y = _props5.y,
        width = _props5.width,
        height = _props5.height,
        orientation = _props5.orientation;


    switch (orientation) {
      case 'left':
        return { x: x + width, y: y - 6, textAnchor: 'middle' };
      case 'right':
        return { x: x, y: y - 6, textAnchor: 'middle' };
      case 'top':
        return { x: x + width + 6, y: y + height + 6, textAnchor: 'start' };
      default:
        return { x: x + width + 6, y: y + 6, textAnchor: 'start' };
    }
  };

  CartesianAxis.prototype.renderAxisLine = function renderAxisLine() {
    var _props6 = this.props,
        x = _props6.x,
        y = _props6.y,
        width = _props6.width,
        height = _props6.height,
        orientation = _props6.orientation,
        axisLine = _props6.axisLine,
        mirror = _props6.mirror;

    var props = _extends({}, getPresentationAttributes(this.props), {
      fill: 'none'
    }, getPresentationAttributes(axisLine));

    if (orientation === 'top' || orientation === 'bottom') {
      var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
      props = _extends({}, props, {
        x1: x,
        y1: y + needHeight * height,
        x2: x + width,
        y2: y + needHeight * height
      });
    } else {
      var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
      props = _extends({}, props, {
        x1: x + needWidth * width,
        y1: y,
        x2: x + needWidth * width,
        y2: y + height
      });
    }

    return React__default.createElement('line', _extends({ className: 'recharts-cartesian-axis-line' }, props));
  };

  CartesianAxis.prototype.renderTickItem = function renderTickItem(option, props, value) {
    var tickItem = void 0;

    if (React__default.isValidElement(option)) {
      tickItem = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      tickItem = option(props);
    } else {
      tickItem = React__default.createElement(
        Text,
        _extends({}, props, {
          className: 'recharts-cartesian-axis-tick-value'
        }),
        value
      );
    }

    return tickItem;
  };

  /**
   * render the ticks
   * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
   * @return {ReactComponent} renderedTicks
   */


  CartesianAxis.prototype.renderTicks = function renderTicks(ticks) {
    var _this2 = this;

    var _props7 = this.props,
        tickLine = _props7.tickLine,
        stroke = _props7.stroke,
        tick = _props7.tick,
        tickFormatter = _props7.tickFormatter;

    var finalTicks = CartesianAxis.getTicks(_extends({}, this.props, { ticks: ticks }));
    var textAnchor = this.getTickTextAnchor();
    var verticalAnchor = this.getTickVerticalAnchor();
    var axisProps = getPresentationAttributes(this.props);
    var customTickProps = getPresentationAttributes(tick);
    var tickLineProps = _extends({}, axisProps, { fill: 'none' }, getPresentationAttributes(tickLine));
    var items = finalTicks.map(function (entry, i) {
      var _getTickLineCoord = _this2.getTickLineCoord(entry),
          lineCoord = _getTickLineCoord.line,
          tickCoord = _getTickLineCoord.tick;

      var tickProps = _extends({
        textAnchor: textAnchor,
        verticalAnchor: verticalAnchor
      }, axisProps, {
        stroke: 'none', fill: stroke
      }, customTickProps, tickCoord, {
        index: i, payload: entry
      });

      return React__default.createElement(
        Layer,
        _extends({
          className: 'recharts-cartesian-axis-tick',
          key: 'tick-' + i
        }, filterEventsOfChild(_this2.props, entry, i)),
        tickLine && React__default.createElement('line', _extends({
          className: 'recharts-cartesian-axis-tick-line'
        }, tickLineProps, lineCoord)),
        tick && _this2.renderTickItem(tick, tickProps, ___default.isFunction(tickFormatter) ? tickFormatter(entry.value) : entry.value)
      );
    });

    return React__default.createElement(
      'g',
      { className: 'recharts-cartesian-axis-ticks' },
      items
    );
  };

  CartesianAxis.prototype.renderLabel = function renderLabel() {
    var _props8 = this.props,
        label = _props8.label,
        stroke = _props8.stroke,
        orientation = _props8.orientation,
        viewBox = _props8.viewBox;

    var presentation = getPresentationAttributes(this.props);

    if (React__default.isValidElement(label)) {
      return React__default.cloneElement(label, _extends({}, presentation, { orientation: orientation, viewBox: viewBox }));
    } else if (___default.isFunction(label)) {
      return label(this.props);
    } else if (isNumOrStr(label)) {
      var props = _extends({}, presentation, {
        stroke: 'none',
        fill: stroke
      }, this.getLabelProps());

      return React__default.createElement(
        'g',
        { className: 'recharts-cartesian-axis-label' },
        React__default.createElement(
          Text,
          props,
          label
        )
      );
    }

    return null;
  };

  CartesianAxis.prototype.render = function render() {
    var _props9 = this.props,
        axisLine = _props9.axisLine,
        width = _props9.width,
        height = _props9.height,
        ticksGenerator = _props9.ticksGenerator;
    var _props10 = this.props,
        ticks = _props10.ticks,
        noTicksProps = objectWithoutProperties(_props10, ['ticks']);


    if (___default.isFunction(ticksGenerator)) {
      ticks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
    }

    if (width <= 0 || height <= 0 || !ticks || !ticks.length) {
      return null;
    }

    return React__default.createElement(
      Layer,
      { className: 'recharts-cartesian-axis' },
      axisLine && this.renderAxisLine(),
      this.renderTicks(ticks),
      this.renderLabel()
    );
  };

  return CartesianAxis;
}(React.Component);

CartesianAxis.displayName = 'CartesianAxis';
CartesianAxis.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: { x: 0, y: 0, width: 0, height: 0 },
  // The orientation of axis
  orientation: 'bottom',
  // The ticks
  ticks: [],

  stroke: '#666',
  tickLine: true,
  axisLine: true,
  tick: true,
  mirror: false,

  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  interval: 'preserveEnd'
};

var _class$22;

/**
 * @fileOverview Cartesian Grid
 */
var CartesianGrid = pureRenderDecorator$1(_class$22 = function (_Component) {
  inherits(CartesianGrid, _Component);

  function CartesianGrid() {
    classCallCheck(this, CartesianGrid);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  CartesianGrid.prototype.renderLineItem = function renderLineItem(option, props) {
    var lineItem = void 0;

    if (React__default.isValidElement(option)) {
      lineItem = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      lineItem = option(props);
    } else {
      var x1 = props.x1,
          y1 = props.y1,
          x2 = props.x2,
          y2 = props.y2,
          key = props.key,
          fill = props.fill,
          others = objectWithoutProperties(props, ['x1', 'y1', 'x2', 'y2', 'key', 'fill']);


      lineItem = React__default.createElement('line', _extends({}, getPresentationAttributes(others), {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        fill: 'none',
        key: key
      }));
    }

    return lineItem;
  };

  /**
   * Draw the horizontal grid lines
   * @param {Array} horizontalPoints either passed in as props or generated from function
   * @return {Group} Horizontal lines
   */


  CartesianGrid.prototype.renderHorizontal = function renderHorizontal(horizontalPoints) {
    var _this2 = this;

    var _props = this.props,
        x = _props.x,
        width = _props.width,
        horizontal = _props.horizontal;


    if (!horizontalPoints || !horizontalPoints.length) {
      return null;
    }

    var items = horizontalPoints.map(function (entry, i) {
      var props = _extends({}, _this2.props, {
        x1: x,
        y1: entry,
        x2: x + width,
        y2: entry,
        key: 'line-' + i,
        index: i
      });

      return _this2.renderLineItem(horizontal, props);
    });

    return React__default.createElement(
      'g',
      { className: 'recharts-cartesian-grid-horizontal' },
      items
    );
  };

  /**
   * Draw vertical grid lines
   * @param {Array} verticalPoints either passed in as props or generated from function
   * @return {Group} Vertical lines
   */


  CartesianGrid.prototype.renderVertical = function renderVertical(verticalPoints) {
    var _this3 = this;

    var _props2 = this.props,
        y = _props2.y,
        height = _props2.height,
        vertical = _props2.vertical;


    if (!verticalPoints || !verticalPoints.length) {
      return null;
    }

    var items = verticalPoints.map(function (entry, i) {
      var props = _extends({}, _this3.props, {
        x1: entry,
        y1: y,
        x2: entry,
        y2: y + height,
        key: 'line-' + i,
        index: i
      });

      return _this3.renderLineItem(vertical, props);
    });

    return React__default.createElement(
      'g',
      { className: 'recharts-cartesian-grid-vertical' },
      items
    );
  };

  CartesianGrid.prototype.renderBackground = function renderBackground() {
    var fill = this.props.fill;


    if (!fill || fill === 'none') {
      return null;
    }

    var _props3 = this.props,
        fillOpacity = _props3.fillOpacity,
        x = _props3.x,
        y = _props3.y,
        width = _props3.width,
        height = _props3.height;


    return React__default.createElement('rect', {
      x: x,
      y: y,
      width: width,
      height: height,
      stroke: 'none',
      fill: fill,
      fillOpacity: fillOpacity,
      className: 'recharts-cartesian-grid-bg'
    });
  };

  CartesianGrid.prototype.render = function render() {
    var _props4 = this.props,
        x = _props4.x,
        y = _props4.y,
        width = _props4.width,
        height = _props4.height,
        horizontal = _props4.horizontal,
        vertical = _props4.vertical,
        horizontalCoordinatesGenerator = _props4.horizontalCoordinatesGenerator,
        verticalCoordinatesGenerator = _props4.verticalCoordinatesGenerator,
        xAxis = _props4.xAxis,
        yAxis = _props4.yAxis,
        offset = _props4.offset,
        chartWidth = _props4.chartWidth,
        chartHeight = _props4.chartHeight;


    if (width <= 0 || height <= 0 || x !== +x || y !== +y) {
      return null;
    }

    var _props5 = this.props,
        horizontalPoints = _props5.horizontalPoints,
        verticalPoints = _props5.verticalPoints;


    if (___default.isFunction(horizontalCoordinatesGenerator)) {
      horizontalPoints = horizontalCoordinatesGenerator({ yAxis: yAxis, width: chartWidth,
        height: chartHeight, offset: offset });
    }

    if (___default.isFunction(verticalCoordinatesGenerator)) {
      verticalPoints = verticalCoordinatesGenerator({ xAxis: xAxis, width: chartWidth,
        height: chartHeight, offset: offset });
    }

    return React__default.createElement(
      'g',
      { className: 'recharts-cartesian-grid' },
      this.renderBackground(),
      horizontal && this.renderHorizontal(horizontalPoints),
      vertical && this.renderVertical(verticalPoints)
    );
  };

  return CartesianGrid;
}(React.Component)) || _class$22;

CartesianGrid.displayName = 'CartesianGrid';
CartesianGrid.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  horizontal: true,
  vertical: true,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],

  stroke: '#ccc',
  fill: 'none'
};

/**
 * @fileOverview Render a group of error bar
*/
var ErrorBar = function (_Component) {
  inherits(ErrorBar, _Component);

  function ErrorBar() {
    classCallCheck(this, ErrorBar);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ErrorBar.prototype.renderErrorBars = function renderErrorBars() {
    var _props = this.props,
        offset = _props.offset,
        layout = _props.layout,
        width = _props.width,
        dataKey = _props.dataKey,
        data = _props.data,
        dataPointFormatter = _props.dataPointFormatter,
        xAxis = _props.xAxis,
        yAxis = _props.yAxis,
        others = objectWithoutProperties(_props, ['offset', 'layout', 'width', 'dataKey', 'data', 'dataPointFormatter', 'xAxis', 'yAxis']);

    var props = getPresentationAttributes(others);

    return data.map(function (entry, i) {
      var _dataPointFormatter = dataPointFormatter(entry, dataKey),
          x = _dataPointFormatter.x,
          y = _dataPointFormatter.y,
          value = _dataPointFormatter.value,
          errorVal = _dataPointFormatter.errorVal;

      if (!errorVal) {
        return null;
      }

      var xMid = void 0,
          yMid = void 0,
          xMin = void 0,
          yMin = void 0,
          xMax = void 0,
          yMax = void 0,
          scale = void 0,
          coordsTop = void 0,
          coordsMid = void 0,
          coordsBot = void 0,
          lowBound = void 0,
          highBound = void 0;

      if (Array.isArray(errorVal)) {
        lowBound = errorVal[0];
        highBound = errorVal[1];
      } else {
        lowBound = errorVal;
        highBound = errorVal;
      }

      if (layout === 'vertical') {
        scale = xAxis.scale;
        xMid = value;
        yMid = y + offset;
        xMin = scale(xMid - lowBound);
        yMin = yMid + width;
        xMax = scale(xMid + highBound);
        yMax = yMid - width;
        coordsTop = { x1: xMax, y1: yMin, x2: xMax, y2: yMax };
        coordsMid = { x1: xMin, y1: yMid, x2: xMax, y2: yMid };
        coordsBot = { x1: xMin, y1: yMin, x2: xMin, y2: yMax };
      } else if (layout === 'horizontal') {
        scale = yAxis.scale;
        xMid = x + offset;
        yMid = value;
        xMin = xMid - width;
        xMax = xMid + width;
        yMin = scale(yMid - lowBound);
        yMax = scale(yMid + highBound);
        coordsTop = { x1: xMin, y1: yMax, x2: xMax, y2: yMax };
        coordsMid = { x1: xMid, y1: yMin, x2: xMid, y2: yMax };
        coordsBot = { x1: xMin, y1: yMin, x2: xMax, y2: yMin };
      }

      return React__default.createElement(
        Layer,
        _extends({ className: 'recharts-errorBar', key: i }, props),
        React__default.createElement('line', coordsTop),
        ';',
        React__default.createElement('line', coordsMid),
        ';',
        React__default.createElement('line', coordsBot),
        ';'
      );
    });
  };

  ErrorBar.prototype.render = function render() {
    return React__default.createElement(
      Layer,
      { className: 'recharts-errorBars' },
      this.renderErrorBars()
    );
  };

  return ErrorBar;
}(React.Component);

ErrorBar.defaultProps = {
  stroke: 'black',
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: 'horizontal'
};

var _class$23;

/**
 * @fileOverview Line
 */
var FACTOR = 1.0000001;

var Line = pureRenderDecorator$1(_class$23 = function (_Component) {
  inherits(Line, _Component);

  function Line() {
    var _temp, _this, _ret;

    classCallCheck(this, Line);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      isAnimationFinished: true,
      totalLength: 0
    }, _this.id = uniqueId('recharts-line-'), _this.pathRef = function (node) {
      _this.animate = node;
    }, _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
      _this.props.onAnimationEnd();
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
      _this.props.onAnimationStart();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  /* eslint-disable  react/no-did-mount-set-state */
  Line.prototype.componentDidMount = function componentDidMount() {
    var isAnimationActive = this.props.isAnimationActive;


    if (!isAnimationActive) {
      return;
    }

    var totalLength = this.getTotalLength();

    this.setState({ totalLength: totalLength });
  };

  /* eslint-disable  react/no-did-update-set-state */


  Line.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var animationId = this.props.animationId;


    if (animationId !== prevProps.animationId) {
      var cur = this.getTotalLength();
      var totalLength = prevState.totalLength;
      // A hack method to trigger animation

      this.setState({
        totalLength: cur === totalLength ? cur * FACTOR : cur
      });
    }
  };

  Line.prototype.getTotalLength = function getTotalLength() {
    var curveDom = this.animate;
    var totalLength = curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;

    return totalLength;
  };

  Line.prototype.getStrokeDasharray = function getStrokeDasharray(length, totalLength, lines) {
    var lineLength = lines.reduce(function (pre, next) {
      return pre + next;
    });

    var count = parseInt(length / lineLength, 10);
    var remainLength = length % lineLength;
    var restLength = totalLength - length;

    var remainLines = [];
    for (var i = 0, sum = 0;; sum += lines[i], ++i) {
      if (sum + lines[i] > remainLength) {
        remainLines = [].concat(lines.slice(0, i), [remainLength - sum]);
        break;
      }
    }

    var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];

    return [].concat(this.repeat(lines, count), remainLines, emptyLines).map(function (line$$1) {
      return line$$1 + 'px';
    }).join(', ');
  };

  Line.prototype.repeat = function repeat(lines, count) {
    var linesUnit = lines.length % 2 !== 0 ? [].concat(lines, [0]) : lines;
    var result = [];

    for (var i = 0; i < count; ++i) {
      result = [].concat(result, linesUnit);
    }

    return result;
  };

  Line.prototype.renderLabelItem = function renderLabelItem(option, props, value) {
    var labelItem = void 0;

    if (React__default.isValidElement(option)) {
      labelItem = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      labelItem = option(props);
    } else {
      labelItem = React__default.createElement(
        Text,
        _extends({
          key: props.key
        }, props, {
          className: 'recharts-line-label'
        }),
        value
      );
    }

    return labelItem;
  };

  Line.prototype.renderLabels = function renderLabels() {
    var _this2 = this;

    var isAnimationActive = this.props.isAnimationActive;


    if (isAnimationActive && !this.state.isAnimationFinished) {
      return null;
    }

    var _props = this.props,
        points = _props.points,
        label = _props.label;

    var lineProps = getPresentationAttributes(this.props);
    var customLabelProps = getPresentationAttributes(label);

    var labels = points.map(function (entry, i) {
      var labelProps = _extends({
        textAnchor: 'middle'
      }, entry, lineProps, customLabelProps, {
        index: i,
        key: 'label-' + i
      });

      return _this2.renderLabelItem(label, labelProps, entry.value);
    });

    return React__default.createElement(
      Layer,
      { className: 'recharts-line-labels' },
      labels
    );
  };

  Line.prototype.renderErrorBar = function renderErrorBar() {
    if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
      return null;
    }

    var _props2 = this.props,
        points = _props2.points,
        xAxis = _props2.xAxis,
        yAxis = _props2.yAxis,
        layout = _props2.layout,
        children = _props2.children;

    var errorBarItem = findChildByType(children, ErrorBar);

    if (!errorBarItem) {
      return null;
    }

    function dataPointFormatter(dataPoint, dataKey) {
      return {
        x: dataPoint.x,
        y: dataPoint.y,
        value: dataPoint.value,
        errorVal: getValueByDataKey(dataPoint.payload, dataKey)
      };
    }

    return React__default.cloneElement(errorBarItem, {
      data: points,
      xAxis: xAxis,
      yAxis: yAxis,
      layout: layout,
      dataPointFormatter: dataPointFormatter
    });
  };

  Line.prototype.renderDotItem = function renderDotItem(option, props) {
    var dotItem = void 0;

    if (React__default.isValidElement(option)) {
      dotItem = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      dotItem = option(props);
    } else {
      dotItem = React__default.createElement(Dot, _extends({}, props, { className: 'recharts-line-dot' }));
    }

    return dotItem;
  };

  Line.prototype.renderDots = function renderDots() {
    var _this3 = this;

    var isAnimationActive = this.props.isAnimationActive;


    if (isAnimationActive && !this.state.isAnimationFinished) {
      return null;
    }
    var _props3 = this.props,
        dot = _props3.dot,
        points = _props3.points;

    var lineProps = getPresentationAttributes(this.props);
    var customDotProps = getPresentationAttributes(dot);
    var dots = points.map(function (entry, i) {
      var dotProps = _extends({
        key: 'dot-' + i,
        r: 3
      }, lineProps, customDotProps, {
        value: entry.value,
        cx: entry.x, cy: entry.y, index: i, payload: entry.payload
      });

      return _this3.renderDotItem(dot, dotProps);
    });

    return React__default.createElement(
      Layer,
      { className: 'recharts-line-dots', key: 'dots' },
      dots
    );
  };

  Line.prototype.renderCurve = function renderCurve(needClip) {
    var _this4 = this;

    var _props4 = this.props,
        points = _props4.points,
        strokeDasharray = _props4.strokeDasharray,
        isAnimationActive = _props4.isAnimationActive,
        animationBegin = _props4.animationBegin,
        animationDuration = _props4.animationDuration,
        animationEasing = _props4.animationEasing,
        onClick = _props4.onClick,
        onMouseEnter = _props4.onMouseEnter,
        onMouseLeave = _props4.onMouseLeave,
        other = objectWithoutProperties(_props4, ['points', 'strokeDasharray', 'isAnimationActive', 'animationBegin', 'animationDuration', 'animationEasing', 'onClick', 'onMouseEnter', 'onMouseLeave']);
    var totalLength = this.state.totalLength;

    var animationProps = {
      isActive: isAnimationActive,
      begin: animationBegin,
      canBegin: totalLength > 0,
      easing: animationEasing,
      duration: animationDuration,
      onAnimationEnd: this.handleAnimationEnd,
      onAnimationStart: this.handleAnimationStart,
      shouldReAnimate: true,
      pathRef: this.pathRef
    };
    var curveProps = _extends({}, other, {
      fill: 'none',
      className: 'recharts-line-curve',
      clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null,
      onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, points: points
    });

    if (!isAnimationActive) {
      return React__default.createElement(Curve, _extends({}, curveProps, { strokeDasharray: strokeDasharray }));
    }

    if (strokeDasharray && totalLength) {
      var _ret2 = function () {
        var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
          return parseFloat(num);
        });

        return {
          v: React__default.createElement(
            Animate,
            _extends({}, animationProps, {
              from: { curveLen: 0 },
              to: { curveLen: totalLength }
            }),
            function (_ref) {
              var curveLen = _ref.curveLen;
              return React__default.createElement(Curve, _extends({}, curveProps, {
                strokeDasharray: _this4.getStrokeDasharray(curveLen, totalLength, lines)
              }));
            }
          )
        };
      }();

      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
    } else if (strokeDasharray) {
      return React__default.createElement(Curve, _extends({}, curveProps, {
        pathRef: this.pathRef,
        strokeDasharray: strokeDasharray
      }));
    }

    return React__default.createElement(
      Animate,
      _extends({}, animationProps, {
        from: '0px ' + (totalLength === 0 ? 1 : totalLength) + 'px',
        to: totalLength + 'px 0px',
        attributeName: 'strokeDasharray'
      }),
      React__default.createElement(Curve, curveProps)
    );
  };

  Line.prototype.render = function render() {
    var _props5 = this.props,
        dot = _props5.dot,
        points = _props5.points,
        label = _props5.label,
        className = _props5.className,
        xAxis = _props5.xAxis,
        yAxis = _props5.yAxis,
        top = _props5.top,
        left = _props5.left,
        width = _props5.width,
        height = _props5.height;


    if (!points || !points.length) {
      return null;
    }

    var hasSinglePoint = points.length === 1;
    var layerClass = classNames('recharts-line', className);
    var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;

    return React__default.createElement(
      Layer,
      { className: layerClass },
      needClip ? React__default.createElement(
        'defs',
        null,
        React__default.createElement(
          'clipPath',
          { id: 'clipPath-' + this.id },
          React__default.createElement('rect', { x: left, y: top, width: width, height: height })
        )
      ) : null,
      !hasSinglePoint && this.renderCurve(needClip),
      this.renderErrorBar(),
      (hasSinglePoint || dot) && this.renderDots(),
      label && this.renderLabels()
    );
  };

  return Line;
}(React.Component)) || _class$23;

Line.displayName = 'Line';
Line.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: false,
  activeDot: true,
  dot: true,
  legendType: 'line',
  stroke: '#3182bd',
  strokeWidth: 1,
  fill: '#fff',
  points: [],
  isAnimationActive: !isSsr(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',

  onAnimationStart: function onAnimationStart() {},
  onAnimationEnd: function onAnimationEnd() {}
};

var _class$24;

/**
 * @fileOverview Area
 */
var Area = pureRenderDecorator$1(_class$24 = function (_Component) {
  inherits(Area, _Component);

  function Area() {
    var _temp, _this, _ret;

    classCallCheck(this, Area);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { isAnimationFinished: true }, _this.id = uniqueId('recharts-area-'), _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
      _this.props.onAnimationEnd();
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
      _this.props.onAnimationStart();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Area.prototype.renderCurve = function renderCurve() {
    var _props = this.props,
        layout = _props.layout,
        type = _props.type,
        stroke = _props.stroke,
        points = _props.points,
        baseLine = _props.baseLine,
        connectNulls = _props.connectNulls,
        isRange = _props.isRange;


    return React__default.createElement(
      'g',
      null,
      stroke !== 'none' && React__default.createElement(Curve, _extends({}, getPresentationAttributes(this.props), {
        className: 'recharts-area-curve',
        layout: layout,
        type: type,
        connectNulls: connectNulls,
        fill: 'none',
        points: points
      })),
      stroke !== 'none' && isRange && React__default.createElement(Curve, _extends({}, getPresentationAttributes(this.props), {
        className: 'recharts-area-curve',
        layout: layout,
        type: type,
        connectNulls: connectNulls,
        fill: 'none',
        points: baseLine
      })),
      React__default.createElement(Curve, _extends({}, this.props, {
        stroke: 'none',
        className: 'recharts-area-area'
      }))
    );
  };

  Area.prototype.renderHorizontalRect = function renderHorizontalRect(alpha) {
    var _props2 = this.props,
        baseLine = _props2.baseLine,
        points = _props2.points,
        strokeWidth = _props2.strokeWidth;

    var startX = points[0].x;
    var endX = points[points.length - 1].x;
    var width = alpha * Math.abs(startX - endX);
    var maxY = Math.max.apply(null, points.map(function (entry) {
      return entry.y || 0;
    }));

    if (isNumber(baseLine)) {
      maxY = Math.max(baseLine, maxY);
    } else {
      maxY = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
        return entry.y || 0;
      })), maxY);
    }

    return React__default.createElement('rect', {
      x: startX < endX ? startX : startX - width,
      y: 0,
      width: width,
      height: maxY + (strokeWidth || 1)
    });
  };

  Area.prototype.renderVerticalRect = function renderVerticalRect(alpha) {
    var _props3 = this.props,
        baseLine = _props3.baseLine,
        points = _props3.points,
        strokeWidth = _props3.strokeWidth;

    var startY = points[0].y;
    var endY = points[points.length - 1].y;
    var height = alpha * Math.abs(startY - endY);
    var maxX = Math.max.apply(null, points.map(function (entry) {
      return entry.x || 0;
    }));

    if (isNumber(baseLine)) {
      maxX = Math.max(baseLine, maxX);
    } else {
      maxX = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
        return entry.x || 0;
      })), maxX);
    }

    return React__default.createElement('rect', {
      x: 0,
      y: startY < endY ? startY : startY - height,
      width: maxX + (strokeWidth || 1),
      height: height
    });
  };

  Area.prototype.renderClipRect = function renderClipRect(alpha) {
    var layout = this.props.layout;


    if (layout === 'vertical') {
      return this.renderVerticalRect(alpha);
    }

    return this.renderHorizontalRect(alpha);
  };

  Area.prototype.renderClipPath = function renderClipPath() {
    var _this2 = this;

    var _props4 = this.props,
        isAnimationActive = _props4.isAnimationActive,
        animationDuration = _props4.animationDuration,
        animationEasing = _props4.animationEasing,
        animationBegin = _props4.animationBegin,
        animationId = _props4.animationId;


    return React__default.createElement(
      'defs',
      null,
      React__default.createElement(
        'clipPath',
        { id: 'animationClipPath-' + this.id },
        React__default.createElement(
          Animate,
          {
            easing: animationEasing,
            isActive: isAnimationActive,
            duration: animationDuration,
            key: animationId,
            animationBegin: animationBegin,
            onAnimationStart: this.handleAnimationStart,
            onAnimationEnd: this.handleAnimationEnd,
            from: { alpha: 0 },
            to: { alpha: 1 }
          },
          function (_ref) {
            var alpha = _ref.alpha;
            return _this2.renderClipRect(alpha);
          }
        )
      )
    );
  };

  Area.prototype.renderDotItem = function renderDotItem(option, props) {
    var dotItem = void 0;

    if (React__default.isValidElement(option)) {
      dotItem = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      dotItem = option(props);
    } else {
      dotItem = React__default.createElement(Dot, _extends({}, props, { className: 'recharts-area-dot' }));
    }

    return dotItem;
  };

  Area.prototype.renderDots = function renderDots() {
    var _this3 = this;

    var isAnimationActive = this.props.isAnimationActive;


    if (isAnimationActive && !this.state.isAnimationFinished) {
      return null;
    }

    var _props5 = this.props,
        dot = _props5.dot,
        points = _props5.points;

    var areaProps = getPresentationAttributes(this.props);
    var customDotProps = getPresentationAttributes(dot);

    var dots = points.map(function (entry, i) {
      var dotProps = _extends({
        key: 'dot-' + i,
        r: 3
      }, areaProps, customDotProps, {
        cx: entry.x,
        cy: entry.y,
        index: i,
        value: entry.value,
        payload: entry.payload
      });

      return _this3.renderDotItem(dot, dotProps);
    });

    return React__default.createElement(
      Layer,
      { className: 'recharts-area-dots' },
      dots
    );
  };

  Area.prototype.renderLabelItem = function renderLabelItem(option, props, value) {
    var labelItem = void 0;

    if (React__default.isValidElement(option)) {
      labelItem = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      labelItem = option(props);
    } else {
      labelItem = React__default.createElement(
        Text,
        _extends({
          key: props.key
        }, props, {
          className: 'recharts-area-label'
        }),
        ___default.isArray(value) ? value[1] : value
      );
    }

    return labelItem;
  };

  Area.prototype.renderLabels = function renderLabels() {
    var _this4 = this;

    var isAnimationActive = this.props.isAnimationActive;


    if (isAnimationActive && !this.state.isAnimationFinished) {
      return null;
    }

    var _props6 = this.props,
        points = _props6.points,
        label = _props6.label;

    var areaProps = getPresentationAttributes(this.props);
    var customLabelProps = getPresentationAttributes(label);

    var labels = points.map(function (entry, i) {
      var labelProps = _extends({
        textAnchor: 'middle'
      }, entry, areaProps, customLabelProps, {
        index: i,
        key: 'label-' + i,
        value: entry.value,
        payload: entry.payload
      });

      return _this4.renderLabelItem(label, labelProps, entry.value);
    });

    return React__default.createElement(
      Layer,
      { className: 'recharts-area-labels' },
      labels
    );
  };

  Area.prototype.render = function render() {
    var _props7 = this.props,
        dot = _props7.dot,
        label = _props7.label,
        points = _props7.points,
        className = _props7.className,
        top = _props7.top,
        left = _props7.left,
        xAxis = _props7.xAxis,
        yAxis = _props7.yAxis,
        width = _props7.width,
        height = _props7.height;


    if (!points || !points.length) {
      return null;
    }

    var hasSinglePoint = points.length === 1;
    var layerClass = classNames('recharts-area', className);
    var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;

    return React__default.createElement(
      Layer,
      { className: layerClass },
      needClip ? React__default.createElement(
        'defs',
        null,
        React__default.createElement(
          'clipPath',
          { id: 'clipPath-' + this.id },
          React__default.createElement('rect', { x: left, y: top, width: width, height: height })
        )
      ) : null,
      !hasSinglePoint ? this.renderClipPath() : null,
      !hasSinglePoint ? React__default.createElement(
        Layer,
        { clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null },
        React__default.createElement(
          Layer,
          { clipPath: 'url(#animationClipPath-' + this.id + ')' },
          this.renderCurve()
        )
      ) : null,
      (dot || hasSinglePoint) && this.renderDots(),
      label && this.renderLabels()
    );
  };

  return Area;
}(React.Component)) || _class$24;

Area.displayName = 'Area';
Area.defaultProps = {
  stroke: '#3182bd',
  fill: '#3182bd',
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'line',
  connectNulls: false,
  // points of area
  points: [],
  dot: false,
  label: false,
  activeDot: true,

  isAnimationActive: !isSsr(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',

  onAnimationStart: function onAnimationStart() {},
  onAnimationEnd: function onAnimationEnd() {}
};

var _class$25;

/**
 * @fileOverview Render a group of bar
 */
var Bar = pureRenderDecorator$1(_class$25 = function (_Component) {
  inherits(Bar, _Component);

  function Bar() {
    var _temp, _this, _ret;

    classCallCheck(this, Bar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = uniqueId('recharts-bar-'), _this.handleAnimationEnd = function () {
      _this.setState({ isAnimationFinished: true });
      _this.props.onAnimationEnd();
    }, _this.handleAnimationStart = function () {
      _this.setState({ isAnimationFinished: false });
      _this.props.onAnimationStart();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Bar.prototype.renderRectangle = function renderRectangle(option, props) {
    var rectangle = void 0;

    if (React__default.isValidElement(option)) {
      rectangle = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      rectangle = option(props);
    } else {
      rectangle = React__default.createElement(Rectangle, props);
    }

    return rectangle;
  };

  Bar.prototype.renderRectangles = function renderRectangles() {
    var _this2 = this;

    var _props = this.props,
        data = _props.data,
        shape = _props.shape,
        layout = _props.layout,
        isAnimationActive = _props.isAnimationActive,
        animationBegin = _props.animationBegin,
        animationDuration = _props.animationDuration,
        animationEasing = _props.animationEasing,
        animationId = _props.animationId;

    var baseProps = getPresentationAttributes(this.props);
    var getStyle = function getStyle(isBegin) {
      return {
        transform: 'scale' + (layout === 'vertical' ? 'X' : 'Y') + '(' + (isBegin ? 0 : 1) + ')'
      };
    };

    return data.map(function (entry, index) {
      var x = entry.x,
          y = entry.y,
          width = entry.width,
          height = entry.height;

      var props = _extends({}, baseProps, entry, { index: index });

      if (___default.isNil(entry.value) || !isAnimationActive) {
        return React__default.createElement(
          Layer,
          _extends({
            className: 'recharts-bar-rectangle'
          }, filterEventsOfChild(_this2.props, entry, index), {
            key: 'rectangle-' + index
          }),
          _this2.renderRectangle(shape, props)
        );
      }

      var transformOrigin = '';

      if (layout === 'vertical') {
        transformOrigin = x + 'px ' + (y + height / 2) + 'px';
      } else {
        transformOrigin = x + width / 2 + 'px ' + (y + height) + 'px';
      }

      return React__default.createElement(
        Animate,
        {
          begin: animationBegin,
          duration: animationDuration,
          isActive: isAnimationActive,
          easing: animationEasing,
          from: getStyle(true),
          to: getStyle(false),
          key: 'rectangle-' + index + '-' + animationId,
          onAnimationEnd: _this2.handleAnimationEnd,
          onAnimationStart: _this2.handleAnimationStart
        },
        React__default.createElement(
          Layer,
          _extends({
            className: 'recharts-bar-rectangle',
            style: translateStyle({ transformOrigin: transformOrigin })
          }, filterEventsOfChild(_this2.props, entry, index), {
            key: 'rectangle-' + index
          }),
          _this2.renderRectangle(shape, props)
        )
      );
    });
  };

  Bar.prototype.renderLabelItem = function renderLabelItem(option, props, value) {
    var labelItem = null;

    if (React__default.isValidElement(option)) {
      labelItem = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      labelItem = option(props);
    } else {
      labelItem = React__default.createElement(
        Text,
        _extends({}, props, {
          key: props.key,
          className: 'recharts-bar-label'
        }),
        ___default.isArray(value) ? value[1] : value
      );
    }

    return labelItem;
  };

  Bar.prototype.renderLabels = function renderLabels() {
    var _this3 = this;

    var isAnimationActive = this.props.isAnimationActive;


    if (isAnimationActive && !this.state.isAnimationFinished) {
      return null;
    }

    var _props2 = this.props,
        data = _props2.data,
        label = _props2.label,
        layout = _props2.layout;

    var barProps = getPresentationAttributes(this.props);
    var customLabelProps = getPresentationAttributes(label);
    var textAnchor = layout === 'vertical' ? 'start' : 'middle';
    var labels = data.map(function (entry, i) {
      var x = 0;
      var y = 0;

      if (layout === 'vertical') {
        x = 5 + entry.x + entry.width;
        y = 5 + entry.y + entry.height / 2;
      } else {
        x = entry.x + entry.width / 2;
        y = entry.y - 5;
      }

      var labelProps = _extends({
        textAnchor: textAnchor
      }, barProps, entry, customLabelProps, {
        x: x,
        y: y,
        index: i,
        key: 'label-' + i,
        payload: entry.payload
      });

      var labelValue = entry.value;
      if (label === true && entry.value && labelProps.label) {
        labelValue = labelProps.label;
      }
      return _this3.renderLabelItem(label, labelProps, labelValue);
    });

    return React__default.createElement(
      Layer,
      { className: 'recharts-bar-labels' },
      labels
    );
  };

  Bar.prototype.renderErrorBar = function renderErrorBar() {
    if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
      return null;
    }

    var _props3 = this.props,
        data = _props3.data,
        xAxis = _props3.xAxis,
        yAxis = _props3.yAxis,
        layout = _props3.layout,
        children = _props3.children;

    var errorBarItem = findChildByType(children, ErrorBar);

    if (!errorBarItem) {
      return null;
    }

    var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;

    function dataPointFormatter(dataPoint, dataKey) {
      return {
        x: dataPoint.x,
        y: dataPoint.y,
        value: dataPoint.value,
        errorVal: getValueByDataKey(dataPoint, dataKey)
      };
    }

    return React__default.cloneElement(errorBarItem, {
      data: data,
      xAxis: xAxis,
      yAxis: yAxis,
      layout: layout,
      offset: offset,
      dataPointFormatter: dataPointFormatter
    });
  };

  Bar.prototype.render = function render() {
    var _props4 = this.props,
        data = _props4.data,
        className = _props4.className,
        label = _props4.label,
        xAxis = _props4.xAxis,
        yAxis = _props4.yAxis,
        left = _props4.left,
        top = _props4.top,
        width = _props4.width,
        height = _props4.height;


    if (!data || !data.length) {
      return null;
    }

    var layerClass = classNames('recharts-bar', className);
    var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;

    return React__default.createElement(
      Layer,
      { className: layerClass },
      needClip ? React__default.createElement(
        'defs',
        null,
        React__default.createElement(
          'clipPath',
          { id: 'clipPath-' + this.id },
          React__default.createElement('rect', { x: left, y: top, width: width, height: height })
        )
      ) : null,
      React__default.createElement(
        Layer,
        {
          className: 'recharts-bar-rectangles',
          clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null
        },
        this.renderRectangles()
      ),
      label && React__default.createElement(
        Layer,
        { className: 'recharts-bar-rectangle-labels' },
        this.renderLabels()
      ),
      this.renderErrorBar()
    );
  };

  return Bar;
}(React.Component)) || _class$25;

Bar.displayName = 'Bar';
Bar.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'rect',
  minPointSize: 0,
  // data of bar
  data: [],
  layout: 'vertical',
  isAnimationActive: !isSsr(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',

  onAnimationStart: function onAnimationStart() {},
  onAnimationEnd: function onAnimationEnd() {}
};

var _class$26;

/**
 * @fileOverview Render a group of scatters
 */
var Scatter = AnimationDecorator(_class$26 = pureRenderDecorator$1(_class$26 = function (_Component) {
  inherits(Scatter, _Component);

  function Scatter() {
    var _temp, _this, _ret;

    classCallCheck(this, Scatter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { activeIndex: -1, isAnimationFinished: false }, _this.id = uniqueId('recharts-scatter-'), _temp), possibleConstructorReturn(_this, _ret);
  }

  Scatter.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var animationDuration = this.props.animationDuration;

    window.setTimeout(function () {
      return _this2.setState({ isAnimationFinished: true });
    }, animationDuration);
  };

  Scatter.prototype.renderSymbolItem = function renderSymbolItem(option, props) {
    var symbol$$1 = void 0;

    if (React__default.isValidElement(option)) {
      symbol$$1 = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      symbol$$1 = option(props);
    } else {
      symbol$$1 = React__default.createElement(Symbols, _extends({}, props, { type: option }));
    }

    return symbol$$1;
  };

  Scatter.prototype.renderSymbols = function renderSymbols() {
    var _this3 = this;

    var _props = this.props,
        points = _props.points,
        shape = _props.shape,
        activeShape = _props.activeShape,
        activeIndex = _props.activeIndex,
        animationBegin = _props.animationBegin,
        animationDuration = _props.animationDuration,
        isAnimationActive = _props.isAnimationActive,
        animationEasing = _props.animationEasing,
        animationId = _props.animationId;

    var baseProps = getPresentationAttributes(this.props);

    return points.map(function (entry, i) {
      var props = _extends({
        key: 'symbol-' + i
      }, baseProps, entry);
      return React__default.createElement(
        Layer,
        _extends({
          className: 'recharts-scatter-symbol'
        }, filterEventsOfChild(_this3.props, entry, i), {
          key: 'symbol-' + i
        }),
        React__default.createElement(
          Animate,
          {
            from: { size: 0 },
            to: { size: props.size },
            duration: animationDuration,
            begin: animationBegin,
            isActive: isAnimationActive,
            key: animationId,
            easing: animationEasing
          },
          function (_ref) {
            var size = _ref.size;

            var finalProps = _extends({}, props, { size: size });

            return _this3.renderSymbolItem(activeIndex === i ? activeShape : shape, finalProps);
          }
        )
      );
    });
  };

  Scatter.prototype.renderErrorBar = function renderErrorBar() {
    if (!this.state.isAnimationFinished) {
      return null;
    }

    var _props2 = this.props,
        points = _props2.points,
        xAxis = _props2.xAxis,
        yAxis = _props2.yAxis,
        children = _props2.children;

    var errorBarItems = findAllByType(children, ErrorBar);

    if (!errorBarItems) {
      return null;
    }

    function dataPointFormatterY(dataPoint, dataKey) {
      return {
        x: dataPoint.cx,
        y: dataPoint.cy,
        value: dataPoint.y,
        errorVal: getValueByDataKey(dataPoint, dataKey)
      };
    }

    function dataPointFormatterX(dataPoint, dataKey) {
      return {
        x: dataPoint.cx,
        y: dataPoint.cy,
        value: dataPoint.x,
        errorVal: getValueByDataKey(dataPoint, dataKey)
      };
    }

    return errorBarItems.map(function (item, i) {
      var direction = item.props.direction;


      return React__default.cloneElement(item, {
        key: i,
        data: points,
        xAxis: xAxis,
        yAxis: yAxis,
        layout: direction === 'x' ? 'vertical' : 'horizontal',
        dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
      });
    });
  };

  Scatter.prototype.renderLine = function renderLine() {
    var _props3 = this.props,
        points = _props3.points,
        line$$1 = _props3.line,
        lineType = _props3.lineType,
        lineJointType = _props3.lineJointType;

    var scatterProps = getPresentationAttributes(this.props);
    var customLineProps = getPresentationAttributes(line$$1);
    var linePoints = void 0,
        lineItem = void 0;

    if (lineType === 'joint') {
      linePoints = points.map(function (entry) {
        return { x: entry.cx, y: entry.cy };
      });
    }
    var lineProps = _extends({}, scatterProps, {
      fill: 'none',
      stroke: scatterProps && scatterProps.fill
    }, customLineProps, {
      points: linePoints
    });

    if (React__default.isValidElement(line$$1)) {
      lineItem = React__default.cloneElement(line$$1, lineProps);
    } else if (___default.isFunction(line$$1)) {
      lineItem = line$$1(lineProps);
    } else {
      lineItem = React__default.createElement(Curve, _extends({}, lineProps, { type: lineJointType }));
    }

    return React__default.createElement(
      Layer,
      { className: 'recharts-scatter-line', key: 'recharts-scatter-line' },
      lineItem
    );
  };

  Scatter.prototype.render = function render() {
    var _props4 = this.props,
        points = _props4.points,
        line$$1 = _props4.line,
        className = _props4.className,
        xAxis = _props4.xAxis,
        yAxis = _props4.yAxis,
        left = _props4.left,
        top = _props4.top,
        width = _props4.width,
        height = _props4.height;


    if (!points || !points.length) {
      return null;
    }

    var layerClass = classNames('recharts-scatter', className);
    var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;

    return React__default.createElement(
      Layer,
      {
        className: layerClass,
        clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null
      },
      needClip ? React__default.createElement(
        'defs',
        null,
        React__default.createElement(
          'clipPath',
          { id: 'clipPath-' + this.id },
          React__default.createElement('rect', { x: left, y: top, width: width, height: height })
        )
      ) : null,
      line$$1 && this.renderLine(),
      this.renderErrorBar(),
      React__default.createElement(
        Layer,
        { key: 'recharts-scatter-symbols' },
        this.renderSymbols()
      )
    );
  };

  return Scatter;
}(React.Component)) || _class$26) || _class$26;

Scatter.displayName = 'Scatter';
Scatter.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: 'circle',
  lineType: 'joint',
  lineJointType: 'linear',
  data: [],
  shape: 'circle',

  isAnimationActive: !isSsr(),
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'linear'
};

var _class$27;

/**
 * @fileOverview X Axis
 */
var XAxis = pureRenderDecorator$1(_class$27 = function (_Component) {
  inherits(XAxis, _Component);

  function XAxis() {
    classCallCheck(this, XAxis);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  XAxis.prototype.render = function render() {
    return null;
  };

  return XAxis;
}(React.Component)) || _class$27;

XAxis.displayName = 'XAxis';
XAxis.defaultProps = {
  allowDecimals: true,
  hide: false,
  orientation: 'bottom',
  width: 0,
  height: 30,
  mirror: false,
  xAxisId: 0,
  tickCount: 5,
  type: 'category',
  domain: [0, 'auto'],
  padding: { left: 0, right: 0 },
  allowDataOverflow: false,
  scale: 'auto'
};

var _class$28;

/**
 * @fileOverview Y Axis
 */
var YAxis = pureRenderDecorator$1(_class$28 = function (_Component) {
  inherits(YAxis, _Component);

  function YAxis() {
    classCallCheck(this, YAxis);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  YAxis.prototype.render = function render() {
    return null;
  };

  return YAxis;
}(React.Component)) || _class$28;

YAxis.displayName = 'YAxis';
YAxis.defaultProps = {
  allowDecimals: true,
  hide: false,
  orientation: 'left',
  width: 60,
  height: 0,
  mirror: false,
  yAxisId: 0,
  tickCount: 5,
  type: 'number',
  domain: [0, 'auto'],
  padding: { top: 0, bottom: 0 },
  allowDataOverflow: false,
  scale: 'auto'
};

var _class$29;

/**
 * @fileOverview Z Axis
 */
var ZAxis = pureRenderDecorator$1(_class$29 = function (_Component) {
  inherits(ZAxis, _Component);

  function ZAxis() {
    classCallCheck(this, ZAxis);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ZAxis.prototype.render = function render() {
    return null;
  };

  return ZAxis;
}(React.Component)) || _class$29;

ZAxis.displayName = 'ZAxis';
ZAxis.defaultProps = {
  zAxisId: 0,
  range: [64, 64],
  scale: 'auto'
};

var identity$2 = function identity(i) {
  return i;
};

var PLACE_HOLDER = {
  '@@functional/placeholder': true
};

var isPlaceHolder = function isPlaceHolder(val) {
  return val === PLACE_HOLDER;
};

var curry0 = function curry0(fn) {
  return function _curried() {
    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
      return _curried;
    }

    return fn.apply(undefined, arguments);
  };
};

var curryN = function curryN(n, fn) {
  if (n === 1) {
    return fn;
  }

  return curry0(function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var argsLength = args.filter(function (arg) {
      return arg !== PLACE_HOLDER;
    }).length;

    if (argsLength >= n) {
      return fn.apply(undefined, args);
    }

    return curryN(n - argsLength, curry0(function () {
      for (var _len2 = arguments.length, restArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        restArgs[_key2] = arguments[_key2];
      }

      var newArgs = args.map(function (arg) {
        return isPlaceHolder(arg) ? restArgs.shift() : arg;
      });

      return fn.apply(undefined, newArgs.concat(restArgs));
    }));
  });
};

var curry = function curry(fn) {
  return curryN(fn.length, fn);
};

var range = function range(begin, end) {
  var arr = [];

  for (var i = begin; i < end; ++i) {
    arr[i - begin] = i;
  }

  return arr;
};

var map = curry(function (fn, arr) {
  if (Array.isArray(arr)) {
    return arr.map(fn);
  }

  return Object.keys(arr).map(function (key) {
    return arr[key];
  }).map(fn);
});

var compose$1 = function compose() {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  if (!args.length) {
    return identity$2;
  }

  var fns = args.reverse();
  // first function can receive multiply arguments
  var firstFn = fns[0];
  var tailsFn = fns.slice(1);

  return function () {
    return tailsFn.reduce(function (res, fn) {
      return fn(res);
    }, firstFn.apply(undefined, arguments));
  };
};

var reverse = function reverse(arr) {
  if (Array.isArray(arr)) {
    return arr.reverse();
  }

  // can be string
  return arr.split('').reverse.join('');
};

var memoize = function memoize(fn) {
  var lastArgs = null;
  var lastResult = null;

  return function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    if (lastArgs && args.every(function (val, i) {
      return val === lastArgs[i];
    })) {
      return lastResult;
    }

    lastArgs = args;
    lastResult = fn.apply(undefined, args);

    return lastResult;
  };
};

/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */
/**
 * 判断数据是否为浮点类型
 *
 * @param {Number} num 输入值
 * @return {Boolean} 是否是浮点类型
 */
function isFloat(num) {
  return (/^([+-]?)\d*\.\d+$/.test(num)
  );
}

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */
function getDigitCount(value) {
  var abs = Math.abs(value);
  var result = void 0;

  if (value === 0) {
    result = 1;
  } else if (abs < 1) {
    result = Math.floor(Math.log(abs) / Math.log(10)) + 1;
  } else {
    var str = '' + value;
    var ary = str.split('.');

    result = ary[0].length;
  }

  return result;
}
/**
 * 计算数值的小数点后的位数
 * @param  {Number} a 数值，可能为整数，也可能为浮点数
 * @return {Integer}   位数
 */
function getDecimalDigitCount(a) {
  var str = a ? '' + a : '';
  var ary = str.split('.');

  return ary.length > 1 ? ary[1].length : 0;
}
/**
 * 乘法运算，解决了js运算的精度问题
 * @param  {Number} a 被乘数
 * @param  {Number} b 乘数
 * @return {Number}   积
 */
function multiply(a, b) {
  var intA = parseInt(('' + a).replace('.', ''), 10);
  var intB = parseInt(('' + b).replace('.', ''), 10);
  var count = getDecimalDigitCount(a) + getDecimalDigitCount(b);

  return intA * intB / Math.pow(10, count);
}
/**
 * 加法运算，解决了js运算的精度问题
 * @param  {Number} a 被加数
 * @param  {Number} b 加数
 * @return {Number}   和
 */
function sum(a, b) {
  var count = Math.max(getDecimalDigitCount(a), getDecimalDigitCount(b));

  count = Math.pow(10, count);

  return (multiply(a, count) + multiply(b, count)) / count;
}
/**
 * 减法运算，解决了js运算的精度问题
 * @param  {Number} a 被减数
 * @param  {Number} b 减数
 * @return {Number}   差
 */
function minus(a, b) {
  return sum(a, -b);
}
/**
 * 除法运算，解决了js运算的精度问题
 * @param  {Number} a 被除数
 * @param  {Number} b 除数
 * @return {Number}   结果
 */
function divide(a, b) {
  var ca = getDecimalDigitCount(a);
  var cb = getDecimalDigitCount(b);
  var intA = parseInt(('' + a).replace('.', ''), 10);
  var intB = parseInt(('' + b).replace('.', ''), 10);

  return intA / intB * Math.pow(10, cb - ca);
}

function modulo(a, b) {
  var mod = Math.abs(b);

  if (b <= 0) {
    return a;
  }

  var cnt = Math.floor(a / mod);

  return minus(a, multiply(mod, cnt));
}

/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Number} start 起点
 * @param  {Number} end   终点，不包含该值
 * @param  {Number} step  步长
 * @return {Array}        若干数值
 */
function rangeStep(start, end, step) {
  var num = start;
  var result = [];

  while (num < end) {
    result.push(num);

    num = sum(num, step);
  }

  return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */
var interpolateNumber = curry(function (a, b, t) {
  var newA = +a;
  var newB = +b;

  return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */
var uninterpolateNumber = curry(function (a, b, x) {
  var diff = b - +a;

  diff = diff || Infinity;

  return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */
var uninterpolateTruncation = curry(function (a, b, x) {
  var diff = b - +a;

  diff = diff || Infinity;

  return Math.max(0, Math.min(1, (x - a) / diff));
});

var Arithmetic = {
  rangeStep: rangeStep,
  isFloat: isFloat,
  getDigitCount: getDigitCount,
  getDecimalDigitCount: getDecimalDigitCount,

  sum: sum,
  minus: minus,
  multiply: multiply,
  divide: divide,
  modulo: modulo,

  interpolateNumber: interpolateNumber,
  uninterpolateNumber: uninterpolateNumber,
  uninterpolateTruncation: uninterpolateTruncation
};

/**
 * @fileOverview calculate tick values of scale
 * @author xile611, arcthur
 * @date 2015-09-17
 */

/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */
function getValidInterval(_ref) {
  var min = _ref[0],
      max = _ref[1];
  var validMin = min,
      validMax = max;

  // exchange

  if (min > max) {
    validMin = max;
    validMax = min;
  }

  return [validMin, validMax];
}

/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Number}  roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Number}  The step which is easy to understand between two ticks
 */
function getFormatStep(roughStep, allowDecimals, correctionFactor) {
  if (roughStep <= 0) {
    return 0;
  }

  var digitCount = Arithmetic.getDigitCount(roughStep);
  // The ratio between the rough step and the smallest number which has a bigger
  // order of magnitudes than the rough step
  var stepRatio = roughStep / Math.pow(10, digitCount);
  // When an integer and a float multiplied, the accuracy of result may be wrong
  var amendStepRatio = digitCount !== 1 ? Arithmetic.multiply(Math.ceil(stepRatio / 0.05) + correctionFactor, 0.05) : Arithmetic.multiply(Math.ceil(stepRatio / 0.1) + correctionFactor, 0.1);

  var formatStep = Arithmetic.multiply(amendStepRatio, Math.pow(10, digitCount));

  return allowDecimals ? formatStep : Math.ceil(formatStep);
}

/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */
function getTickOfSingleValue(value, tickCount, allowDecimals) {
  var isFlt = Arithmetic.isFloat(value);
  var step = 1;
  // calculate the middle value of ticks
  var middle = value;

  if (isFlt && allowDecimals) {
    var absVal = Math.abs(value);

    if (absVal < 1) {
      // The step should be a float number when the difference is smaller than 1
      step = Math.pow(10, Arithmetic.getDigitCount(value) - 1);

      middle = Arithmetic.multiply(Math.floor(value / step), step);
    } else if (absVal > 1) {
      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
      middle = Math.floor(value);
    }
  } else if (value === 0) {
    middle = Math.floor((tickCount - 1) / 2);
  } else if (!allowDecimals) {
    middle = Math.floor(value);
  }

  var middleIndex = Math.floor((tickCount - 1) / 2);

  var fn = compose$1(map(function (n) {
    return Arithmetic.sum(middle, Arithmetic.multiply(n - middleIndex, step));
  }), range);

  return fn(0, tickCount);
}

/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */
function calculateStep(min, max, tickCount, allowDecimals) {
  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  // The step which is easy to understand between two ticks
  var step = getFormatStep((max - min) / (tickCount - 1), allowDecimals, correctionFactor);
  // A medial value of ticks
  var middle = void 0;

  // When 0 is inside the interval, 0 should be a tick
  if (min <= 0 && max >= 0) {
    middle = 0;
  } else {
    middle = Arithmetic.divide(Arithmetic.sum(min, max), 2);
    middle = Arithmetic.minus(middle, Arithmetic.modulo(middle, step));
  }

  var belowCount = Math.ceil((middle - min) / step);
  var upCount = Math.ceil((max - middle) / step);
  var scaleCount = belowCount + upCount + 1;

  if (scaleCount > tickCount) {
    // When more ticks need to cover the interval, step should be bigger.
    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
  } else if (scaleCount < tickCount) {
    // When less ticks can cover the interval, we should add some additional ticks
    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
  }

  return {
    step: step,
    tickMin: Arithmetic.minus(middle, Arithmetic.multiply(belowCount, step)),
    tickMax: Arithmetic.sum(middle, Arithmetic.multiply(upCount, step))
  };
}
/**
 * Calculate the ticks of an interval
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */
function getNiceTickValuesFn(_ref2) {
  var min = _ref2[0],
      max = _ref2[1];
  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval = getValidInterval([min, max]),
      cormin = _getValidInterval[0],
      cormax = _getValidInterval[1];

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  }

  // Get the step between two ticks

  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
      step = _calculateStep.step,
      tickMin = _calculateStep.tickMin,
      tickMax = _calculateStep.tickMax;

  var values = Arithmetic.rangeStep(tickMin, tickMax + 0.1 * step, step);

  return min > max ? reverse(values) : values;
}

function getTickValuesFixedDomainFn(_ref4, tickCount) {
  var min = _ref4[0],
      max = _ref4[1];
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var _getValidInterval3 = getValidInterval([min, max]),
      cormin = _getValidInterval3[0],
      cormax = _getValidInterval3[1];

  if (cormin === cormax) {
    return [cormin];
  }

  var count = Math.max(tickCount, 2);
  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
  var values = [].concat(Arithmetic.rangeStep(cormin, cormax - 0.99 * step, step), [cormax]);

  return min > max ? reverse(values) : values;
}

var getNiceTickValues = memoize(getNiceTickValuesFn);

var getTickValuesFixedDomain = memoize(getTickValuesFixedDomainFn);

var _this = window;

/* eslint no-param-reassign: 0 */
var offsetSign = function offsetSign(series) {
  var n = series.length;
  if (n <= 0) {
    return;
  }

  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;
    var negative = 0;

    for (var i = 0; i < n; ++i) {
      var value = isNaN(series[i][j][1]) ? series[i][j][0] : series[i][j][1];

      if (value >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = negative;
        series[i][j][1] = negative + value;
        negative = series[i][j][1];
      }
    }
  }
};

var STACK_OFFSET_MAP = {
  sign: offsetSign,
  expand: d3Shape.stackOffsetExpand,
  none: d3Shape.stackOffsetNone,
  silhouette: d3Shape.stackOffsetSilhouette,
  wiggle: d3Shape.stackOffsetWiggle
};

var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType) {
  var lines = findAllByType(children, ReferenceLine);
  var dots = findAllByType(children, ReferenceDot);
  var elements = lines.concat(dots);
  var areas = findAllByType(children, ReferenceArea);
  var idKey = axisType + 'Id';
  var valueKey = axisType[0];
  var finalDomain = domain;

  if (elements.length) {
    finalDomain = elements.reduce(function (result, el) {
      if (el.props[idKey] === axisId && el.props.alwaysShow && isNumber(el.props[valueKey])) {
        var value = el.props[valueKey];

        return [Math.min(result[0], value), Math.max(result[1], value)];
      }
      return result;
    }, finalDomain);
  }

  if (areas.length) {
    (function () {
      var key1 = valueKey + '1';
      var key2 = valueKey + '2';

      finalDomain = areas.reduce(function (result, el) {
        if (el.props[idKey] === axisId && el.props.alwaysShow && isNumber(el.props[key1]) && isNumber(el.props[key2])) {
          var value1 = el.props[key1];
          var value2 = el.props[key2];

          return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
        }
        return result;
      }, finalDomain);
    })();
  }

  return finalDomain;
};

var getStackedData = function getStackedData(data, stackItems, offsetType) {
  var dataKeys = stackItems.map(function (item) {
    return item.props.dataKey;
  });
  var stack$$1 = d3Shape.stack().keys(dataKeys).value(function (d, key) {
    return +getValueByDataKey(d, key, 0);
  }).order(d3Shape.stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);

  return stack$$1(data);
};

var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, items, numericAxisId, cateAxisId, offsetType) {
  var stackGroups = items.reduce(function (result, item) {
    var _babelHelpers$extends;

    var stackId = item.props.stackId;

    var axisId = item.props[numericAxisId];
    var parentGroup = result[axisId] || { hasStack: false, stackGroups: {} };

    if (isNumOrStr(stackId)) {
      var childGroup = parentGroup.stackGroups[stackId] || {
        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: []
      };

      childGroup.items = [item].concat(childGroup.items);

      parentGroup.hasStack = true;

      parentGroup.stackGroups[stackId] = childGroup;
    } else {
      parentGroup.stackGroups[uniqueId('_stackId_')] = {
        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: [item]
      };
    }

    return _extends({}, result, (_babelHelpers$extends = {}, _babelHelpers$extends[axisId] = parentGroup, _babelHelpers$extends));
  }, {});

  return Object.keys(stackGroups).reduce(function (result, axisId) {
    var _babelHelpers$extends3;

    var group = stackGroups[axisId];

    if (group.hasStack) {
      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
        var _babelHelpers$extends2;

        var g = group.stackGroups[stackId];

        return _extends({}, res, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[stackId] = {
          numericAxisId: numericAxisId,
          cateAxisId: cateAxisId,
          items: g.items,
          stackedData: getStackedData(data, g.items, offsetType)
        }, _babelHelpers$extends2));
      }, {});
    }

    return _extends({}, result, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[axisId] = group, _babelHelpers$extends3));
  }, {});
};

var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
  var stackId = item.props.stackId;


  if (isNumOrStr(stackId)) {
    var group = stackGroups[stackId];

    if (group && group.items.length) {
      var itemIndex = -1;

      for (var i = 0, len = group.items.length; i < len; i++) {
        if (group.items[i] === item) {
          itemIndex = i;
          break;
        }
      }
      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
    }
  }

  return null;
};
/**
 * get domain of ticks
 * @param  {Array} ticks Ticks of axis
 * @param  {String} type  The type of axis
 * @return {Array} domain
 */
var calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
  if (type === 'number') {
    return [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
  }

  return ticks;
};

/**
 * Get domain of data by key
 * @param  {Array}   data      The data displayed in the chart
 * @param  {String}  key       The unique key of a group of data
 * @param  {String}  type      The type of axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array} Domain of data
 */
var getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
  var flattenData = data.reduce(function (result, entry) {
    var value = getValueByDataKey(entry, key);

    if (___default.isArray(value)) {
      return [].concat(result, value);
    }

    return [].concat(result, [value]);
  }, []);

  if (type === 'number') {
    var domain = flattenData.filter(isNumber);

    return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
  }

  var validateData = filterNil ? flattenData.filter(function (entry) {
    return !___default.isNil(entry);
  }) : flattenData;

  return validateData.map(function (entry) {
    return isNumOrStr(entry) ? entry : '';
  });
};

var getDomainOfSingle = function getDomainOfSingle(data) {
  return data.reduce(function (result, entry) {
    return [Math.min.apply(null, entry.concat([result[0]]).filter(isNumber)), Math.max.apply(null, entry.concat([result[1]]).filter(isNumber))];
  }, [Infinity, -Infinity]);
};

var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
  return Object.keys(stackGroups).reduce(function (result, stackId) {
    var group = stackGroups[stackId];
    var stackedData = group.stackedData;

    var domain = stackedData.reduce(function (res, entry) {
      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));

      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
    }, [Infinity, -Infinity]);

    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
  }, [Infinity, -Infinity]).map(function (result) {
    return result === Infinity || result === -Infinity ? 0 : result;
  });
};

/**
 * Get domain of data by the configuration of item element
 * @param  {Array}   data      The data displayed in the chart
 * @param  {Array}   items     The instances of item
 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array}        Domain
 */
var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
  var domains = items.map(function (item) {
    return getDomainOfDataByKey(data, item.props.dataKey, type, filterNil);
  });

  if (type === 'number') {
    // Calculate the domain of number axis
    return domains.reduce(function (result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }

  var tag = {};
  // Get the union set of category axis
  return domains.reduce(function (result, entry) {
    for (var i = 0, len = entry.length; i < len; i++) {
      if (!tag[entry[i]]) {
        tag[entry[i]] = true;

        result.push(entry[i]);
      }
    }
    return result;
  }, []);
};

var isCategorialAxis = function isCategorialAxis(layout, axisType) {
  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis';
};
/**
* Calculate the Coordinates of grid
* @param  {Array} ticks The ticks in axis
* @param {Number} min   The minimun value of axis
* @param {Number} max   The maximun value of axis
* @return {Array}       Coordinates
*/
var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
  var hasMin = void 0,
      hasMax = void 0;

  var values = ticks.map(function (entry) {
    if (entry.coordinate === min) {
      hasMin = true;
    }
    if (entry.coordinate === max) {
      hasMax = true;
    }

    return entry.coordinate;
  });

  if (!hasMin) {
    values.push(min);
  }
  if (!hasMax) {
    values.push(max);
  }

  return values;
};

/**
 * Get the ticks of an axis
 * @param  {Object}  axis The configuration of an axis
 * @param {Boolean} isGrid Whether or not are the ticks in grid
 * @param {Boolean} isAll Return the ticks of all the points or not
 * @return {Array}  Ticks
 */
var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
  if (!axis) return null;
  var scale = axis.scale;
  var duplicateDomain = axis.duplicateDomain,
      type = axis.type;

  var offset = (isGrid || isAll) && type === 'category' ? scale.bandwidth() / 2 : 0;

  // The ticks setted by user should only affect the ticks adjacent to axis line
  if (isGrid && (axis.ticks || axis.niceTicks)) {
    return (axis.ticks || axis.niceTicks).map(function (entry) {
      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;

      return {
        coordinate: scale(scaleContent) + offset,
        value: entry
      };
    });
  }

  if (axis.isCategorial && axis.categoricalDomain) {
    return axis.categoricalDomain.map(function (entry, index) {
      return {
        coordinate: scale(entry),
        value: entry,
        index: index
      };
    });
  }

  if (scale.ticks && !isAll) {
    return scale.ticks(axis.tickCount).map(function (entry) {
      return { coordinate: scale(entry) + offset, value: entry };
    });
  }

  // When axis has duplicated text, serial numbers are used to generate scale
  return scale.domain().map(function (entry, index) {
    return {
      coordinate: scale(entry) + offset,
      value: duplicateDomain ? duplicateDomain[entry] : entry,
      index: index
    };
  });
};

var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks) {
  var index = -1;
  var len = ticks.length;

  if (len > 1) {
    for (var i = 0; i < len; i++) {
      if (i === 0 && coordinate <= (ticks[i].coordinate + ticks[i + 1].coordinate) / 2 || i > 0 && i < len - 1 && coordinate > (ticks[i].coordinate + ticks[i - 1].coordinate) / 2 && coordinate <= (ticks[i].coordinate + ticks[i + 1].coordinate) / 2 || i === len - 1 && coordinate > (ticks[i].coordinate + ticks[i - 1].coordinate) / 2) {
        index = ticks[i].index;
        break;
      }
    }
  } else {
    index = 0;
  }

  return index;
};

/**
 * Get the main color of each graphic item
 * @param  {ReactElement} item A graphic item
 * @return {String}            Color
 */
var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
  var displayName = item.type.displayName;
  var result = void 0;

  switch (displayName) {
    case 'Line':
    case 'Area':
      result = item.props.stroke;
      break;
    default:
      result = item.props.fill;
      break;
  }

  return result;
};

var getLegendProps = function getLegendProps(children, graphicItems, width) {
  var legendItem = findChildByType(children, Legend);

  if (!legendItem) {
    return null;
  }

  var legendData = legendItem.props && legendItem.props.payload || graphicItems.map(function (child) {
    var _child$props = child.props,
        dataKey = _child$props.dataKey,
        name = _child$props.name,
        legendType = _child$props.legendType;


    return {
      dataKey: dataKey,
      type: legendItem.props.iconType || legendType || 'square',
      color: getMainColorOfGraphicItem(child),
      value: name || dataKey,
      payload: child.props
    };
  }, _this);

  return _extends({}, legendItem.props, Legend.getWithHeight(legendItem, width), {
    payload: legendData
  });
};
/**
 * Configure the scale function of axis
 * @param {Object} scale The scale function
 * @param {Object} opts  The configuration of axis
 * @return {Object}      null
 */
var getTicksOfScale = function getTicksOfScale(scale, opts) {
  var type = opts.type,
      tickCount = opts.tickCount,
      originalDomain = opts.originalDomain,
      allowDecimals = opts.allowDecimals;


  if (opts.scale !== 'auto' && opts.scale !== 'linear') {
    return null;
  }

  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
    // Calculate the ticks by the number of grid when the axis is a number axis
    var domain = scale.domain();
    var tickValues = getNiceTickValues(domain, tickCount, allowDecimals);

    scale.domain(calculateDomainOfTicks(tickValues, type));

    return { niceTicks: tickValues };
  } else if (tickCount && type === 'number') {
    var _domain = scale.domain();
    var _tickValues = getTickValuesFixedDomain(_domain, tickCount, allowDecimals);

    return { niceTicks: _tickValues };
  }

  return null;
};

/**
 * Calculate the size of all groups for stacked bar graph
 * @param  {Object} stackGroups The items grouped by axisId and stackId
 * @return {Object} The size of all groups
 */
var getBarSizeList = function getBarSizeList(_ref) {
  var globalSize = _ref.barSize,
      _ref$stackGroups = _ref.stackGroups,
      stackGroups = _ref$stackGroups === undefined ? {} : _ref$stackGroups;

  var result = {};
  var numericAxisIds = Object.keys(stackGroups);

  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
    var stackIds = Object.keys(sgs);

    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
      var _sgs$stackIds$j = sgs[stackIds[j]],
          items = _sgs$stackIds$j.items,
          cateAxisId = _sgs$stackIds$j.cateAxisId;


      var barItems = items.filter(function (item) {
        return item.type.displayName === 'Bar';
      });

      if (barItems && barItems.length) {
        var selfSize = barItems[0].props.barSize;

        var cateId = barItems[0].props[cateAxisId];

        if (!result[cateId]) {
          result[cateId] = [];
        }

        result[cateId].push({
          item: barItems[0],
          stackList: barItems.slice(1),
          barSize: ___default.isNil(selfSize) ? globalSize : selfSize
        });
      }
    }
  }

  return result;
};

/**
   * Calculate the size of each bar and the gap between two bars
   * @param  {Number} bandSize  The size of each category
   * @param  {sizeList} sizeList  The size of all groups
   * @param  {maxBarSize} maxBarSize The maximum size of bar
   * @return {Number} The size of each bar and the gap between two bars
   */
var getBarPosition = function getBarPosition(_ref2) {
  var barGap = _ref2.barGap,
      barCategoryGap = _ref2.barCategoryGap,
      bandSize = _ref2.bandSize,
      _ref2$sizeList = _ref2.sizeList,
      sizeList = _ref2$sizeList === undefined ? [] : _ref2$sizeList,
      maxBarSize = _ref2.maxBarSize;

  var len = sizeList.length;
  if (len < 1) return null;

  var realBarGap = getPercentValue(barGap, bandSize, 0, true);
  var result = void 0;

  // whether or not is barSize setted by user
  if (sizeList[0].barSize === +sizeList[0].barSize) {
    (function () {
      var useFull = false;
      var fullBarSize = bandSize / len;
      var sum = sizeList.reduce(function (res, entry) {
        return res + entry.barSize || 0;
      }, 0);
      sum += (len - 1) * realBarGap;

      if (sum >= bandSize) {
        sum -= (len - 1) * realBarGap;
        realBarGap = 0;
      }
      if (sum >= bandSize) {
        useFull = true;
        fullBarSize *= 0.9;
        sum = len * fullBarSize;
      }

      var offset = (bandSize - sum) / 2 >> 0;
      var prev = { offset: offset - realBarGap, size: 0 };

      result = sizeList.reduce(function (res, entry) {
        var newRes = [].concat(res, [{
          item: entry.item,
          position: {
            offset: prev.offset + prev.size + realBarGap,
            size: useFull ? fullBarSize : entry.barSize
          }
        }]);

        prev = newRes[newRes.length - 1].position;

        if (entry.stackList && entry.stackList.length) {
          entry.stackList.forEach(function (item) {
            newRes.push({ item: item, position: prev });
          });
        }
        return newRes;
      }, []);
    })();
  } else {
    (function () {
      var offset = getPercentValue(barCategoryGap, bandSize, 0, true);

      if (bandSize - 2 * offset - (len - 1) * realBarGap <= 0) {
        realBarGap = 0;
      }

      var originalSize = (bandSize - 2 * offset - (len - 1) * realBarGap) / len;
      if (originalSize > 1) {
        originalSize >>= 0;
      }
      var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;

      result = sizeList.reduce(function (res, entry, i) {
        var newRes = [].concat(res, [{
          item: entry.item,
          position: {
            offset: offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
            size: size
          }
        }]);

        if (entry.stackList && entry.stackList.length) {
          entry.stackList.forEach(function (item) {
            newRes.push({ item: item, position: newRes[newRes.length - 1].position });
          });
        }
        return newRes;
      }, []);
    })();
  }

  return result;
};

var appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
  var children = props.children,
      width = props.width,
      height = props.height,
      margin = props.margin;

  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
  var legendProps = getLegendProps(children, items, legendWidth, legendHeight);
  var newOffset = offset;

  if (legendProps) {
    var box = legendBox || {};
    var align = legendProps.align,
        verticalAlign = legendProps.verticalAlign,
        layout = legendProps.layout;


    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && isNumber(offset[align])) {
      var _babelHelpers$extends4;

      newOffset = _extends({}, offset, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[align] = newOffset[align] + (box.width || 0), _babelHelpers$extends4));
    }

    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && isNumber(offset[verticalAlign])) {
      var _babelHelpers$extends5;

      newOffset = _extends({}, offset, (_babelHelpers$extends5 = {}, _babelHelpers$extends5[verticalAlign] = newOffset[verticalAlign] + (box.height || 0), _babelHelpers$extends5));
    }
  }

  return newOffset;
};

var index$2 = createCommonjsModule(function (module) {
  'use strict';

  var has = Object.prototype.hasOwnProperty,
      prefix = '~';

  /**
   * Constructor to create a storage for our `EE` objects.
   * An `Events` instance is a plain object whose properties are event names.
   *
   * @constructor
   * @api private
   */
  function Events() {}

  //
  // We try to not inherit from `Object.prototype`. In some engines creating an
  // instance in this way is faster than calling `Object.create(null)` directly.
  // If `Object.create(null)` is not supported we prefix the event names with a
  // character to make sure that the built-in object properties are not
  // overridden or used as an attack vector.
  //
  if (Object.create) {
    Events.prototype = Object.create(null);

    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
  }

  /**
   * Representation of a single event listener.
   *
   * @param {Function} fn The listener function.
   * @param {Mixed} context The context to invoke the listener with.
   * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
   * @constructor
   * @api private
   */
  function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
  }

  /**
   * Minimal `EventEmitter` interface that is molded against the Node.js
   * `EventEmitter` interface.
   *
   * @constructor
   * @api public
   */
  function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
  }

  /**
   * Return an array listing the events for which the emitter has registered
   * listeners.
   *
   * @returns {Array}
   * @api public
   */
  EventEmitter.prototype.eventNames = function eventNames() {
    var names = [],
        events,
        name;

    if (this._eventsCount === 0) return names;

    for (name in events = this._events) {
      if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    }

    if (Object.getOwnPropertySymbols) {
      return names.concat(Object.getOwnPropertySymbols(events));
    }

    return names;
  };

  /**
   * Return the listeners registered for a given event.
   *
   * @param {String|Symbol} event The event name.
   * @param {Boolean} exists Only check if there are listeners.
   * @returns {Array|Boolean}
   * @api public
   */
  EventEmitter.prototype.listeners = function listeners(event, exists) {
    var evt = prefix ? prefix + event : event,
        available = this._events[evt];

    if (exists) return !!available;
    if (!available) return [];
    if (available.fn) return [available.fn];

    for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
      ee[i] = available[i].fn;
    }

    return ee;
  };

  /**
   * Calls each of the listeners registered for a given event.
   *
   * @param {String|Symbol} event The event name.
   * @returns {Boolean} `true` if the event had listeners, else `false`.
   * @api public
   */
  EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;

    if (!this._events[evt]) return false;

    var listeners = this._events[evt],
        len = arguments.length,
        args,
        i;

    if (listeners.fn) {
      if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

      switch (len) {
        case 1:
          return listeners.fn.call(listeners.context), true;
        case 2:
          return listeners.fn.call(listeners.context, a1), true;
        case 3:
          return listeners.fn.call(listeners.context, a1, a2), true;
        case 4:
          return listeners.fn.call(listeners.context, a1, a2, a3), true;
        case 5:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
        case 6:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
      }

      for (i = 1, args = new Array(len - 1); i < len; i++) {
        args[i - 1] = arguments[i];
      }

      listeners.fn.apply(listeners.context, args);
    } else {
      var length = listeners.length,
          j;

      for (i = 0; i < length; i++) {
        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

        switch (len) {
          case 1:
            listeners[i].fn.call(listeners[i].context);break;
          case 2:
            listeners[i].fn.call(listeners[i].context, a1);break;
          case 3:
            listeners[i].fn.call(listeners[i].context, a1, a2);break;
          case 4:
            listeners[i].fn.call(listeners[i].context, a1, a2, a3);break;
          default:
            if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
              args[j - 1] = arguments[j];
            }

            listeners[i].fn.apply(listeners[i].context, args);
        }
      }
    }

    return true;
  };

  /**
   * Add a listener for a given event.
   *
   * @param {String|Symbol} event The event name.
   * @param {Function} fn The listener function.
   * @param {Mixed} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @api public
   */
  EventEmitter.prototype.on = function on(event, fn, context) {
    var listener = new EE(fn, context || this),
        evt = prefix ? prefix + event : event;

    if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];

    return this;
  };

  /**
   * Add a one-time listener for a given event.
   *
   * @param {String|Symbol} event The event name.
   * @param {Function} fn The listener function.
   * @param {Mixed} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @api public
   */
  EventEmitter.prototype.once = function once(event, fn, context) {
    var listener = new EE(fn, context || this, true),
        evt = prefix ? prefix + event : event;

    if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];

    return this;
  };

  /**
   * Remove the listeners of a given event.
   *
   * @param {String|Symbol} event The event name.
   * @param {Function} fn Only remove the listeners that match this function.
   * @param {Mixed} context Only remove the listeners that have this context.
   * @param {Boolean} once Only remove one-time listeners.
   * @returns {EventEmitter} `this`.
   * @api public
   */
  EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;

    if (!this._events[evt]) return this;
    if (!fn) {
      if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
      return this;
    }

    var listeners = this._events[evt];

    if (listeners.fn) {
      if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
        if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
      }
    } else {
      for (var i = 0, events = [], length = listeners.length; i < length; i++) {
        if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
          events.push(listeners[i]);
        }
      }

      //
      // Reset the array, or remove it completely if we have no more listeners.
      //
      if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
    }

    return this;
  };

  /**
   * Remove all listeners, or those of the specified event.
   *
   * @param {String|Symbol} [event] The event name.
   * @returns {EventEmitter} `this`.
   * @api public
   */
  EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;

    if (event) {
      evt = prefix ? prefix + event : event;
      if (this._events[evt]) {
        if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
      }
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }

    return this;
  };

  //
  // Alias methods names because people roll like that.
  //
  EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
  EventEmitter.prototype.addListener = EventEmitter.prototype.on;

  //
  // This function doesn't apply anymore.
  //
  EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
    return this;
  };

  //
  // Expose the prefix.
  //
  EventEmitter.prefixed = prefix;

  //
  // Allow `EventEmitter` to be imported as module namespace.
  //
  EventEmitter.EventEmitter = EventEmitter;

  //
  // Expose the module.
  //
  {
    module.exports = EventEmitter;
  }
});

var eventCenter = new index$2();

if (eventCenter.setMaxListeners) {
  eventCenter.setMaxListeners(10);
}

var SYNC_EVENT = 'recharts.syncMouseEvents';

var ORIENT_MAP = {
  xAxis: ['bottom', 'top'],
  yAxis: ['left', 'right']
};

var originCoordinate = { x: 0, y: 0 };

var generateCategoricalChart = function generateCategoricalChart(ChartComponent, GraphicalChild) {
  var CategoricalChartWrapper = function (_Component) {
    inherits(CategoricalChartWrapper, _Component);

    function CategoricalChartWrapper(props) {
      classCallCheck(this, CategoricalChartWrapper);

      var _this = possibleConstructorReturn(this, _Component.call(this, props));

      _this.handleLegendBBoxUpdate = function (box) {
        if (box && _this.legendInstance) {
          var _this$state = _this.state,
              dataStartIndex = _this$state.dataStartIndex,
              dataEndIndex = _this$state.dataEndIndex;


          _this.setState(_this.updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex
          }));
        }
      };

      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
        var _this$props = _this.props,
            syncId = _this$props.syncId,
            layout = _this$props.layout;


        if (syncId === cId && chartId !== _this.uniqueChartId) {
          var dataStartIndex = data.dataStartIndex,
              dataEndIndex = data.dataEndIndex;


          if (!___default.isNil(data.dataStartIndex) || !___default.isNil(data.dataEndIndex)) {
            _this.setState(_extends({
              dataStartIndex: dataStartIndex,
              dataEndIndex: dataEndIndex
            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex })));
          } else if (!___default.isNil(data.activeTooltipIndex)) {
            var chartX = data.chartX,
                chartY = data.chartY,
                activeTooltipIndex = data.activeTooltipIndex;
            var _this$state2 = _this.state,
                offset = _this$state2.offset,
                tooltipTicks = _this$state2.tooltipTicks;

            if (!offset) {
              return;
            }
            var viewBox = _extends({}, offset, { x: offset.left, y: offset.top });
            // When a categotical chart is combined with another chart, the value of chartX
            // and chartY may beyond the boundaries.
            var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
            var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
            var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
            var activePayload = _this.getTooltipContent(activeTooltipIndex);
            var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
              x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
              y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
            } : originCoordinate;

            _this.setState(_extends({}, data, { activeLabel: activeLabel, activeCoordinate: activeCoordinate, activePayload: activePayload }));
          } else {
            _this.setState(data);
          }
        }
      };

      _this.handleBrushChange = function (_ref) {
        var startIndex = _ref.startIndex,
            endIndex = _ref.endIndex;

        // Only trigger changes if the extents of the brush have actually changed
        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
          _this.setState(_extends({
            dataStartIndex: startIndex,
            dataEndIndex: endIndex
          }, _this.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this.props, dataStartIndex: startIndex, dataEndIndex: endIndex })));

          _this.triggerSyncEvent({
            dataStartIndex: startIndex,
            dataEndIndex: endIndex
          });
        }
      };

      _this.handleMouseEnter = function (e) {
        var onMouseEnter = _this.props.onMouseEnter;

        var mouse = _this.getMouseInfo(e);

        if (mouse) {
          var nextState = _extends({}, mouse, { isTooltipActive: true });
          _this.setState(nextState);
          _this.triggerSyncEvent(nextState);

          if (___default.isFunction(onMouseEnter)) {
            onMouseEnter(nextState, e);
          }
        }
      };

      _this.triggeredAfterMouseMove = function (e) {
        var onMouseMove = _this.props.onMouseMove;

        var mouse = _this.getMouseInfo(e);
        var nextState = mouse ? _extends({}, mouse, { isTooltipActive: true }) : { isTooltipActive: false };

        _this.setState(nextState);
        _this.triggerSyncEvent(nextState);

        if (___default.isFunction(onMouseMove)) {
          onMouseMove(nextState, e);
        }
      };

      _this.handleMouseMove = function (e) {
        if (e && ___default.isFunction(e.persist)) {
          e.persist();
          _this.triggeredAfterMouseMove(e);
        }
      };

      _this.handleMouseLeave = function (e) {
        var onMouseLeave = _this.props.onMouseLeave;

        var nextState = { isTooltipActive: false };

        _this.setState(nextState);
        _this.triggerSyncEvent(nextState);

        if (___default.isFunction(onMouseLeave)) {
          onMouseLeave(nextState, e);
        }
      };

      _this.handleClick = function (e) {
        var onClick = _this.props.onClick;


        if (___default.isFunction(onClick)) {
          var mouse = _this.getMouseInfo(e);

          onClick(mouse, e);
        }
      };

      _this.handleMouseDown = function (e) {
        var onMouseDown = _this.props.onMouseDown;


        if (___default.isFunction(onMouseDown)) {
          var mouse = _this.getMouseInfo(e);

          onMouseDown(mouse, e);
        }
      };

      _this.handleMouseUp = function (e) {
        var onMouseUp = _this.props.onMouseUp;


        if (___default.isFunction(onMouseUp)) {
          var mouse = _this.getMouseInfo(e);

          onMouseUp(mouse, e);
        }
      };

      _this.handleTouchMove = function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseMove(e.changedTouches[0]);
        }
      };

      _this.verticalCoordinatesGenerator = function (_ref2) {
        var xAxis = _ref2.xAxis,
            width = _ref2.width,
            height = _ref2.height,
            offset = _ref2.offset;
        return getCoordinatesOfGrid(CartesianAxis.getTicks(_extends({}, CartesianAxis.defaultProps, xAxis, {
          ticks: getTicksOfAxis(xAxis, true),
          viewBox: { x: 0, y: 0, width: width, height: height }
        })), offset.left, offset.left + offset.width);
      };

      _this.horizontalCoordinatesGenerator = function (_ref3) {
        var yAxis = _ref3.yAxis,
            width = _ref3.width,
            height = _ref3.height,
            offset = _ref3.offset;
        return getCoordinatesOfGrid(CartesianAxis.getTicks(_extends({}, CartesianAxis.defaultProps, yAxis, {
          ticks: getTicksOfAxis(yAxis, true),
          viewBox: { x: 0, y: 0, width: width, height: height }
        })), offset.top, offset.top + offset.height);
      };

      _this.axesTicksGenerator = function (axis) {
        return getTicksOfAxis(axis, true);
      };

      _this.tooltipTicksGenerator = function (_ref4) {
        var layout = _ref4.layout,
            xAxisMap = _ref4.xAxisMap,
            yAxisMap = _ref4.yAxisMap;

        var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
        var axis = getAnyElementOfObject(axisMap);
        var tooltipTicks = getTicksOfAxis(axis, false, true);

        return {
          tooltipTicks: tooltipTicks,
          orderedTooltipTicks: ___default.sortBy(tooltipTicks, function (o) {
            return o.coordinate;
          }),
          tooltipAxis: axis
        };
      };

      var defaultState = _this.createDefaultState(props);
      _this.state = _extends({}, defaultState, { updateId: 0
      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: props }, defaultState)));
      _this.validateAxes();
      _this.uniqueChartId = uniqueId('recharts');

      if (props.throttleDelay) {
        _this.triggeredAfterMouseMove = ___default.throttle(_this.triggeredAfterMouseMove, props.throttleDelay);
      }
      return _this;
    }

    /* eslint-disable  react/no-did-mount-set-state */


    CategoricalChartWrapper.prototype.componentDidMount = function componentDidMount() {
      if (!___default.isNil(this.props.syncId)) {
        this.addListener();
      }
    };

    CategoricalChartWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          data = _props.data,
          children = _props.children,
          width = _props.width,
          height = _props.height,
          layout = _props.layout,
          stackOffset = _props.stackOffset,
          margin = _props.margin;


      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !shallowEqual(nextProps.margin, margin)) {
        var defaultState = this.createDefaultState(nextProps);
        this.setState(_extends({}, defaultState, { updateId: this.state.updateId + 1
        }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, defaultState))));
      } else if (!isChildrenEqual(nextProps.children, children)) {
        var _defaultState = this.createDefaultState(nextProps);
        this.setState(_extends({}, _defaultState, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, _defaultState))));
      }
      // add syncId
      if (___default.isNil(this.props.syncId) && !___default.isNil(nextProps.syncId)) {
        this.addListener();
      }
      // remove syncId
      if (!___default.isNil(this.props.syncId) && ___default.isNil(nextProps.syncId)) {
        this.removeListener();
      }
    };

    CategoricalChartWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
      if (!___default.isNil(this.props.syncId)) {
        this.removeListener();
      }
      if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
        this.triggeredAfterMouseMove.cancel();
      }
    };
    /**
    * Get the configuration of all x-axis or y-axis
    * @param  {Object} props          Latest props
    * @param  {String} axisType       The type of axis
    * @param  {Array}  graphicalItems The instances of item
    * @param  {Object} stackGroups    The items grouped by axisId and stackId
    * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
    * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
    * @return {Object}          Configuration
    */


    CategoricalChartWrapper.prototype.getAxisMap = function getAxisMap(props, _ref5) {
      var _ref5$axisType = _ref5.axisType,
          axisType = _ref5$axisType === undefined ? 'xAxis' : _ref5$axisType,
          graphicalItems = _ref5.graphicalItems,
          stackGroups = _ref5.stackGroups,
          dataStartIndex = _ref5.dataStartIndex,
          dataEndIndex = _ref5.dataEndIndex;
      var children = props.children;

      var Axis = axisType === 'xAxis' ? XAxis : YAxis;
      var axisIdKey = axisType === 'xAxis' ? 'xAxisId' : 'yAxisId';
      // Get all the instance of Axis
      var axes = findAllByType(children, Axis);

      var axisMap = {};

      if (axes && axes.length) {
        axisMap = this.getAxisMapByAxes(props, { axes: axes, graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey,
          stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
      } else if (graphicalItems && graphicalItems.length) {
        axisMap = this.getAxisMapByItems(props, { graphicalItems: graphicalItems, Axis: Axis, axisType: axisType, axisIdKey: axisIdKey,
          stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
      }

      return axisMap;
    };

    /**
     * Get the configuration of axis by the options of axis instance
     * @param  {Object} props         Latest props
     * @param {Array}  axes           The instance of axes
     * @param  {Array} graphicalItems The instances of item
     * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
     * @param  {String} axisIdKey     The unique id of an axis
     * @param  {Object} stackGroups   The items grouped by axisId and stackId
     * @param {Number} dataStartIndex The start index of the data series when a brush is applied
     * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
     * @return {Object}      Configuration
     */


    CategoricalChartWrapper.prototype.getAxisMapByAxes = function getAxisMapByAxes(props, _ref6) {
      var axes = _ref6.axes,
          graphicalItems = _ref6.graphicalItems,
          axisType = _ref6.axisType,
          axisIdKey = _ref6.axisIdKey,
          stackGroups = _ref6.stackGroups,
          dataStartIndex = _ref6.dataStartIndex,
          dataEndIndex = _ref6.dataEndIndex;
      var layout = props.layout,
          children = props.children,
          data = props.data,
          stackOffset = props.stackOffset;

      var displayedData = data.slice(dataStartIndex, dataEndIndex + 1);
      var len = displayedData.length;
      var isCategorial = isCategorialAxis(layout, axisType);

      // Eliminate duplicated axes
      var axisMap = axes.reduce(function (result, child) {
        var _child$props = child.props,
            type = _child$props.type,
            dataKey = _child$props.dataKey,
            allowDataOverflow = _child$props.allowDataOverflow;

        var axisId = child.props[axisIdKey];

        if (!result[axisId]) {
          var _babelHelpers$extends;

          var domain = void 0,
              duplicateDomain = void 0,
              categoricalDomain = void 0;

          if (dataKey) {
            domain = getDomainOfDataByKey(displayedData, dataKey, type);

            if (type === 'category' && isCategorial) {
              var duplicate = hasDuplicate(domain);
              duplicateDomain = duplicate ? domain : null;

              // When category axis has duplicated text, serial numbers are used to generate scale
              domain = duplicate ? ___default.range(0, len) : domain;
            } else if (type === 'category') {
              // eliminate undefined or null or empty string
              domain = domain.filter(function (entry) {
                return entry !== '' && !___default.isNil(entry);
              });
            }

            if (isCategorial && type === 'number') {
              categoricalDomain = getDomainOfDataByKey(displayedData, dataKey, 'category');
            }
          } else if (isCategorial) {
            domain = ___default.range(0, len);
          } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
            // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [0, 1] : getDomainOfStackGroups(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
          } else {
            domain = getDomainOfItemsWithSameAxis(displayedData, graphicalItems.filter(function (entry) {
              return entry.props[axisIdKey] === axisId;
            }), type, true);
          }
          if (type === 'number') {
            // To detect wether there is any reference lines whose props alwaysShow is true
            domain = detectReferenceElementsDomain(children, domain, axisId, axisType);

            if (child.props.domain) {
              domain = parseSpecifiedDomain(child.props.domain, domain, allowDataOverflow);
            }
          }

          return _extends({}, result, (_babelHelpers$extends = {}, _babelHelpers$extends[axisId] = _extends({}, child.props, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: child.props.domain,
            isCategorial: isCategorial
          }), _babelHelpers$extends));
        }

        return result;
      }, {});
      return axisMap;
    };

    /**
     * Get the configuration of axis by the options of item,
     * this kind of axis does not display in chart
     * @param  {Object} props         Latest props
     * @param  {Array} graphicalItems The instances of item
     * @param  {ReactElement} Axis    Axis Component
     * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
     * @param  {String} axisIdKey     The unique id of an axis
     * @param  {Object} stackGroups   The items grouped by axisId and stackId
     * @param {Number} dataStartIndex The start index of the data series when a brush is applied
     * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
     * @return {Object}               Configuration
     */


    CategoricalChartWrapper.prototype.getAxisMapByItems = function getAxisMapByItems(props, _ref7) {
      var graphicalItems = _ref7.graphicalItems,
          Axis = _ref7.Axis,
          axisType = _ref7.axisType,
          axisIdKey = _ref7.axisIdKey,
          stackGroups = _ref7.stackGroups,
          dataStartIndex = _ref7.dataStartIndex,
          dataEndIndex = _ref7.dataEndIndex;
      var layout = props.layout,
          children = props.children,
          data = props.data;

      var displayedData = data.slice(dataStartIndex, dataEndIndex + 1);
      var len = displayedData.length;
      var isCategorial = isCategorialAxis(layout, axisType);
      var index = -1;

      // The default type of x-axis is category axis,
      // The default contents of x-axis is the serial numbers of data
      // The default type of y-axis is number axis
      // The default contents of y-axis is the domain of data
      var axisMap = graphicalItems.reduce(function (result, child) {
        var axisId = child.props[axisIdKey];

        if (!result[axisId]) {
          var _babelHelpers$extends2;

          index++;
          var domain = void 0;

          if (isCategorial) {
            domain = ___default.range(0, len);
          } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
            domain = getDomainOfStackGroups(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            domain = detectReferenceElementsDomain(children, domain, axisId, axisType);
          } else {
            domain = parseSpecifiedDomain(Axis.defaultProps.domain, getDomainOfItemsWithSameAxis(displayedData, graphicalItems.filter(function (entry) {
              return entry.props[axisIdKey] === axisId;
            }), 'number'), Axis.defaultProps.allowDataOverflow);
            domain = detectReferenceElementsDomain(children, domain, axisId, axisType);
          }

          return _extends({}, result, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[axisId] = _extends({
            axisType: axisType
          }, Axis.defaultProps, {
            hide: true,
            orientation: ORIENT_MAP[axisType][index % 2],
            domain: domain,
            originalDomain: Axis.defaultProps.domain,
            isCategorial: isCategorial
          }), _babelHelpers$extends2));
        }

        return result;
      }, {});

      return axisMap;
    };
    /**
     * Calculate the scale function, position, width, height of axes
     * @param  {Object} props    Latest props
     * @param  {Object} axisMap  The configuration of axes
     * @param  {Object} offset   The offset of main part in the svg element
     * @param  {Object} axisType The type of axes, x-axis or y-axis
     * @return {Object} Configuration
     */


    CategoricalChartWrapper.prototype.getFormatAxisMap = function getFormatAxisMap(props, axisMap, offset, axisType) {
      var width = props.width,
          height = props.height,
          layout = props.layout;

      var displayName = this.constructor.displayName;
      var ids = Object.keys(axisMap);
      var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
      };

      return ids.reduce(function (result, id) {
        var _babelHelpers$extends3;

        var axis = axisMap[id];
        var orientation = axis.orientation,
            domain = axis.domain,
            _axis$padding = axis.padding,
            padding = _axis$padding === undefined ? {} : _axis$padding,
            mirror = axis.mirror;

        var offsetKey = '' + orientation + (mirror ? 'Mirror' : '');

        var range = void 0,
            x = void 0,
            y = void 0,
            needSpace = void 0;

        if (axisType === 'xAxis') {
          range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
        } else {
          range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
        }

        var scale = parseScale(axis, displayName);
        scale.domain(domain).range(range);
        var ticks = getTicksOfScale(scale, axis);

        if (axisType === 'xAxis') {
          needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
          x = offset.left;
          y = steps[offsetKey] - needSpace * axis.height;
        } else {
          needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
          x = steps[offsetKey] - needSpace * axis.width;
          y = offset.top;
        }

        var finalAxis = _extends({}, axis, ticks, {
          x: x, y: y, scale: scale,
          width: axisType === 'xAxis' ? offset.width : axis.width,
          height: axisType === 'yAxis' ? offset.height : axis.height
        });
        if (!axis.hide && axisType === 'xAxis') {
          steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        } else if (!axis.hide) {
          steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        }

        return _extends({}, result, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[id] = finalAxis, _babelHelpers$extends3));
      }, {});
    };
    /**
     * Get the information of mouse in chart, return null when the mouse is not in the chart
     * @param  {Object} event    The event object
     * @return {Object}          Mouse data
     */


    CategoricalChartWrapper.prototype.getMouseInfo = function getMouseInfo(event) {
      if (!this.container) {
        return null;
      }

      var offset = this.state.offset;

      var containerOffset = getOffset(this.container);
      var e = calculateChartCoordinate(event, containerOffset);
      var isIn = e.chartX >= offset.left && e.chartX <= offset.left + offset.width && e.chartY >= offset.top && e.chartY <= offset.top + offset.height;

      if (!isIn) {
        return null;
      }

      var layout = this.props.layout;
      var _state = this.state,
          ticks = _state.orderedTooltipTicks,
          axis = _state.tooltipAxis,
          tooltipTicks = _state.tooltipTicks;

      var pos = layout === 'horizontal' ? e.chartX : e.chartY;
      var activeIndex = calculateActiveTickIndex(pos, ticks, axis);

      if (activeIndex >= 0) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = this.getTooltipContent(activeIndex);
        var activeCoordinate = tooltipTicks[activeIndex] ? {
          x: layout === 'horizontal' ? tooltipTicks[activeIndex].coordinate : e.chartX,
          y: layout === 'horizontal' ? e.chartY : tooltipTicks[activeIndex].coordinate
        } : originCoordinate;

        return _extends({}, e, {
          activeTooltipIndex: activeIndex,
          activeLabel: activeLabel,
          activePayload: activePayload,
          activeCoordinate: activeCoordinate
        });
      }

      return null;
    };
    /**
     * Get the content to be displayed in the tooltip
     * @param  {Number} activeIndex    Active index of data
     * @return {Array}                 The content of tooltip
     */


    CategoricalChartWrapper.prototype.getTooltipContent = function getTooltipContent(activeIndex) {
      var _state2 = this.state,
          dataStartIndex = _state2.dataStartIndex,
          dataEndIndex = _state2.dataEndIndex,
          graphicalItems = _state2.graphicalItems;

      var data = this.props.data.slice(dataStartIndex, dataEndIndex + 1);

      if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= data.length) {
        return null;
      }

      return graphicalItems.map(function (child) {
        var _child$props2 = child.props,
            dataKey = _child$props2.dataKey,
            name = _child$props2.name,
            unit = _child$props2.unit,
            formatter = _child$props2.formatter;


        return _extends({}, getPresentationAttributes(child), {
          dataKey: dataKey, unit: unit, formatter: formatter,
          name: name || dataKey,
          color: getMainColorOfGraphicItem(child),
          value: getValueByDataKey(data[activeIndex], dataKey),
          payload: data[activeIndex]
        });
      });
    };

    /**
     * The AxisMaps are expensive to render on large data sets
     * so provide the ability to store them in state and only update them when necessary
     * they are dependent upon the start and end index of
     * the brush so it's important that this method is called _after_
     * the state is updated with any new start/end indices
     *
     * @param {Object} props The props object to be used for updating the axismaps
     * @param {Number} dataStartIndex The start index of the data series when a brush is applied
     * @param {Number} dataEndIndex The end index of the data series when a brush is applied
     * @return {Object} state New state to set
     */


    CategoricalChartWrapper.prototype.updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8) {
      var props = _ref8.props,
          dataStartIndex = _ref8.dataStartIndex,
          dataEndIndex = _ref8.dataEndIndex;
      var data = props.data;

      if (!validateWidthHeight({ props: props }) || !data || !data.length) {
        return null;
      }

      var children = props.children,
          layout = props.layout,
          stackOffset = props.stackOffset;

      var numericIdName = layout === 'horizontal' ? 'yAxis' : 'xAxis';
      var cateIdName = layout === 'horizontal' ? 'xAxis' : 'yAxis';
      var graphicalItems = findAllByType(children, GraphicalChild);
      var stackGroups = getStackGroupsByAxisId(data, graphicalItems, numericIdName + 'Id', cateIdName + 'Id', stackOffset);

      var xAxisMap = this.getAxisMap(props, {
        axisType: 'xAxis',
        graphicalItems: graphicalItems,
        stackGroups: numericIdName === 'xAxis' && stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
      });

      var yAxisMap = this.getAxisMap(props, {
        axisType: 'yAxis',
        graphicalItems: graphicalItems,
        stackGroups: numericIdName === 'yAxis' && stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
      });

      var offset = this.calculateOffset(props, graphicalItems, xAxisMap, yAxisMap);

      xAxisMap = this.getFormatAxisMap(props, xAxisMap, offset, 'xAxis');
      yAxisMap = this.getFormatAxisMap(props, yAxisMap, offset, 'yAxis');

      var ticksObj = this.tooltipTicksGenerator({
        layout: layout, xAxisMap: xAxisMap, yAxisMap: yAxisMap
      });

      return _extends({ graphicalItems: graphicalItems, xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset, stackGroups: stackGroups }, ticksObj);
    };

    /* eslint-disable  no-underscore-dangle */


    CategoricalChartWrapper.prototype.addListener = function addListener() {
      eventCenter.on(SYNC_EVENT, this.handleReceiveSyncEvent);

      if (eventCenter.setMaxListeners && eventCenter._maxListeners) {
        eventCenter.setMaxListeners(eventCenter._maxListeners + 1);
      }
    };

    CategoricalChartWrapper.prototype.removeListener = function removeListener() {
      eventCenter.removeListener(SYNC_EVENT, this.handleReceiveSyncEvent);

      if (eventCenter.setMaxListeners && eventCenter._maxListeners) {
        eventCenter.setMaxListeners(eventCenter._maxListeners - 1);
      }
    };
    /**
     * Returns default, reset state for the categorical chart.
     * @param {Object} props Props object to use when creating the default state
     * @return {Object} Whole new state
     */


    CategoricalChartWrapper.prototype.createDefaultState = function createDefaultState(props) {
      var children = props.children;

      var brushItem = findChildByType(children, Brush);
      var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
      var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
      return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: false
      };
    };
    /**
     * Calculate the offset of main part in the svg element
     * @param  {Object} props          Latest props
     * @param  {Array}  graphicalItems The instances of item
     * @param  {Object} xAxisMap       The configuration of x-axis
     * @param  {Object} yAxisMap       The configuration of y-axis
     * @return {Object} The offset of main part in the svg element
     */


    CategoricalChartWrapper.prototype.calculateOffset = function calculateOffset(props, graphicalItems, xAxisMap, yAxisMap) {
      var width = props.width,
          height = props.height,
          children = props.children;

      var margin = props.margin || {};
      var brushItem = findChildByType(children, Brush);
      var legendItem = findChildByType(children, Legend);

      var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;

        if (!entry.mirror && !entry.hide) {
          var _babelHelpers$extends4;

          return _extends({}, result, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[orientation] = result[orientation] + entry.width, _babelHelpers$extends4));
        }

        return result;
      }, { left: margin.left || 0, right: margin.right || 0 });

      var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;

        if (!entry.mirror && !entry.hide) {
          var _babelHelpers$extends5;

          return _extends({}, result, (_babelHelpers$extends5 = {}, _babelHelpers$extends5[orientation] = result[orientation] + entry.height, _babelHelpers$extends5));
        }

        return result;
      }, { top: margin.top || 0, bottom: margin.bottom || 0 });

      var offset = _extends({}, offsetV, offsetH);

      var brushBottom = offset.bottom;

      if (brushItem) {
        offset.bottom += brushItem.props.height || Brush.defaultProps.height;
      }

      if (legendItem && this.legendInstance) {
        var legendBox = this.legendInstance.getBBox();
        offset = appendOffsetOfLegend(offset, graphicalItems, props, legendBox);
      }

      return _extends({
        brushBottom: brushBottom
      }, offset, {
        width: width - offset.left - offset.right,
        height: height - offset.top - offset.bottom
      });
    };
    /**
     * The handler of mouse entering chart
     * @param  {Object} e              Event object
     * @return {Null}                  null
     */


    /**
     * The handler of mouse moving in chart
     * @param  {Object} e        Event object
     * @return {Null} no return
     */

    /**
     * The handler if mouse leaving chart
     * @param {Object} e Event object
     * @return {Null} no return
     */


    CategoricalChartWrapper.prototype.validateAxes = function validateAxes() {
      var _props2 = this.props,
          layout = _props2.layout,
          children = _props2.children;

      var xAxes = findAllByType(children, XAxis);
      var yAxes = findAllByType(children, YAxis);

      if (layout === 'horizontal' && xAxes && xAxes.length) {
        xAxes.forEach(function (axis) {
          warn$1(axis.props.type === 'category' || axis.props.type === 'number' && !___default.isNil(axis.props.dataKey), 'x-axis should be a category axis or a number axis which has specifed dataKey\n             when the layout is horizontal');
        });
      } else if (layout === 'vertical') {
        var displayName = this.constructor.displayName;

        warn$1(yAxes && yAxes.length, 'You should add <YAxis type="number" /> in ' + displayName + '.\n           The layout is vertical now, y-axis should be category axis,\n           but y-axis is number axis when no YAxis is added.');
        warn$1(xAxes && xAxes.length, 'You should add <XAxis /> in ' + displayName + '.\n          The layout is vertical now, x-axis is category when no XAxis is added.');

        if (yAxes && yAxes.length) {
          yAxes.forEach(function (axis) {
            warn$1(axis.props.type === 'category' || axis.props.type === 'number' && !___default.isNil(axis.props.dataKey), 'y-axis should be a category axis or a number axis which has specifed dataKey\n               when the layout is vertical');
          });
        }
      }

      return null;
    };

    CategoricalChartWrapper.prototype.triggerSyncEvent = function triggerSyncEvent(data) {
      var syncId = this.props.syncId;


      if (!___default.isNil(syncId)) {
        eventCenter.emit(SYNC_EVENT, syncId, this.uniqueChartId, data);
      }
    };

    /**
     * Draw axes
     * @param {Object} axisMap The configuration of all x-axes or y-axes
     * @param {String} name    The name of axes
     * @return {ReactElement}  The instance of x-axes
     */
    CategoricalChartWrapper.prototype.renderAxes = function renderAxes(axisMap, name) {
      var _props3 = this.props,
          width = _props3.width,
          height = _props3.height;

      var ids = axisMap && Object.keys(axisMap);

      if (ids && ids.length) {
        var axes = [];

        for (var i = 0, len = ids.length; i < len; i++) {
          var axis = axisMap[ids[i]];

          if (!axis.hide) {

            axes.push(React__default.createElement(CartesianAxis, _extends({}, axis, {
              key: name + '-' + ids[i],
              viewBox: { x: 0, y: 0, width: width, height: height },
              ticksGenerator: this.axesTicksGenerator
            })));
          }
        }

        return axes.length ? React__default.createElement(
          Layer,
          { key: name + '-layer', className: 'recharts-' + name },
          axes
        ) : null;
      }

      return null;
    };

    /**
     * Draw grid
     * @return {ReactElement} The instance of grid
     */


    CategoricalChartWrapper.prototype.renderGrid = function renderGrid() {
      var _state3 = this.state,
          xAxisMap = _state3.xAxisMap,
          yAxisMap = _state3.yAxisMap,
          offset = _state3.offset;
      var _props4 = this.props,
          children = _props4.children,
          width = _props4.width,
          height = _props4.height;

      var gridItem = findChildByType(children, CartesianGrid);

      if (!gridItem) {
        return null;
      }

      var xAxis = getAnyElementOfObject(xAxisMap);
      var yAxis = getAnyElementOfObject(yAxisMap);

      return React__default.cloneElement(gridItem, {
        key: 'grid',
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height,
        xAxis: xAxis,
        yAxis: yAxis,
        offset: offset,
        chartWidth: width,
        chartHeight: height,
        verticalCoordinatesGenerator: this.verticalCoordinatesGenerator,
        horizontalCoordinatesGenerator: this.horizontalCoordinatesGenerator
      });
    };
    /**
     * Draw legend
     * @return {ReactElement}            The instance of Legend
     */


    CategoricalChartWrapper.prototype.renderLegend = function renderLegend() {
      var _this2 = this;

      var graphicalItems = this.state.graphicalItems;
      var _props5 = this.props,
          children = _props5.children,
          width = _props5.width,
          height = _props5.height;

      var margin = this.props.margin || {};
      var legendWidth = width - (margin.left || 0) - (margin.right || 0);
      var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
      var props = getLegendProps(children, graphicalItems, legendWidth, legendHeight);

      if (!props) {
        return null;
      }

      return React__default.createElement(Legend, _extends({}, props, {
        chartWidth: width,
        chartHeight: height,
        margin: margin,
        ref: function ref(legend) {
          _this2.legendInstance = legend;
        },
        onBBoxUpdate: this.handleLegendBBoxUpdate
      }));
    };

    /**
     * Draw Tooltip
     * @return {ReactElement}  The instance of Tooltip
     */


    CategoricalChartWrapper.prototype.renderTooltip = function renderTooltip() {
      var children = this.props.children;

      var tooltipItem = findChildByType(children, Tooltip);

      if (!tooltipItem) {
        return null;
      }

      var _state4 = this.state,
          isTooltipActive = _state4.isTooltipActive,
          activeCoordinate = _state4.activeCoordinate,
          activePayload = _state4.activePayload,
          activeLabel = _state4.activeLabel,
          offset = _state4.offset;


      return React__default.cloneElement(tooltipItem, {
        viewBox: _extends({}, offset, { x: offset.left, y: offset.top }),
        active: isTooltipActive,
        label: activeLabel,
        payload: isTooltipActive ? activePayload : [],
        coordinate: activeCoordinate
      });
    };

    CategoricalChartWrapper.prototype.renderBrush = function renderBrush() {
      var _props6 = this.props,
          children = _props6.children,
          margin = _props6.margin,
          data = _props6.data;
      var _state5 = this.state,
          offset = _state5.offset,
          dataStartIndex = _state5.dataStartIndex,
          dataEndIndex = _state5.dataEndIndex,
          updateId = _state5.updateId;

      var brushItem = findChildByType(children, Brush);

      if (!brushItem) {
        return null;
      }

      // TODO: update brush when children update
      return React__default.cloneElement(brushItem, {
        onChange: combineEventHandlers(this.handleBrushChange, null, brushItem.props.onChange),
        data: data,
        x: offset.left,
        y: offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
        width: offset.width,
        startIndex: dataStartIndex,
        endIndex: dataEndIndex,
        updateId: 'brush-' + updateId
      });
    };

    CategoricalChartWrapper.prototype.renderReferenceElements = function renderReferenceElements(isFront, Compt) {
      var children = this.props.children;

      var elements = findAllByType(children, Compt);

      if (!elements || !elements.length) {
        return null;
      }

      var _state6 = this.state,
          xAxisMap = _state6.xAxisMap,
          yAxisMap = _state6.yAxisMap,
          offset = _state6.offset;

      var keyPrefix = getDisplayName(Compt) + '-' + (isFront ? 'front' : 'back');

      return elements.filter(function (entry) {
        return isFront === entry.props.isFront;
      }).map(function (entry, i) {
        var _entry$props = entry.props,
            xAxisId = _entry$props.xAxisId,
            yAxisId = _entry$props.yAxisId;


        return React__default.cloneElement(entry, {
          key: keyPrefix + '-' + i,
          xAxis: xAxisMap[xAxisId],
          yAxis: yAxisMap[yAxisId],
          viewBox: {
            x: offset.left,
            y: offset.top,
            width: offset.width,
            height: offset.height
          }
        });
      });
    };

    CategoricalChartWrapper.prototype.render = function render() {
      var _this3 = this;

      var data = this.props.data;

      if (!validateWidthHeight(this) || !data || !data.length) {
        return null;
      }

      var _props7 = this.props,
          children = _props7.children,
          className = _props7.className,
          width = _props7.width,
          height = _props7.height,
          style = _props7.style,
          others = objectWithoutProperties(_props7, ['children', 'className', 'width', 'height', 'style']);
      var _state7 = this.state,
          xAxisMap = _state7.xAxisMap,
          yAxisMap = _state7.yAxisMap;


      var events = {
        onMouseEnter: this.handleMouseEnter,
        onMouseMove: this.handleMouseMove,
        onMouseLeave: this.handleMouseLeave,
        onClick: this.handleClick,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onTouchMove: this.handleTouchMove
      };
      var attrs = getPresentationAttributes(others);

      return React__default.createElement(
        'div',
        _extends({
          className: classNames('recharts-wrapper', className),
          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
        }, events, {
          ref: function ref(node) {
            _this3.container = node;
          }
        }),
        React__default.createElement(
          Surface,
          _extends({}, attrs, { width: width, height: height }),
          this.renderGrid(),
          this.renderReferenceElements(false, ReferenceArea),
          this.renderReferenceElements(false, ReferenceLine),
          this.renderReferenceElements(false, ReferenceDot),
          this.renderAxes(xAxisMap, 'x-axis'),
          this.renderAxes(yAxisMap, 'y-axis'),
          React__default.createElement(ChartComponent, _extends({}, this.props, this.state)),
          this.renderReferenceElements(true, ReferenceArea),
          this.renderReferenceElements(true, ReferenceLine),
          this.renderReferenceElements(true, ReferenceDot),
          this.renderBrush(),
          filterSvgElements(children)
        ),
        this.renderLegend(),
        this.renderTooltip()
      );
    };

    return CategoricalChartWrapper;
  }(React.Component);

  CategoricalChartWrapper.displayName = getDisplayName(ChartComponent);
  CategoricalChartWrapper.defaultProps = {
    layout: 'horizontal',
    stackOffset: 'none',
    margin: { top: 5, right: 5, bottom: 5, left: 5 }
  };


  return CategoricalChartWrapper;
};

/*
 * ComposedDataDecorator is a wrapper component that calculates expensive,
 * reusable data like ticks of an axis, stores it in state on this component,
 * and passes it in as props to the wrapped component.
 */
var composedDataDecorator = (function (_ref) {
  var getComposedData = _ref.getComposedData,
      ChildComponent = _ref.ChildComponent;
  return function (WrappedComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      inherits(ComposedDataDecorator, _Component);

      function ComposedDataDecorator() {
        var _temp, _this, _ret;

        classCallCheck(this, ComposedDataDecorator);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = _this.calculateExpensiveState({ props: _this.props }), _temp), possibleConstructorReturn(_this, _ret);
      }

      // static WrappedComponent = WrappedComponent;

      /**
       * @param {Object} props The props object to operate on
       * @return {Object} returnObj
       *  returnObj {Array} axisTicks Used by renderCursor and anything
       *          else that needs the ticks of the axisTicks
       *  returObj {Array} allComposedData An array or arrays.
       *          Each top-level element is the composedData {points, baseLine, layout}
       *          for a given child(graphcalItem) of the overall Chart
       */
      ComposedDataDecorator.prototype.calculateExpensiveState = function calculateExpensiveState(_ref2) {
        var props = _ref2.props;
        var children = props.children,
            graphicalItems = props.graphicalItems,
            xAxisMap = props.xAxisMap,
            yAxisMap = props.yAxisMap,
            stackGroups = props.stackGroups,
            layout = props.layout,
            offset = props.offset,
            barSize = props.barSize,
            barGap = props.barGap,
            barCategoryGap = props.barCategoryGap,
            globalMaxBarSize = props.maxBarSize;

        // Some charts pre-filter their items into the graphicalItems prop,
        // others filter it in render of the children

        var items = graphicalItems || findAllByType(children, ChildComponent);

        var sizeList = getBarSizeList({ barSize: barSize, stackGroups: stackGroups });

        var axisTicks = void 0;
        var allComposedData = [];
        items.forEach(function (item) {
          var _item$props = item.props,
              xAxisId = _item$props.xAxisId,
              yAxisId = _item$props.yAxisId,
              dataKey = _item$props.dataKey,
              childMaxBarSize = _item$props.maxBarSize;

          var xAxis = void 0,
              yAxis = void 0,
              xTicks = void 0,
              yTicks = void 0,
              barPosition = void 0,
              stackedData = void 0,
              bandSize = void 0;

          if (xAxisMap || yAxisMap) {

            xAxis = xAxisMap[xAxisId];
            yAxis = yAxisMap[yAxisId];

            xTicks = getTicksOfAxis(xAxis);
            yTicks = getTicksOfAxis(yAxis);

            // axisTicks is more global - only need to set once
            axisTicks = axisTicks || (layout === 'horizontal' ? xTicks : yTicks);

            var numericAxisId = layout === 'horizontal' ? yAxisId : xAxisId;
            var cateAxisId = layout === 'horizontal' ? xAxisId : yAxisId;
            var cateAxis = layout === 'horizontal' ? xAxis : yAxis;
            var cateTicks = layout === 'horizontal' ? xTicks : yTicks;

            stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && getStackedDataOfItem(item, stackGroups[numericAxisId].stackGroups);

            bandSize = getBandSizeOfAxis(cateAxis, cateTicks);
            var maxBarSize = ___default.isNil(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
            barPosition = getBarPosition({
              barGap: barGap, barCategoryGap: barCategoryGap, bandSize: bandSize, sizeList: sizeList[cateAxisId], maxBarSize: maxBarSize
            });
          }

          var composedData = getComposedData && getComposedData({ props: props,
            xAxis: xAxis, yAxis: yAxis, xTicks: xTicks, yTicks: yTicks, dataKey: dataKey, item: item, bandSize: bandSize, barPosition: barPosition, offset: offset, stackedData: stackedData
          }) || {};
          allComposedData.push(composedData);
        });

        return { axisTicks: axisTicks, allComposedData: allComposedData };
      };
      /*
      * Update the state of the composedData if anything relevant changed
      */
      /* eslint-disable no-unused-vars */


      ComposedDataDecorator.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var graphicalItems = nextProps.graphicalItems,
            children = nextProps.children,
            chartX = nextProps.chartX,
            chartY = nextProps.chartY,
            activeTooltipIndex = nextProps.activeTooltipIndex,
            activeLabel = nextProps.activeLabel,
            activeCoordinate = nextProps.activeCoordinate,
            activePayload = nextProps.activePayload,
            isTooltipActive = nextProps.isTooltipActive,
            restNextProps = objectWithoutProperties(nextProps, ['graphicalItems', 'children', 'chartX', 'chartY', 'activeTooltipIndex', 'activeLabel', 'activeCoordinate', 'activePayload', 'isTooltipActive']);
        var _props = this.props,
            graphicalItemsOld = _props.graphicalItems,
            childrenOld = _props.children,
            chartXOld = _props.chartX,
            chartYOld = _props.chartY,
            aTIOld = _props.activeTooltipIndex,
            aLOld = _props.activeLabel,
            aCOld = _props.activeCoordinate,
            aPOld = _props.activePayload,
            iTAOld = _props.isTooltipActive,
            restOldProps = objectWithoutProperties(_props, ['graphicalItems', 'children', 'chartX', 'chartY', 'activeTooltipIndex', 'activeLabel', 'activeCoordinate', 'activePayload', 'isTooltipActive']);

        /* eslint-enable no-unused-vars */

        if (!shallowEqual(graphicalItems, graphicalItemsOld) || !shallowEqual(children, childrenOld) || !shallowEqual(restNextProps, restOldProps)) {
          this.setState(this.calculateExpensiveState({ props: nextProps }));
        }
      };
      /*
       * Ignore the state generated by calculateExpensiveState when determining
       * whether to update
       */


      ComposedDataDecorator.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref3, nextState) {
        var graphicalItems = _ref3.graphicalItems,
            restProps = objectWithoutProperties(_ref3, ['graphicalItems']);

        // props.graphicalItems is sometimes generated every time -
        // check that specially as object equality is likely to fail
        var _props2 = this.props,
            graphicalItemsOld = _props2.graphicalItems,
            restPropsOld = objectWithoutProperties(_props2, ['graphicalItems']);


        return !shallowEqual(graphicalItems, graphicalItemsOld) || !shallowEqual(restProps, restPropsOld) || !shallowEqual(nextState, this.state);
      };

      ComposedDataDecorator.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, this.state));
      };

      return ComposedDataDecorator;
    }(React.Component), _class.displayName = 'ComposedDataDecorator(' + getDisplayName(WrappedComponent) + ')', _class.defaultProps = WrappedComponent.defaultProps, _temp2;
  };
});

var _dec;
var _class$30;

/**
 * @fileOverview Line Chart
 */
var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
  var axis = _ref.axis,
      ticks = _ref.ticks,
      bandSize = _ref.bandSize,
      entry = _ref.entry,
      index = _ref.index;

  if (axis.type === 'category') {
    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
  }

  var value = getValueByDataKey(entry, axis.dataKey);

  return !___default.isNil(value) ? axis.scale(value) : null;
};
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */
var getComposedData = function getComposedData(_ref2) {
  var props = _ref2.props,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      xTicks = _ref2.xTicks,
      yTicks = _ref2.yTicks,
      dataKey = _ref2.dataKey,
      bandSize = _ref2.bandSize;
  var layout = props.layout,
      dataStartIndex = props.dataStartIndex,
      dataEndIndex = props.dataEndIndex;

  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);

  return data.map(function (entry, index) {
    var value = getValueByDataKey(entry, dataKey);

    if (layout === 'horizontal') {
      return {
        x: getCategoryAxisCoordinate({ axis: xAxis, ticks: xTicks, bandSize: bandSize, entry: entry, index: index }),
        y: ___default.isNil(value) ? null : yAxis.scale(value),
        value: value,
        payload: entry
      };
    }

    return {
      x: ___default.isNil(value) ? null : xAxis.scale(value),
      y: getCategoryAxisCoordinate({ axis: yAxis, ticks: yTicks, bandSize: bandSize, entry: entry, index: index }),
      value: value,
      payload: entry
    };
  });
};

var LineChart = (_dec = composedDataDecorator({ getComposedData: getComposedData }), AnimationDecorator(_class$30 = _dec(_class$30 = function (_Component) {
  inherits(LineChart, _Component);

  function LineChart() {
    classCallCheck(this, LineChart);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  LineChart.prototype.renderCursor = function renderCursor(_ref3) {
    var offset = _ref3.offset;
    var _props = this.props,
        children = _props.children,
        isTooltipActive = _props.isTooltipActive,
        layout = _props.layout,
        activeTooltipIndex = _props.activeTooltipIndex,
        axisTicks = _props.axisTicks;

    var tooltipItem = findChildByType(children, Tooltip);

    if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
      return null;
    }

    var ticks = axisTicks;

    if (!ticks || !ticks[activeTooltipIndex]) {
      return null;
    }

    var start = ticks[activeTooltipIndex].coordinate;
    var x1 = layout === 'horizontal' ? start : offset.left;
    var y1 = layout === 'horizontal' ? offset.top : start;
    var x2 = layout === 'horizontal' ? start : offset.left + offset.width;
    var y2 = layout === 'horizontal' ? offset.top + offset.height : start;
    var cursorProps = _extends({
      stroke: '#ccc'
    }, getPresentationAttributes(tooltipItem.props.cursor), {
      points: [{ x: x1, y: y1 }, { x: x2, y: y2 }]
    });

    return React__default.isValidElement(tooltipItem.props.cursor) ? React__default.cloneElement(tooltipItem.props.cursor, cursorProps) : React__default.createElement(Curve, _extends({}, cursorProps, { type: 'linear', className: 'recharts-tooltip-cursor' }));
  };

  LineChart.prototype.renderActiveDot = function renderActiveDot(option, props, childIndex) {
    var dot = void 0;

    if (React__default.isValidElement(option)) {
      dot = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      dot = option(props);
    } else {
      dot = React__default.createElement(Dot, _extends({}, props, { className: 'recharts-line-active-dot' }));
    }

    return React__default.createElement(
      Animate,
      {
        from: 'scale(0)',
        to: 'scale(1)',
        duration: 400,
        key: 'dot-' + childIndex,
        attributeName: 'transform'
      },
      React__default.createElement(
        Layer,
        { style: { transformOrigin: 'center center' } },
        dot
      )
    );
  };
  /**
   * Draw the main part of line chart
   * @param  {Array} items     All the instance of Line
   * @param  {Object} xAxisMap The configuration of all x-axes
   * @param  {Object} yAxisMap The configuration of all y-axes
   * @param  {Object} offset   The offset of main part in the svg element
   * @return {ReactComponent}  All the instances of Line
   */


  LineChart.prototype.renderItems = function renderItems(items, xAxisMap, yAxisMap, offset) {
    var _this2 = this;

    var _props2 = this.props,
        children = _props2.children,
        layout = _props2.layout,
        isTooltipActive = _props2.isTooltipActive,
        activeTooltipIndex = _props2.activeTooltipIndex,
        animationId = _props2.animationId,
        allComposedData = _props2.allComposedData;

    var tooltipItem = findChildByType(children, Tooltip);
    var hasDot = tooltipItem && isTooltipActive;
    var dotItems = [];

    var lineItems = items.map(function (child, i) {
      var _child$props = child.props,
          dataKey = _child$props.dataKey,
          stroke = _child$props.stroke,
          activeDot = _child$props.activeDot;

      var points = allComposedData[i];
      var activePoint = points[activeTooltipIndex];

      if (hasDot && activeDot && activePoint) {
        var dotProps = _extends({
          index: activeTooltipIndex,
          dataKey: dataKey,
          cx: activePoint.x, cy: activePoint.y, r: 4,
          fill: stroke, strokeWidth: 2, stroke: '#fff',
          payload: activePoint.payload,
          value: activePoint.value
        }, getPresentationAttributes(activeDot));
        dotItems.push(_this2.renderActiveDot(activeDot, dotProps, i));
      }

      return React__default.cloneElement(child, _extends({
        key: 'line-' + i
      }, offset, {
        layout: layout,
        points: points,
        animationId: animationId,
        xAxis: xAxisMap[child.props.xAxisId],
        yAxis: yAxisMap[child.props.yAxisId]
      }));
    }, this);

    return React__default.createElement(
      Layer,
      { className: 'recharts-line-chart-wrapper' },
      React__default.createElement(
        Layer,
        { className: 'recharts-line-chart' },
        lineItems
      ),
      React__default.createElement(
        Layer,
        { className: 'recharts-line-chart-dot' },
        dotItems
      )
    );
  };

  LineChart.prototype.render = function render() {
    var _props3 = this.props,
        isComposed = _props3.isComposed,
        xAxisMap = _props3.xAxisMap,
        yAxisMap = _props3.yAxisMap,
        offset = _props3.offset,
        graphicalItems = _props3.graphicalItems;


    return React__default.createElement(
      Layer,
      { className: 'recharts-line-graphical' },
      !isComposed && this.renderCursor({ offset: offset }),
      this.renderItems(graphicalItems, xAxisMap, yAxisMap, offset)
    );
  };

  return LineChart;
}(React.Component)) || _class$30) || _class$30);

LineChart.displayName = 'LineChart';
var LineChart$1 = generateCategoricalChart(LineChart, Line);

var _dec$1;
var _class$31;

/**
 * @fileOverview Bar Chart
 */
var getCategoryAxisCoordinate$1 = function getCategoryAxisCoordinate(_ref) {
  var axis = _ref.axis,
      ticks = _ref.ticks,
      offset = _ref.offset,
      bandSize = _ref.bandSize,
      entry = _ref.entry,
      index = _ref.index;

  if (axis.type === 'category') {
    return ticks[index] ? ticks[index].coordinate + offset : null;
  }

  var value = getValueByDataKey(entry, axis.dataKey);

  return !___default.isNil(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};

var getBaseValue = function getBaseValue(_ref2) {
  var props = _ref2.props,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis;
  var layout = props.layout;

  var numberAxis = layout === 'horizontal' ? yAxis : xAxis;
  var domain = numberAxis.scale.domain();

  if (numberAxis.type === 'number') {
    var min = Math.min(domain[0], domain[1]);
    var max = Math.max(domain[0], domain[1]);

    if (min <= 0 && max >= 0) {
      return 0;
    }
    if (max < 0) {
      return max;
    }

    return min;
  }

  return domain[0];
};

/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */
var getComposedData$1 = function getComposedData(_ref3) {
  var props = _ref3.props,
      item = _ref3.item,
      barPosition = _ref3.barPosition,
      bandSize = _ref3.bandSize,
      xAxis = _ref3.xAxis,
      yAxis = _ref3.yAxis,
      xTicks = _ref3.xTicks,
      yTicks = _ref3.yTicks,
      stackedData = _ref3.stackedData;
  var layout = props.layout,
      dataStartIndex = props.dataStartIndex,
      dataEndIndex = props.dataEndIndex;
  var _item$props = item.props,
      dataKey = _item$props.dataKey,
      children = _item$props.children,
      minPointSize = _item$props.minPointSize;

  var pos = findPositionOfBar(barPosition, item);
  var stackedDomain = stackedData && layout === 'horizontal' ? yAxis.scale.domain() : xAxis.scale.domain();

  if (!pos) {
    return [];
  }

  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
  var baseValue = getBaseValue({ props: props, xAxis: xAxis, yAxis: yAxis });
  var cells = findAllByType(children, Cell);

  return data.map(function (entry, index) {
    var value = void 0,
        x = void 0,
        y = void 0,
        width = void 0,
        height = void 0;

    if (stackedData) {
      value = truncateByDomain(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = getValueByDataKey(entry, dataKey);

      if (!___default.isArray(value)) {
        value = [baseValue, value];
      }
    }

    if (layout === 'horizontal') {

      x = getCategoryAxisCoordinate$1({
        axis: xAxis,
        ticks: xTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      y = yAxis.scale(xAxis.orientation === 'top' ? value[0] : value[1]);
      width = pos.size;
      height = xAxis.orientation === 'top' ? yAxis.scale(value[1]) - yAxis.scale(value[0]) : yAxis.scale(value[0]) - yAxis.scale(value[1]);

      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
        var delta = Math.sign(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));

        y -= delta;
        height += delta;
      }
    } else {
      x = xAxis.scale(yAxis.orientation === 'left' ? value[0] : value[1]);
      y = getCategoryAxisCoordinate$1({
        axis: yAxis,
        ticks: yTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      width = yAxis.orientation === 'left' ? xAxis.scale(value[1]) - xAxis.scale(value[0]) : xAxis.scale(value[0]) - xAxis.scale(value[1]);
      height = pos.size;

      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
        var _delta = Math.sign(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
        width += _delta;
      }
    }

    return _extends({}, entry, {
      x: x, y: y, width: width, height: height, value: stackedData ? value : value[1],
      payload: entry
    }, cells && cells[index] && cells[index].props);
  });
};

var BarChart = (_dec$1 = composedDataDecorator({ getComposedData: getComposedData$1 }), AnimationDecorator(_class$31 = _dec$1(_class$31 = function (_Component) {
  inherits(BarChart, _Component);

  function BarChart() {
    classCallCheck(this, BarChart);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  BarChart.prototype.renderCursor = function renderCursor(_ref4) {
    var xAxisMap = _ref4.xAxisMap,
        yAxisMap = _ref4.yAxisMap,
        offset = _ref4.offset;
    var _props = this.props,
        children = _props.children,
        isTooltipActive = _props.isTooltipActive,
        layout = _props.layout,
        activeTooltipIndex = _props.activeTooltipIndex,
        axisTicks = _props.axisTicks;

    var tooltipItem = findChildByType(children, Tooltip);
    if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
      return null;
    }

    var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
    var axis = getAnyElementOfObject(axisMap);
    var ticks = axisTicks;

    if (!ticks || !ticks[activeTooltipIndex]) {
      return null;
    }

    var bandSize = getBandSizeOfAxis(axis);
    var start = ticks[activeTooltipIndex].coordinate;
    var cursorProps = _extends({
      fill: '#f1f1f1'
    }, getPresentationAttributes(tooltipItem.props.cursor), {
      x: layout === 'horizontal' ? start : offset.left + 0.5,
      y: layout === 'horizontal' ? offset.top + 0.5 : start,
      width: layout === 'horizontal' ? bandSize : offset.width - 1,
      height: layout === 'horizontal' ? offset.height - 1 : bandSize
    });

    return React__default.isValidElement(tooltipItem.props.cursor) ? React__default.cloneElement(tooltipItem.props.cursor, cursorProps) : React__default.createElement(Rectangle, _extends({}, cursorProps, { className: 'recharts-bar-cursor' }));
  };

  /**
   * Draw the main part of bar chart
   * @param  {Array} items     All the instance of Bar
   * @param  {Object} offset   The offset of main part in the svg element
   * @return {ReactComponent}  All the instances of Bar
   */


  BarChart.prototype.renderItems = function renderItems(items, offset) {
    if (!items || !items.length) {
      return null;
    }

    var _props2 = this.props,
        layout = _props2.layout,
        xAxisMap = _props2.xAxisMap,
        yAxisMap = _props2.yAxisMap;
    var _props3 = this.props,
        animationId = _props3.animationId,
        allComposedData = _props3.allComposedData;


    return items.map(function (child, i) {
      return React__default.cloneElement(child, _extends({
        key: 'bar-' + i,
        layout: layout,
        animationId: animationId
      }, offset, {
        data: allComposedData[i],
        xAxis: xAxisMap[child.props.xAxisId],
        yAxis: yAxisMap[child.props.yAxisId]
      }));
    }, this);
  };

  BarChart.prototype.render = function render() {
    var _props4 = this.props,
        isComposed = _props4.isComposed,
        graphicalItems = _props4.graphicalItems,
        xAxisMap = _props4.xAxisMap,
        yAxisMap = _props4.yAxisMap,
        offset = _props4.offset;


    return React__default.createElement(
      Layer,
      { className: 'recharts-bar-graphical' },
      !isComposed && this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
      this.renderItems(graphicalItems, offset)
    );
  };

  return BarChart;
}(React.Component)) || _class$31) || _class$31);
BarChart.displayName = 'BarChart';
BarChart.defaultProps = {
  barCategoryGap: '10%',
  barGap: 4
};


var BarChart$1 = generateCategoricalChart(BarChart, Bar);

var _dec$2;
var _class$32;

/**
 * @fileOverview Pie Chart
 */
var getComposedData$2 = function getComposedData(_ref) {
  var item = _ref.item;
  var _item$props = item.props,
      data = _item$props.data,
      children = _item$props.children;

  var presentationProps = getPresentationAttributes(item.props);
  var cells = findAllByType(children, Cell);

  if (data && data.length) {
    return data.map(function (entry, index) {
      return _extends({
        payload: entry
      }, presentationProps, entry, cells && cells[index] && cells[index].props);
    });
  }

  if (cells && cells.length) {
    return cells.map(function (cell) {
      return _extends({}, presentationProps, cell.props);
    });
  }

  return [];
};

var PieChart = (_dec$2 = composedDataDecorator({ getComposedData: getComposedData$2, ChildComponent: Pie }), _dec$2(_class$32 = function (_Component) {
  inherits(PieChart, _Component);

  function PieChart() {
    var _temp, _this, _ret;

    classCallCheck(this, PieChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      activeTooltipLabel: '',
      activeTooltipCoord: { x: 0, y: 0 },
      activeTooltipPayload: [],
      isTooltipActive: false
    }, _this.handleMouseEnter = function (el) {
      var children = _this.props.children;
      var cx = el.cx,
          cy = el.cy,
          outerRadius = el.outerRadius,
          midAngle = el.midAngle;

      var tooltipItem = findChildByType(children, Tooltip);

      if (tooltipItem) {
        _this.setState({
          isTooltipActive: true,
          activeTooltipCoord: polarToCartesian(cx, cy, outerRadius, midAngle),
          activeTooltipPayload: [el]
        });
      }
    }, _this.handleMouseLeave = function () {
      var children = _this.props.children;

      var tooltipItem = findChildByType(children, Tooltip);

      if (tooltipItem) {
        _this.setState({
          isTooltipActive: false
        });
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  /**
   * Draw legend
   * @param  {Array} items             The instances of Pie
   * @return {ReactElement}            The instance of Legend
   */
  PieChart.prototype.renderLegend = function renderLegend(items) {
    var _props = this.props,
        children = _props.children,
        allComposedData = _props.allComposedData;

    var legendItem = findChildByType(children, Legend);
    if (!legendItem) {
      return null;
    }

    var _props2 = this.props,
        width = _props2.width,
        height = _props2.height,
        margin = _props2.margin;

    var legendData = legendItem.props && legendItem.props.payload || items.reduce(function (result, child, i) {
      var nameKey = child.props.nameKey;

      var data = allComposedData[i];

      return result.concat(data.map(function (entry) {
        return {
          type: legendItem.props.iconType || child.props.legendType,
          value: entry[nameKey],
          color: entry.fill,
          payload: entry
        };
      }));
    }, []);

    return React__default.cloneElement(legendItem, _extends({}, Legend.getWithHeight(legendItem, width), {
      payload: legendData,
      chartWidth: width,
      chartHeight: height,
      margin: margin
    }));
  };

  PieChart.prototype.renderTooltip = function renderTooltip() {
    var children = this.props.children;

    var tooltipItem = findChildByType(children, Tooltip);

    if (!tooltipItem) {
      return null;
    }

    var _props3 = this.props,
        width = _props3.width,
        height = _props3.height;
    var _state = this.state,
        isTooltipActive = _state.isTooltipActive,
        activeTooltipLabel = _state.activeTooltipLabel,
        activeTooltipCoord = _state.activeTooltipCoord,
        activeTooltipPayload = _state.activeTooltipPayload;

    var viewBox = { x: 0, y: 0, width: width, height: height };

    return React__default.cloneElement(tooltipItem, {
      viewBox: viewBox,
      active: isTooltipActive,
      label: activeTooltipLabel,
      payload: activeTooltipPayload,
      coordinate: activeTooltipCoord
    });
  };

  /**
   * Draw the main part of bar chart
   * @param  {Array} items    All the instance of Pie
   * @return {ReactComponent} All the instance of Pie
   */


  PieChart.prototype.renderItems = function renderItems(items) {
    var _this2 = this;

    var _props4 = this.props,
        width = _props4.width,
        height = _props4.height,
        margin = _props4.margin,
        allComposedData = _props4.allComposedData,
        onMouseEnter = _props4.onMouseEnter,
        onMouseLeave = _props4.onMouseLeave,
        onClick = _props4.onClick;


    return items.map(function (child, i) {
      var _child$props = child.props,
          innerRadius = _child$props.innerRadius,
          outerRadius = _child$props.outerRadius,
          childOnMouseEnter = _child$props.onMouseEnter,
          childOnMouseLeave = _child$props.onMouseLeave,
          childOnClick = _child$props.onClick;

      var cx = getPercentValue(child.props.cx, width, width / 2);
      var cy = getPercentValue(child.props.cy, height, height / 2);
      var maxRadius = getMaxRadius(width, height, margin);

      return React__default.cloneElement(child, {
        key: 'recharts-pie-' + i,
        cx: cx,
        cy: cy,
        maxRadius: child.props.maxRadius || Math.sqrt(width * width + height * height) / 2,
        innerRadius: getPercentValue(innerRadius, maxRadius, 0),
        outerRadius: getPercentValue(outerRadius, maxRadius, maxRadius * 0.8),
        composedData: allComposedData[i],
        onMouseEnter: combineEventHandlers(_this2.handleMouseEnter, onMouseEnter, childOnMouseEnter),
        onMouseLeave: combineEventHandlers(_this2.handleMouseLeave, onMouseLeave, childOnMouseLeave),
        onClick: combineEventHandlers(null, onClick, childOnClick)
      });
    });
  };

  PieChart.prototype.render = function render() {
    if (!validateWidthHeight(this)) {
      return null;
    }

    var _props5 = this.props,
        style = _props5.style,
        children = _props5.children,
        className = _props5.className,
        width = _props5.width,
        height = _props5.height,
        others = objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height']);

    var items = findAllByType(children, Pie);
    var attrs = getPresentationAttributes(others);

    return React__default.createElement(
      'div',
      {
        className: classNames('recharts-wrapper', className),
        style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
      },
      React__default.createElement(
        Surface,
        _extends({}, attrs, { width: width, height: height }),
        this.renderItems(items),
        filterSvgElements(children)
      ),
      this.renderLegend(items),
      this.renderTooltip()
    );
  };

  return PieChart;
}(React.Component)) || _class$32);

PieChart.displayName = 'PieChart';
PieChart.defaultProps = {
  style: {},
  margin: { top: 0, right: 0, bottom: 0, left: 0 }
};

var _class$33;

/**
 * @fileOverview TreemapChart
 */
var computeNode = function computeNode(_ref) {
  var depth = _ref.depth,
      node = _ref.node,
      index = _ref.index,
      valueKey = _ref.valueKey;
  var children = node.children;

  var childDepth = depth + 1;
  var computedChildren = children && children.length ? children.map(function (child, i) {
    return computeNode({ depth: childDepth, node: child, index: i, valueKey: valueKey });
  }) : null;
  var value = void 0;

  if (children && children.length) {
    value = computedChildren.reduce(function (result, child) {
      return result + child.value;
    }, 0);
  } else {
    value = isNaN(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
  }

  return _extends({}, node, {
    children: computedChildren,
    value: value, depth: depth, index: index
  });
};

var filterRect = function filterRect(node) {
  return { x: node.x, y: node.y, width: node.width, height: node.height };
};

// Compute the area for each child based on value & scale.
var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;

  return children.map(function (child) {
    var area$$1 = child.value * ratio;

    return _extends({}, child, {
      area: isNaN(area$$1) || area$$1 <= 0 ? 0 : area$$1
    });
  });
};

// Computes the score for the specified row, as the worst aspect ratio.
var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
  var parentArea = parentSize * parentSize;
  var rowArea = row.area * row.area;

  var _row$reduce = row.reduce(function (result, child) {
    return {
      min: Math.min(result.min, child.area),
      max: Math.max(result.max, child.area)
    };
  }, { min: Infinity, max: 0 }),
      min = _row$reduce.min,
      max = _row$reduce.max;

  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
};

var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;

  if (isFlush || rowHeight > parentRect.height) {
    rowHeight = parentRect.height;
  }

  var curX = parentRect.x;
  var child = void 0;
  for (var i = 0, len = row.length; i < len; i++) {
    child = row[i];
    child.x = curX;
    child.y = parentRect.y;
    child.height = rowHeight;
    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
    curX += child.width;
  }
  // what's z
  child.z = true;
  // add the remain x to the last one of row
  child.width += parentRect.x + parentRect.width - curX;

  return _extends({}, parentRect, {
    y: parentRect.y + rowHeight,
    height: parentRect.height - rowHeight
  });
};

var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;

  if (isFlush || rowWidth > parentRect.width) {
    rowWidth = parentRect.width;
  }

  var curY = parentRect.y;
  var child = void 0;
  for (var i = 0, len = row.length; i < len; i++) {
    child = row[i];
    child.x = parentRect.x;
    child.y = curY;
    child.width = rowWidth;
    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
    curY += child.height;
  }
  child.z = false;
  child.height += parentRect.y + parentRect.height - curY;

  return _extends({}, parentRect, {
    x: parentRect.x + rowWidth,
    width: parentRect.width - rowWidth
  });
};

var position = function position(row, parentSize, parentRect, isFlush) {
  if (parentSize === parentRect.width) {
    return horizontalPosition(row, parentSize, parentRect, isFlush);
  }

  return verticalPosition(row, parentSize, parentRect, isFlush);
};

// Recursively arranges the specified node's children into squarified rows.
var squarify = function squarify(node, aspectRatio) {
  var children = node.children;

  if (children && children.length) {
    var rect = filterRect(node);
    var row = [];
    var best = Infinity; // the best row score so far
    var child = void 0,
        score = void 0; // the current row score
    var size = Math.min(rect.width, rect.height); // initial orientation
    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
    var tempChildren = scaleChildren.slice();

    row.area = 0;

    while (tempChildren.length > 0) {
      // row first
      row.push(child = tempChildren[0]);
      row.area += child.area;

      score = getWorstScore(row, size, aspectRatio);
      if (score <= best) {
        // continue with this orientation
        tempChildren.shift();
        best = score;
      } else {
        // abort, and try a different orientation
        row.area -= row.pop().area;
        rect = position(row, size, rect, false);
        size = Math.min(rect.width, rect.height);
        row.length = row.area = 0;
        best = Infinity;
      }
    }

    if (row.length) {
      rect = position(row, size, rect, true);
      row.length = row.area = 0;
    }

    return _extends({}, node, { children: scaleChildren.map(function (c) {
        return squarify(c, aspectRatio);
      }) });
  }

  return node;
};

var Treemap = pureRenderDecorator$1(_class$33 = function (_Component) {
  inherits(Treemap, _Component);

  function Treemap() {
    var _temp, _this, _ret;

    classCallCheck(this, Treemap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _temp), possibleConstructorReturn(_this, _ret);
  }

  Treemap.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data) {
      this.setState(this.createDefaultState());
    }
  };
  /**
   * Returns default, reset state for the treemap chart.
   * @return {Object} Whole new state
   */


  Treemap.prototype.createDefaultState = function createDefaultState() {
    return {
      isTooltipActive: false,
      activeNode: null
    };
  };

  Treemap.prototype.handleMouseEnter = function handleMouseEnter(node, e) {
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        children = _props.children;

    var tooltipItem = findChildByType(children, Tooltip);

    if (tooltipItem) {
      this.setState({
        isTooltipActive: true,
        activeNode: node
      }, function () {
        if (onMouseEnter) {
          onMouseEnter(node, e);
        }
      });
    } else if (onMouseEnter) {
      onMouseEnter(node, e);
    }
  };

  Treemap.prototype.handleMouseLeave = function handleMouseLeave(node, e) {
    var _props2 = this.props,
        onMouseLeave = _props2.onMouseLeave,
        children = _props2.children;

    var tooltipItem = findChildByType(children, Tooltip);

    if (tooltipItem) {
      this.setState({
        isTooltipActive: false,
        activeNode: null
      }, function () {
        if (onMouseLeave) {
          onMouseLeave(node, e);
        }
      });
    } else if (onMouseLeave) {
      onMouseLeave(node, e);
    }
  };

  Treemap.prototype.handleClick = function handleClick(node) {
    var onClick = this.props.onClick;


    if (onClick) {
      onClick(node);
    }
  };

  Treemap.prototype.renderAnimatedItem = function renderAnimatedItem(content, nodeProps, isLeaf) {
    var _this2 = this;

    var _props3 = this.props,
        isAnimationActive = _props3.isAnimationActive,
        animationBegin = _props3.animationBegin,
        animationDuration = _props3.animationDuration,
        animationEasing = _props3.animationEasing,
        isUpdateAnimationActive = _props3.isUpdateAnimationActive;
    var width = nodeProps.width,
        height = nodeProps.height,
        x = nodeProps.x,
        y = nodeProps.y;

    var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
    var event = {};

    if (isLeaf) {
      event = {
        onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
        onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
        onClick: this.handleClick.bind(this, nodeProps)
      };
    }

    return React__default.createElement(
      Animate,
      {
        from: { x: x, y: y, width: width, height: height },
        to: { x: x, y: y, width: width, height: height },
        duration: animationDuration,
        easing: animationEasing,
        isActive: isUpdateAnimationActive
      },
      function (_ref2) {
        var currX = _ref2.x,
            currY = _ref2.y,
            currWidth = _ref2.width,
            currHeight = _ref2.height;
        return React__default.createElement(
          Animate,
          {
            from: 'translate(' + translateX + 'px, ' + translateX + 'px)',
            to: 'translate(0, 0)',
            attributeName: 'transform',
            begin: animationBegin,
            easing: animationEasing,
            isActive: isAnimationActive,
            duration: animationDuration
          },
          React__default.createElement(
            Layer,
            event,
            _this2.renderContentItem(content, _extends({}, nodeProps, {
              isAnimationActive: isAnimationActive,
              isUpdateAnimationActive: !isUpdateAnimationActive,
              width: currWidth,
              height: currHeight,
              x: currX,
              y: currY
            }))
          )
        );
      }
    );
  };

  Treemap.prototype.renderContentItem = function renderContentItem(content, nodeProps) {
    if (React__default.isValidElement(content)) {
      return React__default.cloneElement(content, nodeProps);
    } else if (___default.isFunction(content)) {
      return content(nodeProps);
    }

    return React__default.createElement(Rectangle, _extends({
      fill: '#fff',
      stroke: '#000'
    }, nodeProps));
  };

  Treemap.prototype.renderNode = function renderNode(root, node, i) {
    var _this3 = this;

    var content = this.props.content;

    var nodeProps = _extends({}, getPresentationAttributes(this.props), node, { root: root });
    var isLeaf = !node.children || !node.children.length;

    return React__default.createElement(
      Layer,
      { key: 'recharts-treemap-node-' + i, className: 'recharts-treemap-depth-' + node.depth },
      this.renderAnimatedItem(content, nodeProps, isLeaf),
      node.children && node.children.length ? node.children.map(function (child, index) {
        return _this3.renderNode(node, child, index);
      }) : null
    );
  };

  Treemap.prototype.renderAllNodes = function renderAllNodes() {
    var _props4 = this.props,
        width = _props4.width,
        height = _props4.height,
        data = _props4.data,
        dataKey = _props4.dataKey,
        aspectRatio = _props4.aspectRatio;


    var root = computeNode({
      depth: 0,
      node: { children: data, x: 0, y: 0, width: width, height: height },
      index: 0,
      valueKey: dataKey
    });

    var formatRoot = squarify(root, aspectRatio);

    return this.renderNode(formatRoot, formatRoot, 0);
  };

  Treemap.prototype.renderTooltip = function renderTooltip() {
    var _props5 = this.props,
        children = _props5.children,
        nameKey = _props5.nameKey;

    var tooltipItem = findChildByType(children, Tooltip);

    if (!tooltipItem) {
      return null;
    }

    var _props6 = this.props,
        width = _props6.width,
        height = _props6.height,
        dataKey = _props6.dataKey;
    var _state = this.state,
        isTooltipActive = _state.isTooltipActive,
        activeNode = _state.activeNode;

    var viewBox = { x: 0, y: 0, width: width, height: height };
    var coordinate = activeNode ? {
      x: activeNode.x + activeNode.width / 2,
      y: activeNode.y + activeNode.height / 2
    } : null;
    var payload = isTooltipActive && activeNode ? [{
      payload: activeNode,
      name: getValueByDataKey(activeNode, nameKey, ''),
      value: getValueByDataKey(activeNode, dataKey)
    }] : [];

    return React__default.cloneElement(tooltipItem, {
      viewBox: viewBox,
      active: isTooltipActive,
      coordinate: coordinate,
      label: '',
      payload: payload
    });
  };

  Treemap.prototype.render = function render() {
    if (!validateWidthHeight(this)) {
      return null;
    }

    var _props7 = this.props,
        width = _props7.width,
        height = _props7.height,
        className = _props7.className,
        style = _props7.style,
        children = _props7.children,
        others = objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);

    var attrs = getPresentationAttributes(others);

    return React__default.createElement(
      'div',
      {
        className: classNames('recharts-wrapper', className),
        style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
      },
      React__default.createElement(
        Surface,
        _extends({}, attrs, { width: width, height: height }),
        this.renderAllNodes(),
        filterSvgElements(children)
      ),
      this.renderTooltip()
    );
  };

  return Treemap;
}(React.Component)) || _class$33;

Treemap.displayName = 'Treemap';
Treemap.defaultProps = {
  dataKey: 'value',
  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
  isAnimationActive: !isSsr(),
  isUpdateAnimationActive: !isSsr(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'linear'
};

var _class$34;

/**
 * @file TreemapChart
 */
var defaultCoordinateOfTooltip = { x: 0, y: 0 };

var interpolationGenerator = function interpolationGenerator(a, b) {
  var ka = +a;
  var kb = b - ka;
  return function (t) {
    return ka + kb * t;
  };
};
var centerY = function centerY(node) {
  return node.y + node.dy / 2;
};
var getValue = function getValue(entry) {
  return entry && entry.value || 0;
};
var getSumOfIds = function getSumOfIds(links, ids) {
  return ids.reduce(function (result, id) {
    return result + getValue(links[id]);
  }, 0);
};
var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var sourceNode = tree[link.source];

    return result + centerY(sourceNode) * getValue(links[id]);
  }, 0);
};
var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var targetNode = tree[link.target];

    return result + centerY(targetNode) * getValue(links[id]);
  }, 0);
};
var ascendingY = function ascendingY(a, b) {
  return a.y - b.y;
};

var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
  var sourceNodes = [];
  var sourceLinks = [];
  var targetNodes = [];
  var targetLinks = [];

  for (var i = 0, len = links.length; i < len; i++) {
    var link = links[i];

    if (link.source === id) {
      targetNodes.push(link.target);
      targetLinks.push(i);
    }

    if (link.target === id) {
      sourceNodes.push(link.source);
      sourceLinks.push(i);
    }
  }

  return { sourceNodes: sourceNodes, sourceLinks: sourceLinks, targetLinks: targetLinks, targetNodes: targetNodes };
};

var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
  var targetNodes = curNode.targetNodes;

  for (var i = 0, len = targetNodes.length; i < len; i++) {
    var target = tree[targetNodes[i]];

    if (target) {
      target.depth = Math.max(curNode.depth + 1, target.depth);

      updateDepthOfTargets(tree, target);
    }
  }
};

var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
  var nodes = _ref.nodes,
      links = _ref.links;

  var tree = nodes.map(function (entry, index) {
    var result = searchTargetsAndSources(links, index);

    return _extends({}, entry, result, {
      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
      depth: 0
    });
  });

  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];

    if (!node.sourceNodes.length) {
      updateDepthOfTargets(tree, node);
    }
  }
  var maxDepth = ___default.maxBy(tree, function (entry) {
    return entry.depth;
  }).depth;

  if (maxDepth >= 1) {
    var childWidth = (width - nodeWidth) / maxDepth;
    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
      var _node = tree[_i];

      if (!_node.targetNodes.length) {
        _node.depth = maxDepth;
      }
      _node.x = _node.depth * childWidth;
      _node.dx = nodeWidth;
    }
  }

  return { tree: tree, maxDepth: maxDepth };
};

var getDepthTree = function getDepthTree(tree) {
  var result = [];

  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];

    if (!result[node.depth]) {
      result[node.depth] = [];
    }

    result[node.depth].push(node);
  }

  return result;
};

var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
  var yRatio = ___default.min(depthTree.map(function (nodes) {
    return (height - (nodes.length - 1) * nodePadding) / ___default.sumBy(nodes, getValue);
  }));

  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
    for (var i = 0, len = depthTree[d].length; i < len; i++) {
      var node = depthTree[d][i];

      node.y = i;
      node.dy = node.value * yRatio;
    }
  }

  return links.map(function (link) {
    return _extends({}, link, { dy: getValue(link) * yRatio });
  });
};

var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
  for (var i = 0, len = depthTree.length; i < len; i++) {
    var nodes = depthTree[i];
    var n = nodes.length;

    // Sort by the value of y
    nodes.sort(ascendingY);

    var y0 = 0;
    for (var j = 0; j < n; j++) {
      var node = nodes[j];
      var dy = y0 - node.y;

      if (dy > 0) {
        node.y += dy;
      }

      y0 = node.y + node.dy + nodePadding;
    }

    y0 = height + nodePadding;
    for (var _j = n - 1; _j >= 0; _j--) {
      var _node2 = nodes[_j];
      var _dy = _node2.y + _node2.dy + nodePadding - y0;

      if (_dy > 0) {
        _node2.y -= _dy;
        y0 = _node2.y;
      } else {
        break;
      }
    }
  }
};

var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
    var nodes = depthTree[i];

    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];

      if (node.sourceLinks.length) {
        var sourceSum = getSumOfIds(links, node.sourceLinks);
        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
        var y = weightedSum / sourceSum;

        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};
var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
  for (var i = depthTree.length - 1; i >= 0; i--) {
    var nodes = depthTree[i];

    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];

      if (node.targetLinks.length) {
        var targetSum = getSumOfIds(links, node.targetLinks);
        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
        var y = weightedSum / targetSum;

        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};
var updateYOfLinks = function updateYOfLinks(tree, links) {
  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];
    var sy = 0;
    var ty = 0;

    node.targetLinks.sort(function (a, b) {
      return tree[links[a].target].y - tree[links[b].target].y;
    });
    node.sourceLinks.sort(function (a, b) {
      return tree[links[a].source].y - tree[links[b].source].y;
    });

    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
      var link = links[node.targetLinks[j]];

      if (link) {
        link.sy = sy;
        sy += link.dy;
      }
    }

    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
      var _link = links[node.sourceLinks[_j2]];

      if (_link) {
        _link.ty = ty;
        ty += _link.dy;
      }
    }
  }
};

var computeData = function computeData(_ref2) {
  var data = _ref2.data,
      width = _ref2.width,
      height = _ref2.height,
      iterations = _ref2.iterations,
      nodeWidth = _ref2.nodeWidth,
      nodePadding = _ref2.nodePadding;
  var links = data.links;

  var _getNodesTree = getNodesTree(data, width, nodeWidth),
      tree = _getNodesTree.tree;

  var depthTree = getDepthTree(tree);
  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);

  resolveCollisions(depthTree, height, nodePadding);

  var alpha = 1;
  for (var i = 1; i <= iterations; i++) {
    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);

    resolveCollisions(depthTree, height, nodePadding);

    relaxLeftToRight(tree, depthTree, newLinks, alpha);

    resolveCollisions(depthTree, height, nodePadding);
  }

  updateYOfLinks(tree, newLinks);

  return { nodes: tree, links: newLinks };
};

var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
  if (type === 'node') {
    return { x: el.x + el.width / 2, y: el.y + el.height / 2 };
  }

  return {
    x: (el.sourceX + el.targetX) / 2,
    y: (el.sourceY + el.targetY) / 2
  };
};

var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
  var payload = el.payload;

  if (type === 'node') {
    return [{
      payload: el,
      name: getValueByDataKey(payload, nameKey, ''),
      value: getValueByDataKey(payload, 'value')
    }];
  }
  if (payload.source && payload.target) {
    var sourceName = getValueByDataKey(payload.source, nameKey, '');
    var targetName = getValueByDataKey(payload.target, nameKey, '');

    return [{
      payload: el,
      name: sourceName + ' - ' + targetName,
      value: getValueByDataKey(payload, 'value')
    }];
  }

  return [];
};

var Sankey = pureRenderDecorator$1(_class$34 = function (_Component) {
  inherits(Sankey, _Component);

  function Sankey(props) {
    classCallCheck(this, Sankey);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = _this.createDefaultState(props);
    return _this;
  }

  Sankey.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _props = this.props,
        data = _props.data,
        width = _props.width,
        height = _props.height,
        margin = _props.margin,
        iterations = _props.iterations,
        nodeWidth = _props.nodeWidth,
        nodePadding = _props.nodePadding,
        nameKey = _props.nameKey;

    if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !shallowEqual(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
      this.setState(this.createDefaultState(this.props));
    }
  };
  /**
   * Returns default, reset state for the sankey chart.
   * @param  {Object} props The latest props
   * @return {Object} Whole new state
   */


  Sankey.prototype.createDefaultState = function createDefaultState(props) {
    var data = props.data,
        width = props.width,
        height = props.height,
        margin = props.margin,
        iterations = props.iterations,
        nodeWidth = props.nodeWidth,
        nodePadding = props.nodePadding;

    var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
    var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);

    var _computeData = computeData({
      data: data,
      width: contentWidth,
      height: contentHeight,
      iterations: iterations, nodeWidth: nodeWidth, nodePadding: nodePadding
    }),
        links = _computeData.links,
        nodes = _computeData.nodes;

    return {
      activeElement: null,
      activeElementType: null,
      isTooltipActive: false,
      nodes: nodes, links: links
    };
  };

  Sankey.prototype.handleMouseEnter = function handleMouseEnter(el, type, e) {
    var _props2 = this.props,
        onMouseEnter = _props2.onMouseEnter,
        children = _props2.children;

    var tooltipItem = findChildByType(children, Tooltip);

    if (tooltipItem) {
      this.setState({
        activeElement: el,
        activeElementType: type,
        isTooltipActive: true
      }, function () {
        if (onMouseEnter) {
          onMouseEnter(el, type, e);
        }
      });
    } else if (onMouseEnter) {
      onMouseEnter(el, type, e);
    }
  };

  Sankey.prototype.handleMouseLeave = function handleMouseLeave(el, type, e) {
    var _props3 = this.props,
        onMouseLeave = _props3.onMouseLeave,
        children = _props3.children;

    var tooltipItem = findChildByType(children, Tooltip);

    if (tooltipItem) {
      this.setState({
        isTooltipActive: false
      }, function () {
        if (onMouseLeave) {
          onMouseLeave(el, type, e);
        }
      });
    } else if (onMouseLeave) {
      onMouseLeave(el, type, e);
    }
  };

  Sankey.prototype.renderLinkItem = function renderLinkItem(option, props) {
    if (React__default.isValidElement(option)) {
      return React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      return option(props);
    }

    var sourceX = props.sourceX,
        sourceY = props.sourceY,
        sourceControlX = props.sourceControlX,
        targetX = props.targetX,
        targetY = props.targetY,
        targetControlX = props.targetControlX,
        linkWidth = props.linkWidth,
        others = objectWithoutProperties(props, ['sourceX', 'sourceY', 'sourceControlX', 'targetX', 'targetY', 'targetControlX', 'linkWidth']);


    return React__default.createElement('path', _extends({
      className: 'recharts-sankey-link',
      d: '\n          M' + sourceX + ',' + sourceY + '\n          C' + sourceControlX + ',' + sourceY + ' ' + targetControlX + ',' + targetY + ' ' + targetX + ',' + targetY + '\n        ',
      fill: 'none',
      stroke: '#333',
      strokeWidth: linkWidth,
      strokeOpacity: '0.2'
    }, getPresentationAttributes(others)));
  };

  Sankey.prototype.renderLinks = function renderLinks(links, nodes) {
    var _this2 = this;

    var _props4 = this.props,
        linkCurvature = _props4.linkCurvature,
        linkContent = _props4.link,
        margin = _props4.margin;

    var top = margin.top || 0;
    var left = margin.left || 0;

    return React__default.createElement(
      Layer,
      { className: 'recharts-sankey-links', key: 'recharts-sankey-links' },
      links.map(function (link, i) {
        var sourceRelativeY = link.sy,
            targetRelativeY = link.ty,
            linkWidth = link.dy;

        var source = nodes[link.source];
        var target = nodes[link.target];
        var sourceX = source.x + source.dx + left;
        var targetX = target.x + left;
        var interpolationFunc = interpolationGenerator(sourceX, targetX);
        var sourceControlX = interpolationFunc(linkCurvature);
        var targetControlX = interpolationFunc(1 - linkCurvature);
        var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
        var targetY = target.y + targetRelativeY + linkWidth / 2 + top;

        var linkProps = _extends({
          sourceX: sourceX, targetX: targetX,
          sourceY: sourceY, targetY: targetY,
          sourceControlX: sourceControlX, targetControlX: targetControlX,
          sourceRelativeY: sourceRelativeY, targetRelativeY: targetRelativeY,
          linkWidth: linkWidth,
          index: i,
          payload: _extends({}, link, { source: source, target: target })
        }, getPresentationAttributes(linkContent));
        var events = {
          onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
          onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link')
        };

        return React__default.createElement(
          Layer,
          _extends({ key: 'link' + i }, events),
          _this2.renderLinkItem(linkContent, linkProps)
        );
      })
    );
  };

  Sankey.prototype.renderNodeItem = function renderNodeItem(option, props) {
    if (React__default.isValidElement(option)) {
      return React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      return option(props);
    }

    return React__default.createElement(Rectangle, _extends({
      className: 'recharts-sankey-node',
      fill: '#0088fe',
      fillOpacity: '0.8'
    }, props));
  };

  Sankey.prototype.renderNodes = function renderNodes(nodes) {
    var _this3 = this;

    var _props5 = this.props,
        nodeContent = _props5.node,
        margin = _props5.margin;

    var top = margin.top || 0;
    var left = margin.left || 0;

    return React__default.createElement(
      Layer,
      { className: 'recharts-sankey-nodes', key: 'recharts-sankey-nodes' },
      nodes.map(function (node, i) {
        var x = node.x,
            y = node.y,
            dx = node.dx,
            dy = node.dy;

        var nodeProps = _extends({}, getPresentationAttributes(nodeContent), {
          x: x + left,
          y: y + top,
          width: dx,
          height: dy,
          index: i,
          payload: node
        });
        var events = {
          onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
          onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node')
        };

        return React__default.createElement(
          Layer,
          _extends({ key: 'node' + i }, events),
          _this3.renderNodeItem(nodeContent, nodeProps)
        );
      })
    );
  };

  Sankey.prototype.renderTooltip = function renderTooltip() {
    var _props6 = this.props,
        children = _props6.children,
        width = _props6.width,
        height = _props6.height,
        nameKey = _props6.nameKey;

    var tooltipItem = findChildByType(children, Tooltip);

    if (!tooltipItem) {
      return null;
    }

    var _state = this.state,
        isTooltipActive = _state.isTooltipActive,
        activeElement = _state.activeElement,
        activeElementType = _state.activeElementType;

    var viewBox = { x: 0, y: 0, width: width, height: height };
    var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
    var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];

    return React__default.cloneElement(tooltipItem, {
      viewBox: viewBox,
      active: isTooltipActive,
      coordinate: coordinate,
      label: '',
      payload: payload
    });
  };

  Sankey.prototype.render = function render() {
    if (!validateWidthHeight(this)) {
      return null;
    }

    var _props7 = this.props,
        width = _props7.width,
        height = _props7.height,
        className = _props7.className,
        style = _props7.style,
        children = _props7.children,
        others = objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
    var _state2 = this.state,
        links = _state2.links,
        nodes = _state2.nodes;

    var attrs = getPresentationAttributes(others);

    return React__default.createElement(
      'div',
      {
        className: classNames('recharts-wrapper', className),
        style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
      },
      React__default.createElement(
        Surface,
        _extends({}, attrs, { width: width, height: height }),
        filterSvgElements(children),
        this.renderLinks(links, nodes),
        this.renderNodes(nodes)
      ),
      this.renderTooltip()
    );
  };

  return Sankey;
}(React.Component)) || _class$34;

Sankey.displayName = 'Sankey';
Sankey.defaultProps = {
  nodePadding: 10,
  nodeWidth: 10,
  nameKey: 'name',
  dataKey: 'value',
  linkCurvature: 0.5,
  iterations: 32,
  margin: { top: 5, right: 5, bottom: 5, left: 5 }
};

var _class$35;

/**
 * @fileOverview Radar Chart
 */
var RadarChart = AnimationDecorator(_class$35 = pureRenderDecorator$1(_class$35 = function (_Component) {
  inherits(RadarChart, _Component);

  function RadarChart() {
    var _temp, _this, _ret;

    classCallCheck(this, RadarChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _this.handleMouseEnter = function (itemProps, e) {
      var children = _this.props.children;
      var points = itemProps.points;

      var tooltipItem = findChildByType(children, Tooltip);

      if (tooltipItem && points.length) {
        var container = _this.container;
        var containerOffset = getOffset(container);
        var ne = calculateChartCoordinate(e, containerOffset);

        _this.setState({
          isTooltipActive: true,
          activeTooltipLabel: itemProps.name || itemProps.dataKey,
          activeTooltipCoord: { x: ne.chartX, y: ne.chartY },
          activeTooltipPayload: _this.getTooltipContent(itemProps)
        });
      }
    }, _this.handleMouseLeave = function () {
      var children = _this.props.children;

      var tooltipItem = findChildByType(children, Tooltip);

      if (tooltipItem) {
        _this.setState({
          isTooltipActive: false
        });
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  RadarChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data) {
      this.setState(this.createDefaultState());
    }
  };

  RadarChart.prototype.getTooltipContent = function getTooltipContent(itemProps) {
    var points = itemProps.points,
        dataKey = itemProps.dataKey,
        unit = itemProps.unit;


    return points.map(function (entry) {
      var name = entry.name,
          value = entry.value,
          payload = entry.payload;


      return _extends({}, getPresentationAttributes(itemProps), {
        dataKey: dataKey, unit: unit, name: name, value: value, payload: payload
      });
    });
  };

  RadarChart.prototype.getRadiusAxisCfg = function getRadiusAxisCfg(radiusAxis, innerRadius, outerRadius) {
    var props = radiusAxis ? radiusAxis.props : PolarRadiusAxis.defaultProps;
    var domain = void 0,
        tickCount = void 0,
        ticks = void 0;

    if (radiusAxis && radiusAxis.props.ticks) {
      ticks = radiusAxis.props.ticks;

      tickCount = ticks.length;
      domain = [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
    } else {
      tickCount = Math.max(radiusAxis && radiusAxis.props.tickCount || PolarRadiusAxis.defaultProps.tickCount, 2);
      ticks = this.getTicksByItems(radiusAxis, tickCount);

      domain = [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
    }

    return {
      tickCount: tickCount,
      ticks: ticks,
      scale: parseScale(props).domain(domain).range([innerRadius, outerRadius])
    };
  };

  RadarChart.prototype.getTicksByItems = function getTicksByItems(axisItem, tickCount) {
    var _props = this.props,
        data = _props.data,
        children = _props.children;

    var _ref = axisItem ? axisItem.props : PolarRadiusAxis.defaultProps,
        domain = _ref.domain,
        allowDataOverflow = _ref.allowDataOverflow;

    var radarItems = findAllByType(children, Radar);
    var dataKeys = radarItems.map(function (item) {
      return item.props.dataKey;
    });
    var extent = data.reduce(function (prev, current) {
      var values = dataKeys.map(function (v) {
        return getValueByDataKey(current, v, 0);
      });
      var currentMax = Math.max.apply(null, values);
      var currentMin = Math.min.apply(null, values);

      return [Math.min(prev[0], currentMin), Math.max(prev[1], currentMax)];
    }, [Infinity, -Infinity]);
    var finalDomain = parseSpecifiedDomain(domain, extent, allowDataOverflow);

    if (domain && (domain[0] === 'auto' || domain[1] === 'auto')) {
      return getNiceTickValues(finalDomain, tickCount);
    }

    return finalDomain;
  };

  RadarChart.prototype.getGridRadius = function getGridRadius(gridCount, innerRadius, outerRadius) {
    var domain = ___default.range(0, gridCount);
    var scale = d3Scales.scalePoint().domain(domain).range([innerRadius, outerRadius]);

    return domain.map(function (v) {
      return scale(v);
    });
  };

  RadarChart.prototype.getAngle = function getAngle(index, dataLength, startAngle, clockWise) {
    var sign = clockWise ? -1 : 1;
    var angleInterval = 360 / dataLength;

    return startAngle + index * sign * angleInterval;
  };

  RadarChart.prototype.getAngleTicks = function getAngleTicks(dataLength, startAngle, clockWise) {
    var angles = [];

    for (var i = 0; i < dataLength; i++) {
      angles.push(this.getAngle(i, dataLength, startAngle, clockWise));
    }

    return angles;
  };

  RadarChart.prototype.getRadiusTicks = function getRadiusTicks(axisCfg) {
    var ticks = axisCfg.ticks,
        scale = axisCfg.scale;


    if (ticks && ticks.length) {
      return ticks.map(function (entry) {
        return {
          radius: scale(entry),
          value: entry
        };
      });
    }
    var tickCount = axisCfg.tickCount;

    var domain = scale.domain();

    return ___default.range(0, tickCount).map(function (v, i) {
      var value = domain[0] + i * (domain[1] - domain[0]) / (tickCount - 1);
      return {
        value: value,
        radius: scale(value)
      };
    });
  };

  RadarChart.prototype.getComposedData = function getComposedData(item, scale, cx, cy) {
    var _this2 = this;

    var dataKey = item.props.dataKey;
    var _props2 = this.props,
        data = _props2.data,
        startAngle = _props2.startAngle,
        clockWise = _props2.clockWise,
        children = _props2.children;

    var angleAxis = findChildByType(children, PolarAngleAxis);
    var nameKey = angleAxis && angleAxis.props.dataKey;
    var len = data.length;

    return data.map(function (entry, i) {
      var value = getValueByDataKey(entry, dataKey, 0);
      var angle = _this2.getAngle(i, len, startAngle, clockWise);
      var radius = scale(value);

      return _extends({}, polarToCartesian(cx, cy, radius, angle), {
        value: value,
        name: nameKey ? entry[nameKey] || i : i,
        cx: cx, cy: cy, radius: radius, angle: angle,
        payload: entry
      });
    });
  };
  /**
   * Returns default, reset state for the radar chart.
   * @return {Object} Whole new state
   */


  RadarChart.prototype.createDefaultState = function createDefaultState() {
    return {
      activeTooltipLabel: '',
      activeTooltipCoord: { x: 0, y: 0 },
      isTooltipActive: false
    };
  };

  RadarChart.prototype.renderRadars = function renderRadars(items, scale, cx, cy) {
    var _this3 = this;

    if (!items || !items.length) {
      return null;
    }

    var _props3 = this.props,
        onMouseEnter = _props3.onMouseEnter,
        onMouseLeave = _props3.onMouseLeave,
        onClick = _props3.onClick;

    var baseProps = getPresentationAttributes(this.props);

    return items.map(function (el, index) {
      return React__default.cloneElement(el, _extends({}, baseProps, getPresentationAttributes(el), {
        animationId: _this3.props.animationId,
        points: _this3.getComposedData(el, scale, cx, cy),
        key: 'radar-' + index,
        onMouseEnter: combineEventHandlers(_this3.handleMouseEnter, onMouseEnter, el.props.onMouseEnter),
        onMouseLeave: combineEventHandlers(_this3.handleMouseLeave, onMouseLeave, el.props.onMouseLeave),
        onClick: combineEventHandlers(null, onClick, el.props.onClick)
      }));
    });
  };

  RadarChart.prototype.renderGrid = function renderGrid(radiusAxisCfg, cx, cy, innerRadius, outerRadius) {
    var children = this.props.children;

    var grid = findChildByType(children, PolarGrid);

    if (!grid) {
      return null;
    }

    var _props4 = this.props,
        startAngle = _props4.startAngle,
        clockWise = _props4.clockWise,
        data = _props4.data;

    var len = data.length;
    var gridCount = radiusAxisCfg.tickCount;

    return React__default.cloneElement(grid, {
      polarAngles: this.getAngleTicks(len, startAngle, clockWise),
      polarRadius: this.getGridRadius(gridCount, innerRadius, outerRadius),
      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
      key: 'layer-grid'
    });
  };

  RadarChart.prototype.renderAngleAxis = function renderAngleAxis(cx, cy, outerRadius, maxRadius) {
    var _this4 = this;

    var children = this.props.children;

    var angleAxis = findChildByType(children, PolarAngleAxis);

    if (!angleAxis || angleAxis.props.hide) {
      return null;
    }

    var _props5 = this.props,
        data = _props5.data,
        startAngle = _props5.startAngle,
        clockWise = _props5.clockWise;

    var len = data.length;
    var grid = findChildByType(children, PolarGrid);
    var radius = getPercentValue(angleAxis.props.radius, maxRadius, outerRadius);
    var dataKey = angleAxis.props.dataKey;


    return React__default.cloneElement(angleAxis, {
      ticks: data.map(function (v, i) {
        return {
          value: getValueByDataKey(v, dataKey, i),
          angle: _this4.getAngle(i, len, startAngle, clockWise)
        };
      }),
      cx: cx, cy: cy, radius: radius,
      axisLineType: grid && grid.props && grid.props.gridType || PolarGrid.defaultProps.gridType,
      key: 'layer-angle-axis'
    });
  };

  RadarChart.prototype.renderRadiusAxis = function renderRadiusAxis(radiusAxis, radiusAxisCfg, cx, cy) {
    if (!radiusAxis || radiusAxis.props.hide) {
      return null;
    }

    var startAngle = this.props.startAngle;

    return React__default.cloneElement(radiusAxis, {
      angle: radiusAxis.props.angle || startAngle,
      ticks: this.getRadiusTicks(radiusAxisCfg),
      cx: cx, cy: cy
    });
  };

  RadarChart.prototype.renderTooltip = function renderTooltip() {
    var children = this.props.children;

    var tooltipItem = findChildByType(children, Tooltip);

    if (!tooltipItem) {
      return null;
    }

    var _props6 = this.props,
        width = _props6.width,
        height = _props6.height;
    var _state = this.state,
        isTooltipActive = _state.isTooltipActive,
        activeTooltipLabel = _state.activeTooltipLabel,
        activeTooltipCoord = _state.activeTooltipCoord,
        activeTooltipPayload = _state.activeTooltipPayload;

    var viewBox = { x: 0, y: 0, width: width, height: height };

    return React__default.cloneElement(tooltipItem, {
      viewBox: viewBox,
      active: isTooltipActive,
      label: activeTooltipLabel,
      payload: activeTooltipPayload,
      coordinate: activeTooltipCoord
    });
  };

  /**
   * Draw legend
   * @param  {Array} items             The instances of item
   * @return {ReactElement}            The instance of Legend
   */


  RadarChart.prototype.renderLegend = function renderLegend(items) {
    var children = this.props.children;

    var legendItem = findChildByType(children, Legend);
    if (!legendItem) {
      return null;
    }

    var _props7 = this.props,
        width = _props7.width,
        height = _props7.height,
        margin = _props7.margin;

    var legendData = legendItem.props && legendItem.props.payload || items.map(function (child) {
      var _child$props = child.props,
          dataKey = _child$props.dataKey,
          name = _child$props.name,
          legendType = _child$props.legendType;


      return {
        dataKey: dataKey,
        type: legendItem.props.iconType || legendType || 'square',
        color: child.props.stroke || child.props.fill,
        value: name || dataKey,
        payload: child.props
      };
    }, this);

    return React__default.cloneElement(legendItem, _extends({}, Legend.getWithHeight(legendItem, width), {
      payload: legendData,
      chartWidth: width,
      chartHeight: height,
      margin: margin
    }));
  };

  RadarChart.prototype.render = function render() {
    var _this5 = this;

    if (!validateWidthHeight(this)) {
      return null;
    }
    var _props8 = this.props,
        className = _props8.className,
        data = _props8.data,
        width = _props8.width,
        height = _props8.height,
        margin = _props8.margin,
        children = _props8.children,
        style = _props8.style,
        others = objectWithoutProperties(_props8, ['className', 'data', 'width', 'height', 'margin', 'children', 'style']);

    var cx = getPercentValue(this.props.cx, width, width / 2);
    var cy = getPercentValue(this.props.cy, height, height / 2);
    var maxRadius = getMaxRadius(width, height, margin);
    var innerRadius = getPercentValue(this.props.innerRadius, maxRadius, 0);
    var outerRadius = getPercentValue(this.props.outerRadius, maxRadius, maxRadius * 0.8);

    if (outerRadius <= 0 || !data || !data.length) {
      return null;
    }

    var items = findAllByType(children, Radar);
    var radiusAxis = findChildByType(children, PolarRadiusAxis);
    var radiusAxisCfg = this.getRadiusAxisCfg(radiusAxis, innerRadius, outerRadius);
    var attrs = getPresentationAttributes(others);

    return React__default.createElement(
      'div',
      {
        className: classNames('recharts-wrapper', className),
        style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height }),
        ref: function ref(node) {
          _this5.container = node;
        }
      },
      React__default.createElement(
        Surface,
        _extends({}, attrs, { width: width, height: height }),
        this.renderGrid(radiusAxisCfg, cx, cy, innerRadius, outerRadius),
        this.renderRadiusAxis(radiusAxis, radiusAxisCfg, cx, cy),
        this.renderAngleAxis(cx, cy, outerRadius, maxRadius),
        this.renderRadars(items, radiusAxisCfg.scale, cx, cy),
        filterSvgElements(children)
      ),
      this.renderLegend(items),
      this.renderTooltip()
    );
  };

  return RadarChart;
}(React.Component)) || _class$35) || _class$35;

RadarChart.displayName = 'RadarChart';
RadarChart.defaultProps = {
  width: 0,
  height: 0,
  cx: '50%',
  cy: '50%',
  innerRadius: 0,
  outerRadius: '80%',

  startAngle: 90,
  clockWise: true,
  data: [],
  margin: { top: 0, right: 0, bottom: 0, left: 0 }
};

var _class$36;

/**
 * @fileOverview Scatter Chart
 */
var ScatterChart = pureRenderDecorator$1(_class$36 = function (_Component) {
  inherits(ScatterChart, _Component);

  function ScatterChart() {
    var _temp, _this, _ret;

    classCallCheck(this, ScatterChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      activeTooltipCoord: { x: 0, y: 0 },
      isTooltipActive: false,
      activeItem: null
    }, _this.handleLegendBBoxUpdate = function (box) {
      if (box && _this.legendInstance) {
        _this.forceUpdate();
      }
    }, _this.handleScatterMouseEnter = function (el) {
      _this.setState({
        isTooltipActive: true,
        activeItem: el,
        activeTooltipCoord: { x: el.cx, y: el.cy }
      });
    }, _this.handleScatterMouseLeave = function () {
      _this.setState({
        isTooltipActive: false
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  /**
   * Compose the data of each group
   * @param  {Object} item        An instance of Scatter
   * @param  {Array}  data        The original data
   * @param  {Object} xAxis       The configuration of x-axis
   * @param  {Object} yAxis       The configuration of y-axis
   * @param  {Object} zAxis       The configuration of z-axis
   * @return {Array} Composed data
   */
  ScatterChart.prototype.getComposedData = function getComposedData(item, data, xAxis, yAxis, zAxis) {
    var children = item.props.children;

    var xAxisDataKey = xAxis.dataKey;
    var yAxisDataKey = yAxis.dataKey;
    var zAxisDataKey = zAxis.dataKey;
    var cells = findAllByType(children, Cell);

    return data.map(function (entry, index) {
      return _extends({}, entry, {
        cx: isNumber(entry[xAxisDataKey]) ? xAxis.scale(entry[xAxisDataKey]) : null,
        cy: isNumber(entry[yAxisDataKey]) ? yAxis.scale(entry[yAxisDataKey]) : null,
        size: zAxisDataKey !== undefined && isNumber(entry[zAxisDataKey]) ? zAxis.scale(entry[zAxisDataKey]) : zAxis.range[0],
        node: {
          x: entry[xAxisDataKey],
          y: entry[yAxisDataKey],
          z: zAxisDataKey !== undefined && entry[zAxisDataKey] || '-'
        },
        payload: entry
      }, cells && cells[index] && cells[index].props);
    });
  };

  ScatterChart.prototype.getDomain = function getDomain(items, dataKey, axisId, axisType) {
    var domain = items.reduce(function (result, item) {
      return result.concat(item.props.data.map(function (entry) {
        return getValueByDataKey(entry, dataKey);
      }));
    }, []);

    if (axisType === 'xAxis' || axisType === 'yAxis') {
      domain = detectReferenceElementsDomain(this.props.children, domain, axisId, axisType);
    }

    return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
  };

  /**
   * Get the configuration of x-axis or y-axis
   * @param  {String} axisType The type of axis
   * @param  {Array} items     The instances of item
   * @return {Object}          Configuration
   */


  ScatterChart.prototype.getAxis = function getAxis() {
    var axisType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'xAxis';
    var items = arguments[1];
    var children = this.props.children;

    var Axis = axisType === 'xAxis' ? XAxis : YAxis;
    var axis = findChildByType(children, Axis);

    warn$1(axis, 'recharts: ScatterChart must has %s', Axis.displayName);

    if (axis) {
      var domain = parseSpecifiedDomain(axis.props.domain, this.getDomain(items, axis.props.dataKey, axis.props[axisType + 'Id'], axisType), axis.props.allowDataOverflow);

      return _extends({}, axis.props, {
        axisType: axisType,
        domain: domain,
        type: 'number',
        originalDomain: axis.props.domain
      });
    }

    return null;
  };

  /**
   * Get the configuration of z-axis
   * @param  {Array} items The instances of item
   * @return {Object}      Configuration
   */


  ScatterChart.prototype.getZAxis = function getZAxis(items) {
    var children = this.props.children;

    var axisItem = findChildByType(children, ZAxis);
    var axisProps = axisItem && axisItem.props || ZAxis.defaultProps;
    var domain = axisProps.dataKey ? this.getDomain(items, axisProps.dataKey) : [-1, 1];

    return _extends({}, axisProps, {
      domain: domain,
      scale: parseScale(axisProps).domain(domain).range(axisProps.range)
    });
  };

  ScatterChart.prototype.getOffset = function getOffset(items, xAxis, yAxis) {
    var _props = this.props,
        width = _props.width,
        height = _props.height,
        margin = _props.margin,
        children = _props.children;

    var legendItem = findChildByType(children, Legend);

    var offset = {
      left: margin.left || 0, right: margin.right || 0,
      top: margin.top || 0, bottom: margin.bottom || 0
    };

    if (!xAxis.hide && !xAxis.mirror) {
      offset[xAxis.orientation] += xAxis.height;
    }
    if (!yAxis.hide && !yAxis.mirror) {
      offset[yAxis.orientation] += yAxis.width;
    }

    if (legendItem && this.legendInstance) {
      var legendBox = this.legendInstance.getBBox();
      offset = appendOffsetOfLegend(offset, items, this.props, legendBox);
    }

    return _extends({}, offset, {
      width: width - offset.left - offset.right,
      height: height - offset.top - offset.bottom
    });
  };
  /**
   * Calculate the scale function, position, width, height of axes
   * @param  {Object} axis     The configuration of axis
   * @param  {Object} offset   The offset of main part in the svg element
   * @param  {Object} axisType The type of axis, x-axis or y-axis
   * @return {Object} Configuration
   */


  ScatterChart.prototype.getFormatAxis = function getFormatAxis(axis, offset, axisType) {
    var orientation = axis.orientation,
        domain = axis.domain,
        mirror = axis.mirror,
        tickFormat = axis.tickFormat,
        _axis$padding = axis.padding,
        padding = _axis$padding === undefined ? {} : _axis$padding;

    var position = {
      left: offset.left,
      right: offset.left + offset.width,
      top: offset.top,
      bottom: offset.top + offset.height
    };
    var range = axisType === 'xAxis' ? [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)] : [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)];

    var scale = parseScale(axis).domain(domain).range(range);
    var ticks = getTicksOfScale(scale, axis);
    if (tickFormat) {
      scale.tickFormat(tickFormat);
    }

    var x = void 0,
        y = void 0;

    if (axisType === 'xAxis') {
      var needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
      x = offset.left;
      y = position[orientation] - needSpace * axis.height;
    } else {
      var _needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
      x = position[orientation] - _needSpace * axis.width;
      y = offset.top;
    }

    return _extends({}, axis, ticks, {
      scale: scale,
      width: axisType === 'xAxis' ? offset.width : axis.width,
      height: axisType === 'yAxis' ? offset.height : axis.height,
      x: x, y: y
    });
  };

  /**
   * Get the content to be displayed in the tooltip
   * @param  {Object} data  The data of active item
   * @param  {Object} xAxis The configuration of x-axis
   * @param  {Object} yAxis The configuration of y-axis
   * @param  {Object} zAxis The configuration of z-axis
   * @return {Array}        The content of tooltip
   */


  ScatterChart.prototype.getTooltipContent = function getTooltipContent(data, xAxis, yAxis, zAxis) {
    if (!data) {
      return null;
    }

    var payload = data.payload,
        node = data.node;


    var content = [{
      name: xAxis.name || xAxis.dataKey,
      unit: xAxis.unit || '',
      value: node.x,
      payload: payload
    }, {
      name: yAxis.name || yAxis.dataKey,
      unit: yAxis.unit || '',
      value: node.y,
      payload: payload
    }];

    if (node.z && node.z !== '-') {
      content.push({
        name: zAxis.name || zAxis.dataKey,
        unit: zAxis.unit || '',
        value: node.z,
        payload: payload
      });
    }

    return content;
  };
  /**
   * The handler of mouse entering a scatter
   * @param {Object} el The active scatter
   * @param {Object} e  Event object
   * @return {Object} no return
   */


  /**
   * The handler of mouse leaving a scatter
   * @return {Object} no return
   */


  /**
   * Draw Tooltip
   * @param  {Array} items   The instances of Scatter
   * @param  {Object} xAxis  The configuration of x-axis
   * @param  {Object} yAxis  The configuration of y-axis
   * @param  {Object} zAxis  The configuration of z-axis
   * @param  {Object} offset The offset of main part in the svg element
   * @return {ReactElement}  The instance of Tooltip
   */
  ScatterChart.prototype.renderTooltip = function renderTooltip(items, xAxis, yAxis, zAxis, offset) {
    var children = this.props.children;

    var tooltipItem = findChildByType(children, Tooltip);

    if (!tooltipItem) {
      return null;
    }

    var _state = this.state,
        isTooltipActive = _state.isTooltipActive,
        activeItem = _state.activeItem,
        activeTooltipCoord = _state.activeTooltipCoord;

    var viewBox = {
      x: offset.left,
      y: offset.top,
      width: offset.width,
      height: offset.height
    };

    return React__default.cloneElement(tooltipItem, {
      viewBox: viewBox,
      active: isTooltipActive,
      label: '',
      payload: this.getTooltipContent(activeItem, xAxis, yAxis, zAxis),
      coordinate: activeTooltipCoord
    });
  };

  /**
   * Draw grid
   * @param  {Object} xAxis  The configuration of x-axis
   * @param  {Object} yAxis  The configuration of y-axis
   * @param  {Object} offset The offset of main part in the svg element
   * @return {ReactElement} The instance of grid
   */


  ScatterChart.prototype.renderGrid = function renderGrid(xAxis, yAxis, offset) {
    var _props2 = this.props,
        children = _props2.children,
        width = _props2.width,
        height = _props2.height;

    var gridItem = findChildByType(children, CartesianGrid);

    if (!gridItem) {
      return null;
    }

    var verticalPoints = getCoordinatesOfGrid(CartesianAxis.getTicks(_extends({}, CartesianAxis.defaultProps, xAxis, {
      ticks: getTicksOfAxis(xAxis, true),
      viewBox: { x: 0, y: 0, width: width, height: height }
    })), offset.left, offset.left + offset.width);

    var horizontalPoints = getCoordinatesOfGrid(CartesianAxis.getTicks(_extends({}, CartesianAxis.defaultProps, yAxis, {
      ticks: getTicksOfAxis(yAxis, true),
      viewBox: { x: 0, y: 0, width: width, height: height }
    })), offset.top, offset.top + offset.height);

    return React__default.cloneElement(gridItem, {
      key: 'grid',
      x: offset.left,
      y: offset.top,
      width: offset.width,
      height: offset.height,
      verticalPoints: verticalPoints,
      horizontalPoints: horizontalPoints
    });
  };
  /**
   * Draw legend
   * @param  {Array} items     The instances of Scatters
   * @return {ReactElement}    The instance of Legend
   */


  ScatterChart.prototype.renderLegend = function renderLegend(items) {
    var _this2 = this;

    var _props3 = this.props,
        children = _props3.children,
        width = _props3.width,
        height = _props3.height,
        margin = _props3.margin;

    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
    var props = getLegendProps(children, items, legendWidth, legendHeight);

    if (!props) {
      return null;
    }

    return React__default.createElement(Legend, _extends({}, props, {
      chartWidth: width,
      chartHeight: height,
      margin: margin,
      ref: function ref(legend) {
        _this2.legendInstance = legend;
      },
      onBBoxUpdate: this.handleLegendBBoxUpdate
    }));
  };

  /**
   * Draw axis
   * @param {Object} axis     The configuration of axis
   * @param {String} layerKey The key of layer
   * @return {ReactElement}   The instance of axis
   */


  ScatterChart.prototype.renderAxis = function renderAxis(axis, layerKey) {
    var _props4 = this.props,
        width = _props4.width,
        height = _props4.height;


    if (axis && !axis.hide) {
      return React__default.createElement(
        Layer,
        { key: layerKey, className: layerKey },
        React__default.createElement(CartesianAxis, _extends({}, axis, {
          viewBox: { x: 0, y: 0, width: width, height: height },
          ticks: getTicksOfAxis(axis, true)
        }))
      );
    }

    return null;
  };

  ScatterChart.prototype.renderCursor = function renderCursor(xAxis, yAxis, offset) {
    var children = this.props.children;

    var tooltipItem = findChildByType(children, Tooltip);

    if (!tooltipItem || !tooltipItem.props.cursor || !this.state.isTooltipActive) {
      return null;
    }
    var activeItem = this.state.activeItem;


    var cursorProps = _extends({
      stroke: '#ccc',
      strokeDasharray: '5 5'
    }, getPresentationAttributes(tooltipItem.props.cursor), offset, {
      x: activeItem.cx,
      y: activeItem.cy,
      payload: activeItem
    });

    return React__default.isValidElement(tooltipItem.props.cursor) ? React__default.cloneElement(tooltipItem.props.cursor, cursorProps) : React__default.createElement(Cross, cursorProps);
  };

  /**
   * Draw the main part of scatter chart
   * @param  {Array} items   All the instance of Scatter
   * @param  {Object} xAxis  The configuration of all x-axis
   * @param  {Object} yAxis  The configuration of all y-axis
   * @param  {Object} zAxis  The configuration of all z-axis
   * @param  {Object} offset The offset of main part in the svg element
   * @return {ReactComponent}  All the instances of Scatter
   */


  ScatterChart.prototype.renderItems = function renderItems(items, xAxis, yAxis, zAxis, offset) {
    var _this3 = this;

    var activeGroupId = this.state.activeGroupId;

    return items.map(function (child, i) {
      var _child$props = child.props,
          strokeWidth = _child$props.strokeWidth,
          data = _child$props.data;


      var finalStrokeWidth = strokeWidth === +strokeWidth ? strokeWidth : 1;
      finalStrokeWidth = activeGroupId === 'scatter-' + i ? finalStrokeWidth + 2 : finalStrokeWidth;

      return React__default.cloneElement(child, _extends({
        key: 'scatter-' + i,
        groupId: 'scatter-' + i,
        strokeWidth: finalStrokeWidth,
        onMouseLeave: _this3.handleScatterMouseLeave,
        onMouseEnter: _this3.handleScatterMouseEnter,
        points: _this3.getComposedData(child, data, xAxis, yAxis, zAxis)
      }, offset, {
        xAxis: xAxis,
        yAxis: yAxis
      }));
    }, this);
  };

  ScatterChart.prototype.renderReferenceElements = function renderReferenceElements(xAxis, yAxis, offset, isFront, Compt) {
    var children = this.props.children;

    var elements = findAllByType(children, Compt);

    if (!elements || !elements.length) {
      return null;
    }

    var keyPrefix = getDisplayName(Compt) + '-' + (isFront ? 'front' : 'back');

    return elements.filter(function (entry) {
      return isFront === entry.props.isFront;
    }).map(function (entry, i) {
      return React__default.cloneElement(entry, {
        key: keyPrefix + '-' + i,
        xAxis: xAxis, yAxis: yAxis,
        viewBox: {
          x: offset.left,
          y: offset.top,
          width: offset.width,
          height: offset.height
        }
      });
    });
  };

  ScatterChart.prototype.render = function render() {
    if (!validateWidthHeight(this)) {
      return null;
    }

    // eslint-disable-next-line no-unused-vars
    var _props5 = this.props,
        style = _props5.style,
        children = _props5.children,
        className = _props5.className,
        width = _props5.width,
        height = _props5.height,
        others = objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height']);

    var items = findAllByType(children, Scatter);
    var zAxis = this.getZAxis(items);
    var xAxis = this.getAxis('xAxis', items);
    var yAxis = this.getAxis('yAxis', items);

    var offset = this.getOffset(items, xAxis, yAxis);
    xAxis = this.getFormatAxis(xAxis, offset, 'xAxis');
    yAxis = this.getFormatAxis(yAxis, offset, 'yAxis');
    var events = filterEventAttributes(this.props);
    var attrs = getPresentationAttributes(others);

    return React__default.createElement(
      'div',
      _extends({
        className: classNames('recharts-wrapper', className),
        style: { position: 'relative', cursor: 'default', width: width, height: height }
      }, events),
      React__default.createElement(
        Surface,
        _extends({}, attrs, { width: width, height: height }),
        this.renderGrid(xAxis, yAxis, offset),
        this.renderReferenceElements(xAxis, yAxis, offset, false, ReferenceArea),
        this.renderReferenceElements(xAxis, yAxis, offset, false, ReferenceLine),
        this.renderReferenceElements(xAxis, yAxis, offset, false, ReferenceDot),
        this.renderAxis(xAxis, 'recharts-x-axis'),
        this.renderAxis(yAxis, 'recharts-y-axis'),
        this.renderCursor(xAxis, yAxis, offset),
        this.renderItems(items, xAxis, yAxis, zAxis, offset),
        this.renderReferenceElements(xAxis, yAxis, offset, true, ReferenceArea),
        this.renderReferenceElements(xAxis, yAxis, offset, true, ReferenceLine),
        this.renderReferenceElements(xAxis, yAxis, offset, true, ReferenceDot),
        filterSvgElements(children)
      ),
      this.renderLegend(items),
      this.renderTooltip(items, xAxis, yAxis, zAxis, offset)
    );
  };

  return ScatterChart;
}(React.Component)) || _class$36;

ScatterChart.displayName = 'ScatterChart';
ScatterChart.defaultProps = {
  style: {},
  margin: { top: 5, right: 5, bottom: 5, left: 5 }
};

var _dec$3;
var _class$37;

/**
 * @fileOverview Area Chart
 */
var getCategoryAxisCoordinate$2 = function getCategoryAxisCoordinate(_ref) {
  var axis = _ref.axis,
      ticks = _ref.ticks,
      bandSize = _ref.bandSize,
      entry = _ref.entry,
      index = _ref.index;

  if (axis.type === 'category') {
    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
  }

  var value = getValueByDataKey(entry, axis.dataKey);

  return !___default.isNil(value) ? axis.scale(value) : null;
};

var getBaseValue$1 = function getBaseValue(props, xAxis, yAxis) {
  var layout = props.layout,
      baseValue = props.baseValue;


  if (isNumber(baseValue)) {
    return baseValue;
  }

  var numberAxis = layout === 'horizontal' ? yAxis : xAxis;
  var domain = numberAxis.scale.domain();

  if (numberAxis.type === 'number') {
    var max = Math.max(domain[0], domain[1]);
    var min = Math.min(domain[0], domain[1]);

    if (baseValue === 'dataMin') {
      return min;
    }
    if (baseValue === 'dataMax') {
      return max;
    }

    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
  }

  if (baseValue === 'dataMin') {
    return domain[0];
  }
  if (baseValue === 'dataMax') {
    return domain[1];
  }

  return domain[0];
};

/**
 * Compose the data of each area
 * @param {Object} props The props that are passed to the component
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {String} dataKey     The unique key of a group
 * @param {Array} stackedData If the area is stacked,
 * the stackedData is an array of min value and max value
 * @return {Array} Composed data
 */
var getComposedData$3 = function getComposedData(_ref2) {
  var props = _ref2.props,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      xTicks = _ref2.xTicks,
      yTicks = _ref2.yTicks,
      bandSize = _ref2.bandSize,
      dataKey = _ref2.dataKey,
      stackedData = _ref2.stackedData;
  var layout = props.layout,
      dataStartIndex = props.dataStartIndex,
      dataEndIndex = props.dataEndIndex;

  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
  var hasStack = stackedData && stackedData.length;
  var baseValue = getBaseValue$1(props, xAxis, yAxis);
  var isRange = false;

  var points = data.map(function (entry, index) {
    var value = void 0;

    if (hasStack) {
      value = stackedData[dataStartIndex + index];
    } else {
      value = getValueByDataKey(entry, dataKey);

      if (!___default.isArray(value)) {
        value = [baseValue, value];
      } else {
        isRange = true;
      }
    }

    if (layout === 'horizontal') {
      return {
        x: getCategoryAxisCoordinate$2({ axis: xAxis, ticks: xTicks, bandSize: bandSize, entry: entry, index: index }),
        y: ___default.isNil(value[1]) ? null : yAxis.scale(value[1]),
        value: value,
        payload: entry
      };
    }

    return {
      x: ___default.isNil(value[1]) ? null : xAxis.scale(value[1]),
      y: getCategoryAxisCoordinate$2({ axis: yAxis, ticks: yTicks, bandSize: bandSize, entry: entry, index: index }),
      value: value,
      payload: entry
    };
  });

  var baseLine = void 0;
  if (hasStack || isRange) {
    baseLine = points.map(function (entry) {
      return {
        x: layout === 'horizontal' ? entry.x : xAxis.scale(entry && entry.value[0]),
        y: layout === 'horizontal' ? yAxis.scale(entry && entry.value[0]) : entry.y
      };
    });
  } else if (layout === 'horizontal') {
    baseLine = yAxis.scale(baseValue);
  } else {
    baseLine = xAxis.scale(baseValue);
  }

  return { points: points, baseLine: baseLine, layout: layout, isRange: isRange };
};

var AreaChart = (_dec$3 = composedDataDecorator({ getComposedData: getComposedData$3 }), AnimationDecorator(_class$37 = _dec$3(_class$37 = function (_Component) {
  inherits(AreaChart, _Component);

  function AreaChart() {
    classCallCheck(this, AreaChart);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AreaChart.prototype.renderCursor = function renderCursor(_ref3) {
    var offset = _ref3.offset;
    var _props = this.props,
        children = _props.children,
        isTooltipActive = _props.isTooltipActive,
        layout = _props.layout,
        activeTooltipIndex = _props.activeTooltipIndex,
        axisTicks = _props.axisTicks;

    var tooltipItem = findChildByType(children, Tooltip);

    if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
      return null;
    }

    var ticks = axisTicks;

    if (!ticks || !ticks[activeTooltipIndex]) {
      return null;
    }

    var start = ticks[activeTooltipIndex].coordinate;
    var x1 = layout === 'horizontal' ? start : offset.left;
    var y1 = layout === 'horizontal' ? offset.top : start;
    var x2 = layout === 'horizontal' ? start : offset.left + offset.width;
    var y2 = layout === 'horizontal' ? offset.top + offset.height : start;
    var cursorProps = _extends({
      stroke: '#ccc'
    }, getPresentationAttributes(tooltipItem.props.cursor), {
      points: [{ x: x1, y: y1 }, { x: x2, y: y2 }]
    });

    return React__default.isValidElement(tooltipItem.props.cursor) ? React__default.cloneElement(tooltipItem.props.cursor, cursorProps) : React__default.createElement(Curve, _extends({}, cursorProps, { type: 'linear', className: 'recharts-tooltip-cursor' }));
  };

  AreaChart.prototype.renderActiveDot = function renderActiveDot(option, props, childIndex) {
    var dot = void 0;

    if (React__default.isValidElement(option)) {
      dot = React__default.cloneElement(option, props);
    } else if (___default.isFunction(option)) {
      dot = option(props);
    } else {
      dot = React__default.createElement(Dot, props);
    }

    return React__default.createElement(
      Animate,
      {
        from: 'scale(0)',
        to: 'scale(1)',
        duration: 400,
        key: 'dot-' + childIndex + '-' + props.pointType,
        attributeName: 'transform'
      },
      React__default.createElement(
        Layer,
        { style: { transformOrigin: 'center center' } },
        dot
      )
    );
  };

  /**
   * Draw the main part of area chart
   * @param  {Array} items     React elements of Area
   * @param  {Object} xAxisMap The configuration of all x-axis
   * @param  {Object} yAxisMap The configuration of all y-axis
   * @param  {Object} offset   The offset of main part in the svg element
   * @param  {Array} allComposedData The array of pre-created composedData
   *                                 {points, basedLine, layout} for each item
   * @return {ReactComponent} The instances of Area
   */


  AreaChart.prototype.renderItems = function renderItems(items, xAxisMap, yAxisMap, offset, allComposedData) {
    var _this2 = this;

    var _props2 = this.props,
        children = _props2.children,
        layout = _props2.layout,
        isTooltipActive = _props2.isTooltipActive,
        activeTooltipIndex = _props2.activeTooltipIndex;

    var tooltipItem = findChildByType(children, Tooltip);
    var hasDot = tooltipItem && isTooltipActive;
    var dotItems = [];
    var animationId = this.props.animationId;


    var areaItems = items.reduce(function (result, child, i) {
      var _child$props = child.props,
          dataKey = _child$props.dataKey,
          activeDot = _child$props.activeDot;

      var currentComposedData = allComposedData[i];
      var isRange = currentComposedData.isRange;

      var activePoint = currentComposedData.points && currentComposedData.points[activeTooltipIndex];
      var basePoint = isRange && currentComposedData.baseLine && currentComposedData.baseLine[activeTooltipIndex];

      if (hasDot && activeDot && activePoint) {
        var dotProps = _extends({
          index: activeTooltipIndex,
          dataKey: dataKey,
          animationId: animationId,
          cx: activePoint.x, cy: activePoint.y, r: 4,
          fill: getMainColorOfGraphicItem(child),
          strokeWidth: 2, stroke: '#fff',
          payload: activePoint.payload,
          value: activePoint.value,
          pointType: 'activePoint'
        }, getPresentationAttributes(activeDot));

        dotItems.push(_this2.renderActiveDot(activeDot, dotProps, i));

        if (basePoint) {
          dotItems.push(_this2.renderActiveDot(activeDot, _extends({}, dotProps, {
            cx: basePoint.x,
            cy: basePoint.y,
            pointType: 'basePoint'
          }), i));
        }
      }

      var area$$1 = React__default.cloneElement(child, _extends({
        key: 'area-' + i
      }, currentComposedData, offset, {
        animationId: animationId,
        layout: layout,
        xAxis: xAxisMap[child.props.xAxisId],
        yAxis: yAxisMap[child.props.yAxisId]
      }));

      return [].concat(result, [area$$1]);
    }, []);

    return React__default.createElement(
      Layer,
      { className: 'recharts-area-chart-group' },
      React__default.createElement(
        Layer,
        { className: 'recharts-area-chart-shapes' },
        areaItems
      ),
      React__default.createElement(
        Layer,
        { className: 'recharts-area-chart-dots' },
        dotItems
      )
    );
  };

  AreaChart.prototype.render = function render() {
    var _props3 = this.props,
        isComposed = _props3.isComposed,
        graphicalItems = _props3.graphicalItems,
        xAxisMap = _props3.xAxisMap,
        yAxisMap = _props3.yAxisMap,
        offset = _props3.offset,
        allComposedData = _props3.allComposedData;


    return React__default.createElement(
      Layer,
      { className: 'recharts-area-graphical' },
      !isComposed && this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
      this.renderItems(graphicalItems, xAxisMap, yAxisMap, offset, allComposedData)
    );
  };

  return AreaChart;
}(React.Component)) || _class$37) || _class$37);

AreaChart.displayName = 'AreaChart';
AreaChart.defaultProps = {
  baseValue: 'auto'
};
var AreaChart$1 = generateCategoricalChart(AreaChart, Area);

var _class$38;

/**
 * @fileOverview Radar Bar Chart
 */
var RadialBarChart = pureRenderDecorator$1(_class$38 = function (_Component) {
  inherits(RadialBarChart, _Component);

  function RadialBarChart() {
    var _temp, _this, _ret;

    classCallCheck(this, RadialBarChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _this.handleMouseEnter = function (el) {
      var children = _this.props.children;
      var cx = el.cx,
          cy = el.cy,
          endAngle = el.endAngle,
          outerRadius = el.outerRadius;

      var tooltipItem = findChildByType(children, Tooltip);

      if (tooltipItem) {
        _this.setState({
          isTooltipActive: true,
          activeTooltipCoord: polarToCartesian(cx, cy, outerRadius, endAngle),
          activeTooltipPayload: [el.payload]
        });
      }
    }, _this.handleMouseLeave = function () {
      var children = _this.props.children;

      var tooltipItem = findChildByType(children, Tooltip);

      if (tooltipItem) {
        _this.setState({
          isTooltipActive: false
        });
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  RadialBarChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data) {
      this.setState(this.createDefaultState());
    }
  };
  /**
   * Compose the data of each group
   * @param  {Object} item        An instance of RadialBar
   * @param  {Array}  barPosition The offset and size of each bar
   * @param  {Object} radiusScale The scale function of radius of bars
   * @param  {Object} center      The coordinate of center
   * @param  {String} dataKey     The unique key of a group
   * @return {Array}              Composed data
   */


  RadialBarChart.prototype.getComposedData = function getComposedData(item, barPosition, radiusScale, center, dataKey) {
    var data = this.props.data;

    var pos = findPositionOfBar(barPosition, item);
    var cells = findAllByType(item.props.children, Cell);

    return data.map(function (entry, index) {
      var value = getValueByDataKey(entry, dataKey);
      var radius = radiusScale(index);

      return _extends({}, entry, center, {
        value: value,
        innerRadius: radius - pos.offset,
        outerRadius: radius - pos.offset + pos.radius,
        payload: entry
      }, cells && cells[index] && cells[index].props);
    });
  };
  /**
   * Calculate the size of all groups
   * @param  {Array} items All the instance of RadialBar
   * @return {Object} The size of all groups
   */


  RadialBarChart.prototype.getRadiusList = function getRadiusList(items) {
    var barSize = this.props.barSize;


    return items.map(function (child) {
      return _extends({}, child.props, {
        item: child,
        barSize: child.props.barSize || barSize
      });
    });
  };

  /**
   * Calculate the scale function of radius
   * @param {Number} innerRadius The outer radius
   * @param {Number} outerRadius The inner radius
   * @return {Object}            A scale function
   */


  RadialBarChart.prototype.getRadiusScale = function getRadiusScale(innerRadius, outerRadius) {
    var data = this.props.data;

    var bandCount = Math.max(data.length, 1);
    var range = [outerRadius, innerRadius];
    var scale = d3Scales.scaleBand().domain(___default.range(0, bandCount)).range(range);

    return scale;
  };

  /**
   * Calculate the size of each bar and the gap between two bars
   * @param  {Number} bandRadius  The radius of each category
   * @param  {Array} radiusList   The radius of all groups
   * @return {Number} The size of each bar and the gap between two bars
   */


  RadialBarChart.prototype.getBarPosition = function getBarPosition(bandRadius, radiusList) {
    var _props = this.props,
        barGap = _props.barGap,
        barCategoryGap = _props.barCategoryGap;

    var len = radiusList.length;
    var result = void 0;

    // whether or not is barSize setted by user
    if (len && radiusList[0].barSize === +radiusList[0].barSize) {
      (function () {
        var sum = radiusList.reduce(function (res, entry) {
          return res + entry.barSize;
        }, 0);
        sum += (len - 1) * barGap;
        var offset = -sum / 2 >> 0;
        var prev = { offset: offset - barGap, radius: 0 };

        result = radiusList.reduce(function (res, entry) {
          prev = {
            offset: prev.offset + prev.radius + barGap,
            radius: entry.barSize
          };

          return [].concat(res, [{ item: entry.item, position: prev }]);
        }, []);
      })();
    } else {
      (function () {
        var offset = getPercentValue(barCategoryGap, bandRadius);
        var radius = (bandRadius - 2 * offset - (len - 1) * barGap) / len >> 0;
        offset = -Math.max((radius * len + (len - 1) * barGap) / 2 >> 0, 0);

        result = radiusList.reduce(function (res, entry, i) {
          return [].concat(res, [{
            item: entry.item,
            position: {
              offset: offset + (radius + barGap) * i,
              radius: radius
            }
          }]);
        }, []);
      })();
    }

    return result;
  };
  /**
   * Returns default, reset state for the radial bar chart.
   * @return {Object} Whole new state
   */


  RadialBarChart.prototype.createDefaultState = function createDefaultState() {
    return {
      activeTooltipLabel: '',
      activeTooltipPayload: [],
      activeTooltipCoord: { x: 0, y: 0 },
      isTooltipActive: false
    };
  };

  /**
   * Draw legend
   * @param  {ReactElement} legendItem The instance of Legend
   * @return {ReactElement}            The instance of Legend
   */
  RadialBarChart.prototype.renderLegend = function renderLegend() {
    var children = this.props.children;

    var legendItem = findChildByType(children, Legend);
    if (!legendItem) {
      return null;
    }

    var _props2 = this.props,
        data = _props2.data,
        width = _props2.width,
        height = _props2.height,
        margin = _props2.margin;


    var legendData = legendItem.props && legendItem.props.payload || data.map(function (entry) {
      return {
        type: legendItem.props.iconType || 'square',
        color: entry.fill || '#000',
        value: entry.name,
        payload: entry
      };
    });

    return React__default.cloneElement(legendItem, _extends({}, Legend.getWithHeight(legendItem, width), {
      payload: legendData,
      chartWidth: width,
      chartHeight: height,
      margin: margin
    }));
  };

  RadialBarChart.prototype.renderTooltip = function renderTooltip() {
    var children = this.props.children;

    var tooltipItem = findChildByType(children, Tooltip);

    if (!tooltipItem) {
      return null;
    }

    var _props3 = this.props,
        width = _props3.width,
        height = _props3.height;
    var _state = this.state,
        isTooltipActive = _state.isTooltipActive,
        activeTooltipLabel = _state.activeTooltipLabel,
        activeTooltipCoord = _state.activeTooltipCoord,
        activeTooltipPayload = _state.activeTooltipPayload;

    var viewBox = { x: 0, y: 0, width: width, height: height };

    return React__default.cloneElement(tooltipItem, {
      viewBox: viewBox,
      active: isTooltipActive,
      label: activeTooltipLabel,
      payload: activeTooltipPayload,
      coordinate: activeTooltipCoord
    });
  };

  /**
   * Draw the main part of bar chart
   * @param  {Array} items     All the instance of RadialBar
   * @param  {Object} radiusScale The scale function of radius of bars
   * @param  {Object} center      The coordinate of center
   * @return {ReactComponent}  All the instances of RadialBar
   */


  RadialBarChart.prototype.renderItems = function renderItems(items, radiusScale, center) {
    var _this2 = this;

    if (!items || !items.length) {
      return null;
    }

    var _props4 = this.props,
        onMouseEnter = _props4.onMouseEnter,
        onMouseLeave = _props4.onMouseLeave,
        onClick = _props4.onClick;

    var radiusList = this.getRadiusList(items);
    var bandRadius = radiusScale.bandwidth();
    var barPosition = this.getBarPosition(bandRadius, radiusList);

    return items.map(function (child, i) {
      var _child$props = child.props,
          dataKey = _child$props.dataKey,
          childOnMouseEnter = _child$props.onMouseEnter,
          childOnMouseLeave = _child$props.onMouseLeave,
          childOnClick = _child$props.onClick;


      return React__default.cloneElement(child, _extends({}, center, {
        key: 'radial-bar-' + i,
        onMouseEnter: combineEventHandlers(_this2.handleMouseEnter, onMouseEnter, childOnMouseEnter),
        onMouseLeave: combineEventHandlers(_this2.handleMouseLeave, onMouseLeave, childOnMouseLeave),
        onClick: combineEventHandlers(null, onClick, childOnClick),
        data: _this2.getComposedData(child, barPosition, radiusScale, center, dataKey)
      }));
    }, this);
  };

  RadialBarChart.prototype.render = function render() {
    var data = this.props.data;

    if (!validateWidthHeight(this) || !data || !data.length) {
      return null;
    }

    var _props5 = this.props,
        style = _props5.style,
        children = _props5.children,
        className = _props5.className,
        width = _props5.width,
        height = _props5.height,
        margin = _props5.margin,
        others = objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height', 'margin']);

    var items = findAllByType(children, RadialBar);
    var cx = getPercentValue(this.props.cx, width, width / 2);
    var cy = getPercentValue(this.props.cy, height, height / 2);
    var maxRadius = getMaxRadius(width, height, margin);
    var innerRadius = getPercentValue(this.props.innerRadius, maxRadius, 0);
    var outerRadius = getPercentValue(this.props.outerRadius, maxRadius, maxRadius * 0.8);
    var radiusScale = this.getRadiusScale(innerRadius, outerRadius);
    var attrs = getPresentationAttributes(others);

    return React__default.createElement(
      'div',
      {
        className: classNames('recharts-wrapper', className),
        style: _extends({}, style, { cursor: 'default', position: 'relative', width: width, height: height })
      },
      React__default.createElement(
        Surface,
        _extends({}, attrs, { width: width, height: height }),
        this.renderItems(items, radiusScale, { cx: cx, cy: cy }),
        filterSvgElements(children)
      ),
      this.renderLegend(),
      this.renderTooltip(items)
    );
  };

  return RadialBarChart;
}(React.Component)) || _class$38;

RadialBarChart.displayName = 'RadialBarChart';
RadialBarChart.defaultProps = {
  cx: '50%',
  cy: '50%',
  innerRadius: '30%',
  outerRadius: '90%',
  barGap: 2,
  barCategoryGap: '10%',
  style: {},
  margin: { top: 0, right: 0, bottom: 0, left: 0 }
};

var _dec$4;
var _class$39;

/**
 * @fileOverview Composed Chart
 */
var GRAPHICAL_TYPES = ['Area', 'Bar', 'Line'];
var GRAPHICAL_MAP = { Area: AreaChart, Bar: BarChart, Line: LineChart };

var ComposedChart = (_dec$4 = composedDataDecorator({}), pureRenderDecorator$1(_class$39 = _dec$4(_class$39 = function (_Component) {
  inherits(ComposedChart, _Component);

  function ComposedChart() {
    classCallCheck(this, ComposedChart);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ComposedChart.prototype.filterGraphicalItems = function filterGraphicalItems() {
    var graphicalItems = this.props.graphicalItems;

    var record = {};
    var result = [];

    for (var i = 0, len = graphicalItems.length; i < len; i++) {
      var item = graphicalItems[i];
      var displayName = item.type.displayName;

      if (GRAPHICAL_TYPES.indexOf(displayName) >= 0) {
        if (!___default.isNil(record[displayName])) {
          var index = record[displayName];

          result[index].items = [].concat(result[index].items, [item]);
        } else {
          record[displayName] = result.length;
          result.push({ items: [item], type: displayName });
        }
      }
    }

    return result;
  };

  ComposedChart.prototype.renderCursor = function renderCursor(_ref) {
    var xAxisMap = _ref.xAxisMap,
        yAxisMap = _ref.yAxisMap,
        offset = _ref.offset;
    var _props = this.props,
        children = _props.children,
        isTooltipActive = _props.isTooltipActive,
        layout = _props.layout,
        activeTooltipIndex = _props.activeTooltipIndex,
        axisTicks = _props.axisTicks;

    var tooltipItem = findChildByType(children, Tooltip);
    if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
      return null;
    }

    var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
    var axis = getAnyElementOfObject(axisMap);
    var ticks = axisTicks;

    if (!ticks || !ticks[activeTooltipIndex]) {
      return null;
    }

    var bandSize = getBandSizeOfAxis(axis);
    var start = ticks[activeTooltipIndex].coordinate;
    var cursorProps = _extends({
      fill: '#f1f1f1'
    }, getPresentationAttributes(tooltipItem.props.cursor), {
      x: layout === 'horizontal' ? start : offset.left + 0.5,
      y: layout === 'horizontal' ? offset.top + 0.5 : start,
      width: layout === 'horizontal' ? bandSize : offset.width - 1,
      height: layout === 'horizontal' ? offset.height - 1 : bandSize
    });

    return React__default.isValidElement(tooltipItem.props.cursor) ? React__default.cloneElement(tooltipItem.props.cursor, cursorProps) : React__default.createElement(Rectangle, cursorProps);
  };

  ComposedChart.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        xAxisMap = _props2.xAxisMap,
        yAxisMap = _props2.yAxisMap,
        offset = _props2.offset;

    var filteredItems = this.filterGraphicalItems();

    return React__default.createElement(
      Layer,
      { className: 'recharts-composed' },
      this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
      filteredItems.map(function (_ref2) {
        var items = _ref2.items,
            type = _ref2.type;

        var Chart = GRAPHICAL_MAP[type];

        return React__default.createElement(Chart, _extends({ key: type }, _this2.props, { graphicalItems: items, isComposed: true }));
      })
    );
  };

  return ComposedChart;
}(React.Component)) || _class$39) || _class$39);
ComposedChart.displayName = 'ComposedChart';


var ComposedChart$1 = generateCategoricalChart(ComposedChart, [Line, Area, Bar]);



var recharts$1 = Object.freeze({
	Surface: Surface,
	Layer: Layer,
	Legend: Legend,
	Tooltip: Tooltip,
	ResponsiveContainer: ResponsiveContainer,
	Cell: Cell,
	Text: Text,
	Sector: Sector,
	Curve: Curve,
	Rectangle: Rectangle,
	Polygon: Polygon,
	Dot: Dot,
	Cross: Cross,
	Symbols: Symbols,
	PolarGrid: PolarGrid,
	PolarRadiusAxis: PolarRadiusAxis,
	PolarAngleAxis: PolarAngleAxis,
	Pie: Pie,
	Radar: Radar,
	RadialBar: RadialBar,
	Brush: Brush,
	ReferenceLine: ReferenceLine,
	ReferenceDot: ReferenceDot,
	ReferenceArea: ReferenceArea,
	CartesianAxis: CartesianAxis,
	CartesianGrid: CartesianGrid,
	Line: Line,
	Area: Area,
	Bar: Bar,
	Scatter: Scatter,
	XAxis: XAxis,
	YAxis: YAxis,
	ZAxis: ZAxis,
	ErrorBar: ErrorBar,
	LineChart: LineChart$1,
	BarChart: BarChart$1,
	PieChart: PieChart,
	Treemap: Treemap,
	Sankey: Sankey,
	RadarChart: RadarChart,
	ScatterChart: ScatterChart,
	AreaChart: AreaChart$1,
	RadialBarChart: RadialBarChart,
	ComposedChart: ComposedChart$1
});



var lib$1 = Object.freeze({
	default: recharts$1,
	Surface: Surface,
	Layer: Layer,
	Legend: Legend,
	Tooltip: Tooltip,
	ResponsiveContainer: ResponsiveContainer,
	Cell: Cell,
	Text: Text,
	Sector: Sector,
	Curve: Curve,
	Rectangle: Rectangle,
	Polygon: Polygon,
	Dot: Dot,
	Cross: Cross,
	Symbols: Symbols,
	PolarGrid: PolarGrid,
	PolarRadiusAxis: PolarRadiusAxis,
	PolarAngleAxis: PolarAngleAxis,
	Pie: Pie,
	Radar: Radar,
	RadialBar: RadialBar,
	Brush: Brush,
	ReferenceLine: ReferenceLine,
	ReferenceDot: ReferenceDot,
	ReferenceArea: ReferenceArea,
	CartesianAxis: CartesianAxis,
	CartesianGrid: CartesianGrid,
	Line: Line,
	Area: Area,
	Bar: Bar,
	Scatter: Scatter,
	XAxis: XAxis,
	YAxis: YAxis,
	ZAxis: ZAxis,
	ErrorBar: ErrorBar,
	LineChart: LineChart$1,
	BarChart: BarChart$1,
	PieChart: PieChart,
	Treemap: Treemap,
	Sankey: Sankey,
	RadarChart: RadarChart,
	ScatterChart: ScatterChart,
	AreaChart: AreaChart$1,
	RadialBarChart: RadialBarChart,
	ComposedChart: ComposedChart$1
});

return lib$1;

})));
//# sourceMappingURL=precharts.js.map
